/* tslint:disable */
/* eslint-disable */
/**
 * Cryptix API
 * The Cryptix API is organized around [REST](https://wikipedia.org/wiki/REST).  ## HTTP response status codes |Status Code | Description| |---|---| |[200 OK](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/200) | The request is successful.| |[202 Accepted](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/202) | The server accepted the request and will execute it later. | |[401 Unauthorized](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/401)| Indicates that the client request has not been completed because it lacks valid authentication credentials for the requested resource.| |[403 Forbidden](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/403)| Indicates that the server understands the request but refuses to authorize it.| |[404 Not Found](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/404)| Indicates that the server cannot find the requested resource.| |[405 Method Not Allowed](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/405)| Indicates that the server knows the request method, but the target resource doesn\'t support this method.| |[422 Unprocessable Content](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/422)| Returned when the validation of the resource fails on POST or PUT requests. Response contains errors field with a list of errors.| |[429 Too Many Requests](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/429)| Indicates the user has sent too many requests in a given amount of time (\"rate limiting\").| |[500 Internal Server Error](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/500)| Server error.|  ## Error Codes |Error Code | Description| |---|---| | `authentication_required` | Indicates that the client request has not been completed because it lacks valid authentication credentials for the requested resource. | | `rate_limit_exceeded`     | Indicates the user has sent too many requests in a given amount of time (\"rate limiting\"). | | `validation_error`     | Request validation error. Response contains errors field with a list of errors. | | `insufficient_balance` | The operation could not be completed because the associated account does not have a sufficient balance available. Create a new operation using an amount less than or equal to the account\'s available balance. | | `amount_too_small`     | The specified amount is less than the minimum amount allowed. Use a higher amount (or change fee payer) and try again. | --- 
 *
 * The version of the OpenAPI document: v2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BankAccountDetails
 */
export interface BankAccountDetails {
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    beneficiary_account_name?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    beneficiary_account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    beneficiary_address?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    bank_name?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    bank_address?: string;
    /**
     * BIC/SWIFT code
     * @type {string}
     * @memberof BankAccountDetails
     */
    bic_swift_code?: string;
}
/**
 * 
 * @export
 * @interface BankAccountResponse
 */
export interface BankAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponse
     */
    transfer?: BankAccountResponseTransferEnum;
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponse
     */
    currency?: BankAccountResponseCurrencyEnum;
    /**
     * 
     * @type {BankAccountDetails}
     * @memberof BankAccountResponse
     */
    details?: BankAccountDetails;
    /**
     * 
     * @type {string}
     * @memberof BankAccountResponse
     */
    created_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BankAccountResponseTransferEnum {
    Swift = 'SWIFT',
    Sepa = 'SEPA'
}
/**
    * @export
    * @enum {string}
    */
export enum BankAccountResponseCurrencyEnum {
    Usd = 'USD',
    Eur = 'EUR'
}

/**
 * 
 * @export
 * @interface BankFee
 */
export interface BankFee {
    /**
     * 
     * @type {string}
     * @memberof BankFee
     */
    total_fee?: string;
    /**
     * 
     * @type {FeePercent}
     * @memberof BankFee
     */
    percent?: FeePercent;
    /**
     * 
     * @type {FeeFix}
     * @memberof BankFee
     */
    fix?: FeeFix;
}
/**
 * 
 * @export
 * @interface BankPayoutCallback
 */
export interface BankPayoutCallback {
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallback
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallback
     */
    type: string;
    /**
     * 
     * @type {BankPayoutCallbackData}
     * @memberof BankPayoutCallback
     */
    data: BankPayoutCallbackData;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallback
     */
    created_at: string;
}
/**
 * 
 * @export
 * @interface BankPayoutCallbackData
 */
export interface BankPayoutCallbackData {
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallbackData
     */
    id: string;
    /**
     * 
     * @type {SymbolBank}
     * @memberof BankPayoutCallbackData
     */
    symbol: SymbolBank;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallbackData
     */
    account_number: string;
    /**
     * 
     * @type {number}
     * @memberof BankPayoutCallbackData
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallbackData
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallbackData
     */
    callback_url: string;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallbackData
     */
    external_id: string;
    /**
     * 
     * @type {BankFee}
     * @memberof BankPayoutCallbackData
     */
    fees?: BankFee | null;
    /**
     * 
     * @type {PayoutError}
     * @memberof BankPayoutCallbackData
     */
    error?: PayoutError;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallbackData
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutCallbackData
     */
    updated_at: string;
}
/**
 * 
 * @export
 * @interface BankPayoutCreate
 */
export interface BankPayoutCreate {
    /**
     * Unique ID of payout (UUID format)
     * @type {string}
     * @memberof BankPayoutCreate
     */
    id: string;
    /**
     * Merchant\'s callback URL.
     * @type {string}
     * @memberof BankPayoutCreate
     */
    callback_url?: string;
    /**
     * 
     * @type {SymbolBank}
     * @memberof BankPayoutCreate
     */
    symbol: SymbolBank;
    /**
     * Amount to send.
     * @type {string}
     * @memberof BankPayoutCreate
     */
    amount: string;
    /**
     * 
     * @type {BankPayoutCreateCustomer}
     * @memberof BankPayoutCreate
     */
    customer?: BankPayoutCreateCustomer;
    /**
     * 
     * @type {BankPayoutCreateAccount}
     * @memberof BankPayoutCreate
     */
    account?: BankPayoutCreateAccount;
    /**
     * Merchant\'s external ID for this payout.
     * @type {string}
     * @memberof BankPayoutCreate
     */
    external_id?: string;
    /**
     * OTP code (if enabled)
     * @type {string}
     * @memberof BankPayoutCreate
     */
    otp?: string;
}
/**
 * 
 * @export
 * @interface BankPayoutCreateAccount
 */
export interface BankPayoutCreateAccount {
    /**
     * Bank account number
     * @type {string}
     * @memberof BankPayoutCreateAccount
     */
    number: string;
    /**
     * bank account type
     * @type {string}
     * @memberof BankPayoutCreateAccount
     */
    type: BankPayoutCreateAccountTypeEnum;
    /**
     * country
     * @type {string}
     * @memberof BankPayoutCreateAccount
     */
    country: BankPayoutCreateAccountCountryEnum;
    /**
     * bank id
     * @type {number}
     * @memberof BankPayoutCreateAccount
     */
    bank_id: number;
}

/**
    * @export
    * @enum {string}
    */
export enum BankPayoutCreateAccountTypeEnum {
    Cacc = 'CACC',
    Svgs = 'SVGS'
}
/**
    * @export
    * @enum {string}
    */
export enum BankPayoutCreateAccountCountryEnum {
    Colombia = 'Colombia',
    Peru = 'Peru',
    Ecuador = 'Ecuador'
}

/**
 * 
 * @export
 * @interface BankPayoutCreateCustomer
 */
export interface BankPayoutCreateCustomer {
    /**
     * Customer first name
     * @type {string}
     * @memberof BankPayoutCreateCustomer
     */
    first_name: string;
    /**
     * Customer last name
     * @type {string}
     * @memberof BankPayoutCreateCustomer
     */
    last_name: string;
    /**
     * Customer’s email address
     * @type {string}
     * @memberof BankPayoutCreateCustomer
     */
    email: string;
    /**
     * Customer’s phone number without leading +
     * @type {string}
     * @memberof BankPayoutCreateCustomer
     */
    phone: string;
    /**
     * Customer’s document number
     * @type {string}
     * @memberof BankPayoutCreateCustomer
     */
    doc_number: string;
    /**
     * Customer’s document type
     * @type {string}
     * @memberof BankPayoutCreateCustomer
     */
    doc_type: BankPayoutCreateCustomerDocTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BankPayoutCreateCustomerDocTypeEnum {
    Dni = 'DNI',
    Pas = 'PAS',
    Ce = 'CE',
    Ruc = 'RUC',
    Ci = 'CI',
    Cc = 'CC',
    Nit = 'NIT'
}

/**
 * 
 * @export
 * @interface BankPayoutData
 */
export interface BankPayoutData {
    /**
     * 
     * @type {string}
     * @memberof BankPayoutData
     */
    ext_tx_id?: string;
    /**
     * 
     * @type {SymbolBank}
     * @memberof BankPayoutData
     */
    symbol: SymbolBank;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutData
     */
    amount: string;
    /**
     * 
     * @type {BankPayoutDataAccount}
     * @memberof BankPayoutData
     */
    account: BankPayoutDataAccount;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutData
     */
    callback_url?: string;
    /**
     * 
     * @type {BankFee}
     * @memberof BankPayoutData
     */
    fees?: BankFee | null;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutData
     */
    external_id?: string;
}
/**
 * 
 * @export
 * @interface BankPayoutDataAccount
 */
export interface BankPayoutDataAccount {
    /**
     * 
     * @type {string}
     * @memberof BankPayoutDataAccount
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutDataAccount
     */
    type: BankPayoutDataAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutDataAccount
     */
    country: BankPayoutDataAccountCountryEnum;
    /**
     * 
     * @type {number}
     * @memberof BankPayoutDataAccount
     */
    bank_id: number;
}

/**
    * @export
    * @enum {string}
    */
export enum BankPayoutDataAccountTypeEnum {
    Cacc = 'CACC',
    Svgs = 'SVGS'
}
/**
    * @export
    * @enum {string}
    */
export enum BankPayoutDataAccountCountryEnum {
    Colombia = 'Colombia',
    Peru = 'Peru',
    Ecuador = 'Ecuador'
}

/**
 * Bank payout
 * @export
 * @interface BankPayoutResponse
 */
export interface BankPayoutResponse {
    /**
     * 
     * @type {string}
     * @memberof BankPayoutResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutResponse
     */
    status: BankPayoutResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutResponse
     */
    callback_url?: string;
    /**
     * 
     * @type {PayoutError}
     * @memberof BankPayoutResponse
     */
    error?: PayoutError;
    /**
     * 
     * @type {BankPayoutData}
     * @memberof BankPayoutResponse
     */
    data: BankPayoutData;
    /**
     * 
     * @type {string}
     * @memberof BankPayoutResponse
     */
    created_at: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BankPayoutResponseStatusEnum {
    Pending = 'pending',
    Sending = 'sending',
    Failed = 'failed',
    Completed = 'completed'
}

/**
 * 
 * @export
 * @interface CardFee
 */
export interface CardFee {
    /**
     * 
     * @type {string}
     * @memberof CardFee
     */
    total_fee?: string;
    /**
     * 
     * @type {FeePercent}
     * @memberof CardFee
     */
    percent?: FeePercent;
    /**
     * 
     * @type {FeeFix}
     * @memberof CardFee
     */
    fix?: FeeFix;
}
/**
 * 
 * @export
 * @interface CardMassPayoutJsonCreate
 */
export interface CardMassPayoutJsonCreate {
    /**
     * Unique ID of mass payout (UUID format)
     * @type {string}
     * @memberof CardMassPayoutJsonCreate
     */
    id: string;
    /**
     * Merchant\'s external ID for mass payout.
     * @type {string}
     * @memberof CardMassPayoutJsonCreate
     */
    external_id?: string;
    /**
     * Merchant\'s callback URL.
     * @type {string}
     * @memberof CardMassPayoutJsonCreate
     */
    callback_url?: string;
    /**
     * List of payout objects.
     * @type {Array<CardMassPayoutJsonCreatePayouts>}
     * @memberof CardMassPayoutJsonCreate
     */
    payouts: Array<CardMassPayoutJsonCreatePayouts>;
    /**
     * OTP code (if enabled)
     * @type {string}
     * @memberof CardMassPayoutJsonCreate
     */
    otp?: string;
    /**
     * whether mass payout sending should be confirmed with [/send](#/MassPayouts/send) call.
     * @type {boolean}
     * @memberof CardMassPayoutJsonCreate
     */
    with_confirmation?: boolean;
}
/**
 * 
 * @export
 * @interface CardMassPayoutJsonCreatePayouts
 */
export interface CardMassPayoutJsonCreatePayouts {
    /**
     * 
     * @type {SymbolCard}
     * @memberof CardMassPayoutJsonCreatePayouts
     */
    symbol: SymbolCard;
    /**
     * Card number.
     * @type {string}
     * @memberof CardMassPayoutJsonCreatePayouts
     */
    card_number: string;
    /**
     * Amount to send.
     * @type {string}
     * @memberof CardMassPayoutJsonCreatePayouts
     */
    amount: string;
    /**
     * Merchant\'s external ID for this payout.
     * @type {string}
     * @memberof CardMassPayoutJsonCreatePayouts
     */
    external_id?: string;
}
/**
 * single payout from a mass payout
 * @export
 * @interface CardMassPayoutPayoutResponse
 */
export interface CardMassPayoutPayoutResponse {
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutPayoutResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutPayoutResponse
     */
    status: CardMassPayoutPayoutResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutPayoutResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutPayoutResponse
     */
    mass_payout_id: string;
    /**
     * 
     * @type {CardMassPayoutPayoutResponseData}
     * @memberof CardMassPayoutPayoutResponse
     */
    data?: CardMassPayoutPayoutResponseData;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutPayoutResponse
     */
    created_at: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CardMassPayoutPayoutResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface CardMassPayoutPayoutResponseData
 */
export interface CardMassPayoutPayoutResponseData {
    /**
     * 
     * @type {SymbolCard}
     * @memberof CardMassPayoutPayoutResponseData
     */
    symbol: SymbolCard;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutPayoutResponseData
     */
    card_number: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutPayoutResponseData
     */
    amount: string;
    /**
     * 
     * @type {CardFee}
     * @memberof CardMassPayoutPayoutResponseData
     */
    fee?: CardFee | null;
}
/**
 * 
 * @export
 * @interface CardMassPayoutResponse
 */
export interface CardMassPayoutResponse {
    /**
     * ID of mass payout.
     * @type {string}
     * @memberof CardMassPayoutResponse
     */
    id: string;
    /**
     * Status of mass payout.
     * @type {string}
     * @memberof CardMassPayoutResponse
     */
    status: CardMassPayoutResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutResponse
     */
    external_id?: string;
    /**
     * List of payouts related to this card mass payout.
     * @type {Array<CardMassPayoutResponsePayouts>}
     * @memberof CardMassPayoutResponse
     */
    payouts: Array<CardMassPayoutResponsePayouts>;
    /**
     * Mass payout creation date.
     * @type {string}
     * @memberof CardMassPayoutResponse
     */
    created_at?: string;
    /**
     * Mass payout expiration date (if present).
     * @type {string}
     * @memberof CardMassPayoutResponse
     */
    expires_at?: string;
    /**
     * 
     * @type {Array<SummaryCardItem>}
     * @memberof CardMassPayoutResponse
     */
    summary?: Array<SummaryCardItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum CardMassPayoutResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Processed = 'processed'
}

/**
 * 
 * @export
 * @interface CardMassPayoutResponsePayouts
 */
export interface CardMassPayoutResponsePayouts {
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutResponsePayouts
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutResponsePayouts
     */
    status?: CardMassPayoutResponsePayoutsStatusEnum;
    /**
     * 
     * @type {SymbolCard}
     * @memberof CardMassPayoutResponsePayouts
     */
    symbol: SymbolCard;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutResponsePayouts
     */
    card_number: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutResponsePayouts
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutResponsePayouts
     */
    callback_url?: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutResponsePayouts
     */
    external_id?: string;
    /**
     * 
     * @type {CardFee}
     * @memberof CardMassPayoutResponsePayouts
     */
    fees?: CardFee | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CardMassPayoutResponsePayoutsStatusEnum {
    New = 'new',
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed',
    Cancelled = 'cancelled'
}

/**
 * card mass payout container without inner payouts
 * @export
 * @interface CardMassPayoutShort
 */
export interface CardMassPayoutShort {
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutShort
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutShort
     */
    status: CardMassPayoutShortStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutShort
     */
    external_id?: string;
    /**
     * 
     * @type {MassPayoutShortStats}
     * @memberof CardMassPayoutShort
     */
    stats?: MassPayoutShortStats;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutShort
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof CardMassPayoutShort
     */
    expires_at?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum CardMassPayoutShortStatusEnum {
    New = 'new',
    Pending = 'pending',
    Processed = 'processed'
}

/**
 * 
 * @export
 * @interface CardPayoutCallback
 */
export interface CardPayoutCallback {
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallback
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallback
     */
    type: string;
    /**
     * 
     * @type {CardPayoutCallbackData}
     * @memberof CardPayoutCallback
     */
    data: CardPayoutCallbackData;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallback
     */
    created_at: string;
}
/**
 * 
 * @export
 * @interface CardPayoutCallbackData
 */
export interface CardPayoutCallbackData {
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    id: string;
    /**
     * 
     * @type {SymbolCard}
     * @memberof CardPayoutCallbackData
     */
    symbol: SymbolCard;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    card_number: string;
    /**
     * 
     * @type {number}
     * @memberof CardPayoutCallbackData
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    callback_url: string;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    external_id: string;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    mass_payout_id?: string;
    /**
     * 
     * @type {CardFee}
     * @memberof CardPayoutCallbackData
     */
    fees?: CardFee | null;
    /**
     * 
     * @type {PayoutError}
     * @memberof CardPayoutCallbackData
     */
    error?: PayoutError;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof CardPayoutCallbackData
     */
    updated_at: string;
}
/**
 * 
 * @export
 * @interface ChargeResponse
 */
export interface ChargeResponse {
    /**
     * Unique identifier for the object
     * @type {string}
     * @memberof ChargeResponse
     */
    id?: string;
    /**
     * ID of merchant
     * @type {string}
     * @memberof ChargeResponse
     */
    merchant_id?: string;
    /**
     * ID of project
     * @type {string}
     * @memberof ChargeResponse
     */
    project_id?: string;
    /**
     * The charge\'s name, meant to be displayable to the customer
     * @type {string}
     * @memberof ChargeResponse
     */
    name?: string;
    /**
     * The charge\'s description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes
     * @type {string}
     * @memberof ChargeResponse
     */
    description?: string;
    /**
     * What type of prices do you want to offer?
     * @type {string}
     * @memberof ChargeResponse
     */
    pricing_type?: ChargeResponsePricingTypeEnum;
    /**
     * Is auto resolve if amount less than what was requested
     * @type {boolean}
     * @memberof ChargeResponse
     */
    is_resolve_underpaid?: boolean;
    /**
     * Is auto resolve if amount more than what was requested
     * @type {boolean}
     * @memberof ChargeResponse
     */
    is_resolve_overpaid?: boolean;
    /**
     * A unique string to reference the Charge. This can be a customer ID, a cart ID, or similar, and can be used to reconcile the Charge with your internal systems
     * @type {string}
     * @memberof ChargeResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChargeResponse
     */
    status?: ChargeResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ChargeResponse
     */
    context?: ChargeResponseContextEnum;
    /**
     * Time at which the object was created
     * @type {string}
     * @memberof ChargeResponse
     */
    created_at?: string;
    /**
     * Time at which the object was completed
     * @type {string}
     * @memberof ChargeResponse
     */
    completes_at?: string;
    /**
     * Time at which the object was expired
     * @type {string}
     * @memberof ChargeResponse
     */
    expires_at?: string;
    /**
     * ID of checkout
     * @type {string}
     * @memberof ChargeResponse
     */
    checkout_id?: string | null;
    /**
     * ID of invoice
     * @type {string}
     * @memberof ChargeResponse
     */
    invoice_id?: string | null;
    /**
     * status change history
     * @type {Array<object>}
     * @memberof ChargeResponse
     */
    timeline?: Array<object>;
    /**
     * 
     * @type {InitPrice}
     * @memberof ChargeResponse
     */
    init_price?: InitPrice | null;
    /**
     * 
     * @type {MerchantPrice}
     * @memberof ChargeResponse
     */
    merchant_price?: MerchantPrice | null;
    /**
     * 
     * @type {Pricing}
     * @memberof ChargeResponse
     */
    pricing?: Pricing;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof ChargeResponse
     */
    payments?: Array<Payment>;
    /**
     * 
     * @type {Array<EnabledCrypto>}
     * @memberof ChargeResponse
     */
    enabled_crypto?: Array<EnabledCrypto>;
    /**
     * 
     * @type {HostedResponse}
     * @memberof ChargeResponse
     */
    hosted?: HostedResponse;
    /**
     * 
     * @type {ChargeResponseLogo}
     * @memberof ChargeResponse
     */
    logo?: ChargeResponseLogo;
    /**
     * 
     * @type {ChargeResponseLogo}
     * @memberof ChargeResponse
     */
    image?: ChargeResponseLogo;
    /**
     * 
     * @type {string}
     * @memberof ChargeResponse
     */
    min_accepted_amount_usd?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ChargeResponsePricingTypeEnum {
    FixedPrice = 'fixed_price',
    NoPrice = 'no_price'
}
/**
    * @export
    * @enum {string}
    */
export enum ChargeResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Completed = 'completed',
    Expired = 'expired',
    Unresolved = 'unresolved',
    Resolving = 'resolving',
    Resolved = 'resolved',
    Canceled = 'canceled'
}
/**
    * @export
    * @enum {string}
    */
export enum ChargeResponseContextEnum {
    Underpaid = 'underpaid',
    Overpaid = 'overpaid',
    Manual = 'manual',
    IllicitResource = 'illicit_resource',
    Reactivated = 'reactivated'
}

/**
 * 
 * @export
 * @interface ChargeResponseLogo
 */
export interface ChargeResponseLogo {
    /**
     * 
     * @type {object}
     * @memberof ChargeResponseLogo
     */
    versions?: object;
}
/**
 * 
 * @export
 * @interface CheckoutCreateRequest
 */
export interface CheckoutCreateRequest {
    /**
     * ID of project
     * @type {string}
     * @memberof CheckoutCreateRequest
     */
    project_id: string;
    /**
     * What type of prices do you want to offer?
     * @type {string}
     * @memberof CheckoutCreateRequest
     */
    pricing_type: CheckoutCreateRequestPricingTypeEnum;
    /**
     * 
     * @type {CheckoutCreateRequestFiatPrice}
     * @memberof CheckoutCreateRequest
     */
    fiat_price?: CheckoutCreateRequestFiatPrice;
    /**
     * The product’s name, meant to be displayable to the customer
     * @type {string}
     * @memberof CheckoutCreateRequest
     */
    name: string;
    /**
     * The product’s description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes
     * @type {string}
     * @memberof CheckoutCreateRequest
     */
    description: string;
    /**
     * 
     * @type {CheckoutCreateRequestImage}
     * @memberof CheckoutCreateRequest
     */
    image?: CheckoutCreateRequestImage;
    /**
     * If provided, the success page will include a button that redirects your customer to the provided URL
     * @type {string}
     * @memberof CheckoutCreateRequest
     */
    return_url?: string | null;
    /**
     * Payment page theme
     * @type {string}
     * @memberof CheckoutCreateRequest
     */
    theme?: CheckoutCreateRequestThemeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CheckoutCreateRequestPricingTypeEnum {
    FixedPrice = 'fixed_price',
    NoPrice = 'no_price'
}
/**
    * @export
    * @enum {string}
    */
export enum CheckoutCreateRequestThemeEnum {
    Light = 'light',
    Dark = 'dark'
}

/**
 * Required for pricing_type: fixed_price
 * @export
 * @interface CheckoutCreateRequestFiatPrice
 */
export interface CheckoutCreateRequestFiatPrice {
    /**
     * A positive float in fiat representing how much to charge
     * @type {string}
     * @memberof CheckoutCreateRequestFiatPrice
     */
    amount?: string;
    /**
     * Three-letter ISO currency code, in uppercase
     * @type {string}
     * @memberof CheckoutCreateRequestFiatPrice
     */
    symbol?: string;
}
/**
 * 
 * @export
 * @interface CheckoutCreateRequestImage
 */
export interface CheckoutCreateRequestImage {
    /**
     * 
     * @type {string}
     * @memberof CheckoutCreateRequestImage
     */
    cache_id?: string;
}
/**
 * 
 * @export
 * @interface CheckoutResponse
 */
export interface CheckoutResponse {
    /**
     * Unique identifier for the object
     * @type {string}
     * @memberof CheckoutResponse
     */
    id?: string;
    /**
     * ID of project
     * @type {string}
     * @memberof CheckoutResponse
     */
    project_id: string;
    /**
     * What type of prices do you want to offer?
     * @type {string}
     * @memberof CheckoutResponse
     */
    pricing_type: CheckoutResponsePricingTypeEnum;
    /**
     * 
     * @type {CheckoutCreateRequestFiatPrice}
     * @memberof CheckoutResponse
     */
    fiat_price?: CheckoutCreateRequestFiatPrice;
    /**
     * The product’s name, meant to be displayable to the customer
     * @type {string}
     * @memberof CheckoutResponse
     */
    name: string;
    /**
     * The product’s description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes
     * @type {string}
     * @memberof CheckoutResponse
     */
    description: string;
    /**
     * 
     * @type {CheckoutCreateRequestImage}
     * @memberof CheckoutResponse
     */
    image?: CheckoutCreateRequestImage;
    /**
     * 
     * @type {HostedResponse}
     * @memberof CheckoutResponse
     */
    hosted?: HostedResponse;
}

/**
    * @export
    * @enum {string}
    */
export enum CheckoutResponsePricingTypeEnum {
    FixedPrice = 'fixed_price',
    NoPrice = 'no_price'
}

/**
 * 
 * @export
 * @interface CheckoutUpdateRequest
 */
export interface CheckoutUpdateRequest {
    /**
     * 
     * @type {CheckoutCreateRequestFiatPrice}
     * @memberof CheckoutUpdateRequest
     */
    fiat_price?: CheckoutCreateRequestFiatPrice;
    /**
     * The product’s name, meant to be displayable to the customer
     * @type {string}
     * @memberof CheckoutUpdateRequest
     */
    name: string;
    /**
     * The product’s description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes
     * @type {string}
     * @memberof CheckoutUpdateRequest
     */
    description: string;
    /**
     * 
     * @type {CheckoutCreateRequestImage}
     * @memberof CheckoutUpdateRequest
     */
    image?: CheckoutCreateRequestImage;
    /**
     * The success page will include a button that redirects your customer to the provided URL
     * @type {string}
     * @memberof CheckoutUpdateRequest
     */
    return_url: string | null;
    /**
     * Payment page theme
     * @type {string}
     * @memberof CheckoutUpdateRequest
     */
    theme: CheckoutUpdateRequestThemeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CheckoutUpdateRequestThemeEnum {
    Light = 'light',
    Dark = 'dark'
}

/**
 * 
 * @export
 * @interface ConvertPairsResponse
 */
export interface ConvertPairsResponse {
    /**
     * 
     * @type {ConvertPairsResponseFrom}
     * @memberof ConvertPairsResponse
     */
    from?: ConvertPairsResponseFrom;
    /**
     * 
     * @type {ConvertPairsResponseFrom}
     * @memberof ConvertPairsResponse
     */
    to?: ConvertPairsResponseFrom;
}
/**
 * 
 * @export
 * @interface ConvertPairsResponseFrom
 */
export interface ConvertPairsResponseFrom {
    /**
     * 
     * @type {NetworkAll}
     * @memberof ConvertPairsResponseFrom
     */
    network?: NetworkAll;
    /**
     * 
     * @type {SymbolAll}
     * @memberof ConvertPairsResponseFrom
     */
    symbol?: SymbolAll;
}
/**
 * 
 * @export
 * @interface ConvertResponse
 */
export interface ConvertResponse {
    /**
     * 
     * @type {string}
     * @memberof ConvertResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvertResponse
     */
    status?: ConvertResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ConvertResponse
     */
    created_at?: string;
    /**
     * 
     * @type {NetworkAll}
     * @memberof ConvertResponse
     */
    network_from?: NetworkAll;
    /**
     * 
     * @type {SymbolAll}
     * @memberof ConvertResponse
     */
    symbol_from?: SymbolAll;
    /**
     * 
     * @type {string}
     * @memberof ConvertResponse
     */
    amount_from?: string;
    /**
     * 
     * @type {NetworkAll}
     * @memberof ConvertResponse
     */
    network_to?: NetworkAll;
    /**
     * 
     * @type {SymbolAll}
     * @memberof ConvertResponse
     */
    symbol_to?: SymbolAll;
    /**
     * 
     * @type {string}
     * @memberof ConvertResponse
     */
    amount_to?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvertResponse
     */
    rate?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ConvertResponseStatusEnum {
    Pending = 'pending',
    Success = 'success',
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface ConvertTokenResponse
 */
export interface ConvertTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ConvertTokenResponse
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvertTokenResponse
     */
    expires_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvertTokenResponse
     */
    rate?: string;
    /**
     * 
     * @type {string}
     * @memberof ConvertTokenResponse
     */
    amount?: string;
}
/**
 * 
 * @export
 * @interface DepositCreateRequest
 */
export interface DepositCreateRequest {
    /**
     * ID of project
     * @type {string}
     * @memberof DepositCreateRequest
     */
    project_id: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof DepositCreateRequest
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof DepositCreateRequest
     */
    symbol: SymbolCrypto;
}
/**
 * 
 * @export
 * @interface DepositPaymentCallback
 */
export interface DepositPaymentCallback {
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentCallback
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentCallback
     */
    type: string;
    /**
     * 
     * @type {DepositPaymentResponse}
     * @memberof DepositPaymentCallback
     */
    data: DepositPaymentResponse;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentCallback
     */
    created_at: string;
}
/**
 * 
 * @export
 * @interface DepositPaymentResponse
 */
export interface DepositPaymentResponse {
    /**
     * Unique identifier for the object
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    id?: string;
    /**
     * ID of deposit
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    deposit_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    pricing_type?: DepositPaymentResponsePricingTypeEnum;
    /**
     * ID of blockchain
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    tx_id?: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof DepositPaymentResponse
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof DepositPaymentResponse
     */
    symbol?: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    address_from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    address_to?: string;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     * @deprecated
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    status?: DepositPaymentResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    aml_level?: DepositPaymentResponseAmlLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    detected_at?: string;
    /**
     * 
     * @type {DepositPaymentResponseExchange}
     * @memberof DepositPaymentResponse
     */
    exchange?: DepositPaymentResponseExchange | null;
    /**
     * ID of refund
     * @type {string}
     * @memberof DepositPaymentResponse
     */
    refund_id?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DepositPaymentResponsePricingTypeEnum {
    Deposit = 'deposit'
}
/**
    * @export
    * @enum {string}
    */
export enum DepositPaymentResponseStatusEnum {
    Pending = 'pending',
    Confirmed = 'confirmed',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum DepositPaymentResponseAmlLevelEnum {
    Low = 'low',
    Medium = 'medium',
    High = 'high'
}

/**
 * 
 * @export
 * @interface DepositPaymentResponseExchange
 */
export interface DepositPaymentResponseExchange {
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof DepositPaymentResponseExchange
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof DepositPaymentResponseExchange
     */
    symbol?: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponseExchange
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponseExchange
     */
    rate?: string;
    /**
     * 
     * @type {string}
     * @memberof DepositPaymentResponseExchange
     */
    status?: DepositPaymentResponseExchangeStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DepositPaymentResponseExchangeStatusEnum {
    Pending = 'pending',
    Success = 'success'
}

/**
 * 
 * @export
 * @interface DepositResponse
 */
export interface DepositResponse {
    /**
     * Unique identifier for the object
     * @type {string}
     * @memberof DepositResponse
     */
    id: string;
    /**
     * ID of project
     * @type {string}
     * @memberof DepositResponse
     */
    project_id: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof DepositResponse
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof DepositResponse
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof DepositResponse
     */
    address: string;
    /**
     * If the value is false, it is necessary to recreate the deposit address using the method [Create a deposit](#/Deposits/create_deposit). Callbacks will not be received and cryptocurrencies will not be exchanged if the value is false.
     * @type {boolean}
     * @memberof DepositResponse
     */
    is_active: boolean;
    /**
     * Time at which the object was created
     * @type {string}
     * @memberof DepositResponse
     */
    created_at: string;
    /**
     * 
     * @type {DepositResponseExchangeTo}
     * @memberof DepositResponse
     */
    exchange_to?: DepositResponseExchangeTo | null;
}
/**
 * 
 * @export
 * @interface DepositResponseExchangeTo
 */
export interface DepositResponseExchangeTo {
    /**
     * 
     * @type {string}
     * @memberof DepositResponseExchangeTo
     */
    network?: DepositResponseExchangeToNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof DepositResponseExchangeTo
     */
    symbol?: DepositResponseExchangeToSymbolEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DepositResponseExchangeToNetworkEnum {
    Fiat = 'fiat',
    Tron = 'tron'
}
/**
    * @export
    * @enum {string}
    */
export enum DepositResponseExchangeToSymbolEnum {
    Usd = 'USD',
    Eur = 'EUR',
    Usdt = 'USDT'
}

/**
 * 
 * @export
 * @interface EnabledCrypto
 */
export interface EnabledCrypto {
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof EnabledCrypto
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof EnabledCrypto
     */
    symbol: SymbolCrypto;
}
/**
 * 
 * @export
 * @interface Fee
 */
export interface Fee {
    /**
     * 
     * @type {string}
     * @memberof Fee
     */
    total_fee?: string;
    /**
     * 
     * @type {FeePercent}
     * @memberof Fee
     */
    percent?: FeePercent;
    /**
     * 
     * @type {FeeFix}
     * @memberof Fee
     */
    fix?: FeeFix;
}
/**
 * 
 * @export
 * @interface FeeFix
 */
export interface FeeFix {
    /**
     * 
     * @type {string}
     * @memberof FeeFix
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof FeeFix
     */
    amount?: string;
}
/**
 * 
 * @export
 * @interface FeePercent
 */
export interface FeePercent {
    /**
     * 
     * @type {string}
     * @memberof FeePercent
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof FeePercent
     */
    amount?: string;
}
/**
 * 
 * @export
 * @interface FiatWithdrawalResponse
 */
export interface FiatWithdrawalResponse {
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    bank_account_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    bank_account_transfer?: FiatWithdrawalResponseBankAccountTransferEnum;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    bank_account_currency?: FiatWithdrawalResponseBankAccountCurrencyEnum;
    /**
     * 
     * @type {BankAccountDetails}
     * @memberof FiatWithdrawalResponse
     */
    bank_account_details?: BankAccountDetails;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    total_amount?: string;
    /**
     * 
     * @type {FiatWithdrawalResponseFees}
     * @memberof FiatWithdrawalResponse
     */
    fees?: FiatWithdrawalResponseFees;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    status?: FiatWithdrawalResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponse
     */
    created_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FiatWithdrawalResponseBankAccountTransferEnum {
    Swift = 'SWIFT',
    Sepa = 'SEPA'
}
/**
    * @export
    * @enum {string}
    */
export enum FiatWithdrawalResponseBankAccountCurrencyEnum {
    Usd = 'USD',
    Eur = 'EUR'
}
/**
    * @export
    * @enum {string}
    */
export enum FiatWithdrawalResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Sending = 'sending',
    Completed = 'completed',
    Failed = 'failed',
    Canceled = 'canceled',
    Expired = 'expired'
}

/**
 * 
 * @export
 * @interface FiatWithdrawalResponseFees
 */
export interface FiatWithdrawalResponseFees {
    /**
     * 
     * @type {FiatWithdrawalResponseFeesPercent}
     * @memberof FiatWithdrawalResponseFees
     */
    percent?: FiatWithdrawalResponseFeesPercent;
    /**
     * 
     * @type {FiatWithdrawalResponseFeesFix}
     * @memberof FiatWithdrawalResponseFees
     */
    fix?: FiatWithdrawalResponseFeesFix;
}
/**
 * 
 * @export
 * @interface FiatWithdrawalResponseFeesFix
 */
export interface FiatWithdrawalResponseFeesFix {
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponseFeesFix
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponseFeesFix
     */
    amount?: string;
}
/**
 * 
 * @export
 * @interface FiatWithdrawalResponseFeesPercent
 */
export interface FiatWithdrawalResponseFeesPercent {
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponseFeesPercent
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof FiatWithdrawalResponseFeesPercent
     */
    amount?: string;
}
/**
 * 
 * @export
 * @interface HostedResponse
 */
export interface HostedResponse {
    /**
     * 
     * @type {string}
     * @memberof HostedResponse
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof HostedResponse
     */
    return_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HostedResponse
     */
    theme?: HostedResponseThemeEnum;
    /**
     * 
     * @type {string}
     * @memberof HostedResponse
     */
    version?: HostedResponseVersionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum HostedResponseThemeEnum {
    Dark = 'dark',
    Light = 'light'
}
/**
    * @export
    * @enum {string}
    */
export enum HostedResponseVersionEnum {
    _10 = '1.0',
    _20 = '2.0'
}

/**
 * 
 * @export
 * @interface InitPrice
 */
export interface InitPrice {
    /**
     * 
     * @type {string}
     * @memberof InitPrice
     */
    network?: string;
    /**
     * 
     * @type {string}
     * @memberof InitPrice
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof InitPrice
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof InitPrice
     */
    amount_rest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitPrice
     */
    amount_paid?: string;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * ID of project
     * @type {string}
     * @memberof InlineObject
     */
    project_id: string;
    /**
     * The charge\'s name, meant to be displayable to the customer
     * @type {string}
     * @memberof InlineObject
     */
    name?: string;
    /**
     * The charge\'s description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes
     * @type {string}
     * @memberof InlineObject
     */
    description?: string;
    /**
     * What type of prices do you want to offer?
     * @type {string}
     * @memberof InlineObject
     */
    pricing_type: InlineObjectPricingTypeEnum;
    /**
     * 
     * @type {V20ChargesCrypto}
     * @memberof InlineObject
     */
    crypto?: V20ChargesCrypto;
    /**
     * 
     * @type {V20ChargesFiatPrice}
     * @memberof InlineObject
     */
    fiat_price?: V20ChargesFiatPrice;
    /**
     * A unique string to reference the Charge. This can be a customer ID, a cart ID, or similar, and can be used to reconcile the Charge with your internal systems
     * @type {string}
     * @memberof InlineObject
     */
    external_id?: string;
    /**
     * If provided, the success page will include a button that redirects your customer to the provided URL
     * @type {string}
     * @memberof InlineObject
     */
    return_url?: string;
    /**
     * Payment page theme
     * @type {string}
     * @memberof InlineObject
     */
    theme?: InlineObjectThemeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineObjectPricingTypeEnum {
    FixedPrice = 'fixed_price',
    NoPrice = 'no_price'
}
/**
    * @export
    * @enum {string}
    */
export enum InlineObjectThemeEnum {
    Light = 'light',
    Dark = 'dark'
}

/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject1
     */
    checkout_id?: string;
}
/**
 * 
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject10
     */
    email: string;
    /**
     * Confirmation code from the email we sent you after registration
     * @type {string}
     * @memberof InlineObject10
     */
    code: string;
}
/**
 * 
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject11
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject11
     */
    password: string;
    /**
     * Will check after 3 unsuccessfully logins. To generate re-captcha use \'login\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=login\">here</a>
     * @type {string}
     * @memberof InlineObject11
     */
    re_captcha?: string;
    /**
     * Required only if OTP was enabled for login merchant
     * @type {string}
     * @memberof InlineObject11
     */
    otp?: string;
}
/**
 * 
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject12
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject12
     */
    re_captcha: string;
}
/**
 * 
 * @export
 * @interface InlineObject13
 */
export interface InlineObject13 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject13
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject13
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject13
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject13
     */
    confirm_password: string;
}
/**
 * 
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    current_merchant_password: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    new_submerchant_password: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject14
     */
    confirm_submerchant_password: string;
}
/**
 * 
 * @export
 * @interface InlineObject15
 */
export interface InlineObject15 {
    /**
     * The parameter can be used to block or unblock submerchant
     * @type {string}
     * @memberof InlineObject15
     */
    status?: InlineObject15StatusEnum;
    /**
     * Possible access rights for submerchants
     * @type {Array<string>}
     * @memberof InlineObject15
     */
    access_control_groups?: Array<InlineObject15AccessControlGroupsEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineObject15StatusEnum {
    Confirmed = 'confirmed',
    Blocked = 'blocked'
}
/**
    * @export
    * @enum {string}
    */
export enum InlineObject15AccessControlGroupsEnum {
    View = 'view',
    Reports = 'reports'
}

/**
 * 
 * @export
 * @interface InlineObject16
 */
export interface InlineObject16 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject16
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject16
     */
    password: string;
}
/**
 * 
 * @export
 * @interface InlineObject17
 */
export interface InlineObject17 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject17
     */
    code: string;
}
/**
 * 
 * @export
 * @interface InlineObject18
 */
export interface InlineObject18 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject18
     */
    network?: InlineObject18NetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineObject18
     */
    symbol: InlineObject18SymbolEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineObject18NetworkEnum {
    Fiat = 'fiat',
    Tron = 'tron'
}
/**
    * @export
    * @enum {string}
    */
export enum InlineObject18SymbolEnum {
    Usd = 'USD',
    Eur = 'EUR',
    Usdt = 'USDT'
}

/**
 * 
 * @export
 * @interface InlineObject19
 */
export interface InlineObject19 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineObject19
     */
    resolve_underpaid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InlineObject19
     */
    resolve_overpaid: boolean;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    network?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    symbol?: string;
}
/**
 * 
 * @export
 * @interface InlineObject20
 */
export interface InlineObject20 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject20
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject20
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject20
     */
    network: string;
    /**
     * Required when travel rule is enabled
     * @type {string}
     * @memberof InlineObject20
     */
    symbol?: string;
    /**
     * 
     * @type {V20MerchantWhitelistAddressesTravelRule}
     * @memberof InlineObject20
     */
    travel_rule?: V20MerchantWhitelistAddressesTravelRule;
}
/**
 * 
 * @export
 * @interface InlineObject21
 */
export interface InlineObject21 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject21
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface InlineObject22
 */
export interface InlineObject22 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject22
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject22
     */
    project_id?: string;
}
/**
 * 
 * @export
 * @interface InlineObject23
 */
export interface InlineObject23 {
    /**
     * IP address or a range of IP addresses in a [CIDR](https://en.wikipedia.org/wiki/Classless_Inter-Domain_Routing) notation.
     * @type {string}
     * @memberof InlineObject23
     */
    address: string;
    /**
     * Optional description.
     * @type {string}
     * @memberof InlineObject23
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface InlineObject24
 */
export interface InlineObject24 {
    /**
     * IP address or a range of IP addresses in a [CIDR](https://en.wikipedia.org/wiki/Classless_Inter-Domain_Routing) notation.
     * @type {string}
     * @memberof InlineObject24
     */
    address?: string;
    /**
     * Optional description.
     * @type {string}
     * @memberof InlineObject24
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface InlineObject25
 */
export interface InlineObject25 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject25
     */
    name?: string;
    /**
     * Possible token scopes. Optional field. Empty \"scopes\" field means maximum scope.
     * @type {Array<string>}
     * @memberof InlineObject25
     */
    scopes?: Array<string>;
}
/**
 * 
 * @export
 * @interface InlineObject26
 */
export interface InlineObject26 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject26
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject26
     */
    transfer?: InlineObject26TransferEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineObject26
     */
    currency?: InlineObject26CurrencyEnum;
    /**
     * 
     * @type {V20BankAccountsDetails}
     * @memberof InlineObject26
     */
    details?: V20BankAccountsDetails;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineObject26TransferEnum {
    Swift = 'SWIFT',
    Sepa = 'SEPA'
}
/**
    * @export
    * @enum {string}
    */
export enum InlineObject26CurrencyEnum {
    Usd = 'USD',
    Eur = 'EUR'
}

/**
 * 
 * @export
 * @interface InlineObject29
 */
export interface InlineObject29 {
    /**
     * Unique ID of withdrawal
     * @type {string}
     * @memberof InlineObject29
     */
    id?: string;
    /**
     * ID of bank account
     * @type {string}
     * @memberof InlineObject29
     */
    bank_account_id?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject29
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject29
     */
    external_id?: string;
    /**
     * OTP code
     * @type {string}
     * @memberof InlineObject29
     */
    otp?: string;
}
/**
 * 
 * @export
 * @interface InlineObject30
 */
export interface InlineObject30 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject30
     */
    callback_url?: string;
}
/**
 * 
 * @export
 * @interface InlineObject31
 */
export interface InlineObject31 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject31
     */
    token?: string;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * ID of project
     * @type {string}
     * @memberof InlineObject4
     */
    project_id: string;
    /**
     * 
     * @type {V20InvoicesFiatPrice}
     * @memberof InlineObject4
     */
    fiat_price: V20InvoicesFiatPrice;
    /**
     * The customer’s full name or business name
     * @type {string}
     * @memberof InlineObject4
     */
    customer_name?: string;
    /**
     * Customer’s email address
     * @type {string}
     * @memberof InlineObject4
     */
    customer_email: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject4
     */
    memo?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineObject4
     */
    void_after_seconds?: number | null;
}
/**
 * 
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
    /**
     * OTP code
     * @type {string}
     * @memberof InlineObject5
     */
    otp: string;
}
/**
 * 
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
    /**
     * OTP code
     * @type {string}
     * @memberof InlineObject6
     */
    otp: string;
}
/**
 * 
 * @export
 * @interface InlineObject7
 */
export interface InlineObject7 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject7
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject7
     */
    secret: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject7
     */
    password: string;
}
/**
 * 
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject8
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject8
     */
    password: string;
}
/**
 * 
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject9
     */
    current_password: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject9
     */
    new_password: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject9
     */
    confirm_password: string;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse200
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse200Data}
     * @memberof InlineResponse200
     */
    data?: InlineResponse200Data;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2001
     */
    success?: boolean;
    /**
     * 
     * @type {ChargeResponse}
     * @memberof InlineResponse2001
     */
    data?: ChargeResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20010
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20010Data}
     * @memberof InlineResponse20010
     */
    data?: InlineResponse20010Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20010Data
 */
export interface InlineResponse20010Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20010Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<InvoiceResponse>}
     * @memberof InlineResponse20010Data
     */
    data?: Array<InvoiceResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20011
     */
    success?: boolean;
    /**
     * 
     * @type {InvoiceResponse}
     * @memberof InlineResponse20011
     */
    data?: InvoiceResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20012
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20012Data}
     * @memberof InlineResponse20012
     */
    data?: InlineResponse20012Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20012Data
 */
export interface InlineResponse20012Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20012Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<MassPayoutShort>}
     * @memberof InlineResponse20012Data
     */
    data?: Array<MassPayoutShort>;
}
/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20013
     */
    success?: boolean;
    /**
     * 
     * @type {MassPayoutResponse}
     * @memberof InlineResponse20013
     */
    data?: MassPayoutResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20014
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20014Data}
     * @memberof InlineResponse20014
     */
    data?: InlineResponse20014Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20014Data
 */
export interface InlineResponse20014Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20014Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<SummaryItem>}
     * @memberof InlineResponse20014Data
     */
    summary?: Array<SummaryItem>;
    /**
     * 
     * @type {Array<MassPayoutPayoutResponse>}
     * @memberof InlineResponse20014Data
     */
    data?: Array<MassPayoutPayoutResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20015
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20015Data}
     * @memberof InlineResponse20015
     */
    data?: InlineResponse20015Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20015Data
 */
export interface InlineResponse20015Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20015Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<CardMassPayoutShort>}
     * @memberof InlineResponse20015Data
     */
    data?: Array<CardMassPayoutShort>;
}
/**
 * 
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20016
     */
    success?: boolean;
    /**
     * 
     * @type {CardMassPayoutResponse}
     * @memberof InlineResponse20016
     */
    data?: CardMassPayoutResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20017
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20017Data}
     * @memberof InlineResponse20017
     */
    data?: InlineResponse20017Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20017Data
 */
export interface InlineResponse20017Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20017Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<SummaryCardItem>}
     * @memberof InlineResponse20017Data
     */
    summary?: Array<SummaryCardItem>;
    /**
     * 
     * @type {Array<CardMassPayoutPayoutResponse>}
     * @memberof InlineResponse20017Data
     */
    data?: Array<CardMassPayoutPayoutResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20018
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20018Data}
     * @memberof InlineResponse20018
     */
    data?: InlineResponse20018Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20018Data
 */
export interface InlineResponse20018Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20018Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<BankPayoutResponse>}
     * @memberof InlineResponse20018Data
     */
    data?: Array<BankPayoutResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20019
     */
    success?: boolean;
    /**
     * 
     * @type {BankPayoutResponse}
     * @memberof InlineResponse20019
     */
    data?: BankPayoutResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2002
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse2002Data}
     * @memberof InlineResponse2002
     */
    data?: InlineResponse2002Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
    /**
     * 
     * @type {InlineResponse20020Data}
     * @memberof InlineResponse20020
     */
    data?: InlineResponse20020Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20020Data
 */
export interface InlineResponse20020Data {
    /**
     * 
     * @type {InlineResponse20020DataReCaptcha}
     * @memberof InlineResponse20020Data
     */
    re_captcha?: InlineResponse20020DataReCaptcha;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020Data
     */
    payment_page_url?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20020DataReCaptcha
 */
export interface InlineResponse20020DataReCaptcha {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20020DataReCaptcha
     */
    secret?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20021
     */
    success?: boolean;
    /**
     * 
     * @type {MerchantResponse}
     * @memberof InlineResponse20021
     */
    data?: MerchantResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20022
     */
    success?: boolean;
    /**
     * 
     * @type {KYBUrlResponse}
     * @memberof InlineResponse20022
     */
    data?: KYBUrlResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20023
     */
    success: boolean;
    /**
     * 
     * @type {LimitsResponse}
     * @memberof InlineResponse20023
     */
    data?: LimitsResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20024
 */
export interface InlineResponse20024 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20024
     */
    success: boolean;
    /**
     * 
     * @type {InlineResponse20024Data}
     * @memberof InlineResponse20024
     */
    data: InlineResponse20024Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20024Data
 */
export interface InlineResponse20024Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20024Data
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<SubmerchantResponse>}
     * @memberof InlineResponse20024Data
     */
    data: Array<SubmerchantResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20025
 */
export interface InlineResponse20025 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20025
     */
    success: boolean;
    /**
     * 
     * @type {SubmerchantResponse}
     * @memberof InlineResponse20025
     */
    data: SubmerchantResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20026
 */
export interface InlineResponse20026 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20026
     */
    success: boolean;
    /**
     * Possible access rights for submerchants
     * @type {Array<string>}
     * @memberof InlineResponse20026
     */
    data: Array<string>;
}
/**
 * 
 * @export
 * @interface InlineResponse20027
 */
export interface InlineResponse20027 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20027
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20027
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20028
 */
export interface InlineResponse20028 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20028
     */
    success?: boolean;
    /**
     * 
     * @type {TopupAddressResponse}
     * @memberof InlineResponse20028
     */
    data?: TopupAddressResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20029
 */
export interface InlineResponse20029 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20029
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20029Data}
     * @memberof InlineResponse20029
     */
    data?: InlineResponse20029Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20029Data
 */
export interface InlineResponse20029Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20029Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<TopupPaymentResponse>}
     * @memberof InlineResponse20029Data
     */
    data?: Array<TopupPaymentResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2002Data
 */
export interface InlineResponse2002Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse2002Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof InlineResponse2002Data
     */
    data?: Array<Payment>;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2003
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse2003Data}
     * @memberof InlineResponse2003
     */
    data?: InlineResponse2003Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20030
 */
export interface InlineResponse20030 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20030
     */
    success?: boolean;
    /**
     * 
     * @type {Array<TopupBankAccountResponse>}
     * @memberof InlineResponse20030
     */
    data?: Array<TopupBankAccountResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20031
 */
export interface InlineResponse20031 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20031
     */
    success?: boolean;
    /**
     * 
     * @type {VerificationOperationCodeSendResponse}
     * @memberof InlineResponse20031
     */
    data?: VerificationOperationCodeSendResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20032
 */
export interface InlineResponse20032 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20032
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20032Data}
     * @memberof InlineResponse20032
     */
    data?: InlineResponse20032Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20032Data
 */
export interface InlineResponse20032Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20032Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<SessionResponse>}
     * @memberof InlineResponse20032Data
     */
    data?: Array<SessionResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20033
 */
export interface InlineResponse20033 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20033
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20033Data}
     * @memberof InlineResponse20033
     */
    data?: InlineResponse20033Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20033Data
 */
export interface InlineResponse20033Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20033Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<BankAccountResponse>}
     * @memberof InlineResponse20033Data
     */
    data?: Array<BankAccountResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20034
 */
export interface InlineResponse20034 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20034
     */
    success?: boolean;
    /**
     * 
     * @type {BankAccountResponse}
     * @memberof InlineResponse20034
     */
    data?: BankAccountResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20035
 */
export interface InlineResponse20035 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20035
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20035Data}
     * @memberof InlineResponse20035
     */
    data?: InlineResponse20035Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20035Data
 */
export interface InlineResponse20035Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20035Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<ProjectResponse>}
     * @memberof InlineResponse20035Data
     */
    data?: Array<ProjectResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20036
 */
export interface InlineResponse20036 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20036
     */
    success?: boolean;
    /**
     * 
     * @type {ProjectResponse}
     * @memberof InlineResponse20036
     */
    data?: ProjectResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20037
 */
export interface InlineResponse20037 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20037
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20037Data}
     * @memberof InlineResponse20037
     */
    data?: InlineResponse20037Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20037Data
 */
export interface InlineResponse20037Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20037Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<FiatWithdrawalResponse>}
     * @memberof InlineResponse20037Data
     */
    data?: Array<FiatWithdrawalResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20038
 */
export interface InlineResponse20038 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20038
     */
    success?: boolean;
    /**
     * 
     * @type {FiatWithdrawalResponse}
     * @memberof InlineResponse20038
     */
    data?: FiatWithdrawalResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20039
 */
export interface InlineResponse20039 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20039
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20039Data}
     * @memberof InlineResponse20039
     */
    data?: InlineResponse20039Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20039Data
 */
export interface InlineResponse20039Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20039Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<PayoutResponse>}
     * @memberof InlineResponse20039Data
     */
    data?: Array<PayoutResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2003Data
 */
export interface InlineResponse2003Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse2003Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<DepositResponse>}
     * @memberof InlineResponse2003Data
     */
    data?: Array<DepositResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2004
     */
    success?: boolean;
    /**
     * 
     * @type {DepositResponse}
     * @memberof InlineResponse2004
     */
    data?: DepositResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20040
 */
export interface InlineResponse20040 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20040
     */
    success?: boolean;
    /**
     * 
     * @type {PayoutResponse}
     * @memberof InlineResponse20040
     */
    data?: PayoutResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20041
 */
export interface InlineResponse20041 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20041
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20041Data}
     * @memberof InlineResponse20041
     */
    data?: InlineResponse20041Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20041Data
 */
export interface InlineResponse20041Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20041Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<WithdrawalResponse>}
     * @memberof InlineResponse20041Data
     */
    data?: Array<WithdrawalResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20042
 */
export interface InlineResponse20042 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20042
     */
    success?: boolean;
    /**
     * 
     * @type {WithdrawalResponse}
     * @memberof InlineResponse20042
     */
    data?: WithdrawalResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20043
 */
export interface InlineResponse20043 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20043
     */
    success?: boolean;
    /**
     * 
     * @type {Array<ConvertPairsResponse>}
     * @memberof InlineResponse20043
     */
    data?: Array<ConvertPairsResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20044
 */
export interface InlineResponse20044 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20044
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20044Data}
     * @memberof InlineResponse20044
     */
    data?: InlineResponse20044Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20044Data
 */
export interface InlineResponse20044Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20044Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<ConvertResponse>}
     * @memberof InlineResponse20044Data
     */
    data?: Array<ConvertResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20045
 */
export interface InlineResponse20045 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20045
     */
    success?: boolean;
    /**
     * 
     * @type {ConvertResponse}
     * @memberof InlineResponse20045
     */
    data?: ConvertResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20046
 */
export interface InlineResponse20046 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20046
     */
    success?: boolean;
    /**
     * 
     * @type {ConvertTokenResponse}
     * @memberof InlineResponse20046
     */
    data?: ConvertTokenResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20047
 */
export interface InlineResponse20047 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20047
     */
    success?: boolean;
    /**
     * 
     * @type {RatesResponse}
     * @memberof InlineResponse20047
     */
    data?: RatesResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20048
 */
export interface InlineResponse20048 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20048
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20048Data}
     * @memberof InlineResponse20048
     */
    data?: InlineResponse20048Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20048Data
 */
export interface InlineResponse20048Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20048Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<RefundResponse>}
     * @memberof InlineResponse20048Data
     */
    data?: Array<RefundResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20049
 */
export interface InlineResponse20049 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20049
     */
    success?: boolean;
    /**
     * 
     * @type {RefundResponse}
     * @memberof InlineResponse20049
     */
    data?: RefundResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2005
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse2005Data}
     * @memberof InlineResponse2005
     */
    data?: InlineResponse2005Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20050
 */
export interface InlineResponse20050 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20050
     */
    success?: boolean;
    /**
     * 
     * @type {ReferrerResponse}
     * @memberof InlineResponse20050
     */
    data?: ReferrerResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20051
 */
export interface InlineResponse20051 {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20051
     */
    pagination: Pagination;
    /**
     * active referral merchant count
     * @type {number}
     * @memberof InlineResponse20051
     */
    available: number;
    /**
     * 
     * @type {InlineResponse20051Referrals}
     * @memberof InlineResponse20051
     */
    referrals: InlineResponse20051Referrals;
}
/**
 * 
 * @export
 * @interface InlineResponse20051Referrals
 */
export interface InlineResponse20051Referrals {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20051Referrals
     */
    id: string;
    /**
     * Merchant\'s email
     * @type {string}
     * @memberof InlineResponse20051Referrals
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20051Referrals
     */
    is_active?: boolean;
    /**
     * posted transaction count
     * @type {number}
     * @memberof InlineResponse20051Referrals
     */
    total_transactions: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20051Referrals
     */
    created_at?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20052
 */
export interface InlineResponse20052 {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20052
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<InlineResponse20052Data>}
     * @memberof InlineResponse20052
     */
    data: Array<InlineResponse20052Data>;
}
/**
 * 
 * @export
 * @interface InlineResponse20052Data
 */
export interface InlineResponse20052Data {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20052Data
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20052Data
     */
    url: string;
    /**
     * Referral link expiration date
     * @type {string}
     * @memberof InlineResponse20052Data
     */
    expires_at: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20053
 */
export interface InlineResponse20053 {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20053
     */
    pagination: Pagination;
    /**
     * 
     * @type {InlineResponse20053Data}
     * @memberof InlineResponse20053
     */
    data: InlineResponse20053Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20053Data
 */
export interface InlineResponse20053Data {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20053Data
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20053Data
     */
    url: string;
    /**
     * Referral link expiration date
     * @type {string}
     * @memberof InlineResponse20053Data
     */
    expires_at: string;
}
/**
 * 
 * @export
 * @interface InlineResponse20054
 */
export interface InlineResponse20054 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20054
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20054Data}
     * @memberof InlineResponse20054
     */
    data?: InlineResponse20054Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20054Data
 */
export interface InlineResponse20054Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20054Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<WidgetResponse>}
     * @memberof InlineResponse20054Data
     */
    data?: Array<WidgetResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20055
 */
export interface InlineResponse20055 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20055
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetResponse}
     * @memberof InlineResponse20055
     */
    data?: WidgetResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20056
 */
export interface InlineResponse20056 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20056
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20056Data}
     * @memberof InlineResponse20056
     */
    data?: InlineResponse20056Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20056Data
 */
export interface InlineResponse20056Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20056Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<WidgetTransactionResponse>}
     * @memberof InlineResponse20056Data
     */
    data?: Array<WidgetTransactionResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20057
 */
export interface InlineResponse20057 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20057
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetAuthCodeResponse}
     * @memberof InlineResponse20057
     */
    data?: WidgetAuthCodeResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20058
 */
export interface InlineResponse20058 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20058
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetAuthResponse}
     * @memberof InlineResponse20058
     */
    data?: WidgetAuthResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20059
 */
export interface InlineResponse20059 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20059
     */
    success?: boolean;
    /**
     * Widget limits
     * @type {{ [key: string]: WidgetLimitItem; }}
     * @memberof InlineResponse20059
     */
    data?: { [key: string]: WidgetLimitItem; };
}
/**
 * 
 * @export
 * @interface InlineResponse2005Data
 */
export interface InlineResponse2005Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse2005Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<DepositPaymentResponse>}
     * @memberof InlineResponse2005Data
     */
    data?: Array<DepositPaymentResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2006
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse2006Data}
     * @memberof InlineResponse2006
     */
    data?: InlineResponse2006Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20060
 */
export interface InlineResponse20060 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20060
     */
    success?: boolean;
    /**
     * Widget limits for unverified users
     * @type {{ [key: string]: WidgetLimitUnverifiedItem; }}
     * @memberof InlineResponse20060
     */
    data?: { [key: string]: WidgetLimitUnverifiedItem; };
}
/**
 * 
 * @export
 * @interface InlineResponse20061
 */
export interface InlineResponse20061 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20061
     */
    success?: boolean;
    /**
     * 
     * @type {Array<WidgetCurrencyResponse>}
     * @memberof InlineResponse20061
     */
    data?: Array<WidgetCurrencyResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20062
 */
export interface InlineResponse20062 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20062
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetAuthRefreshTokenResponse}
     * @memberof InlineResponse20062
     */
    data?: WidgetAuthRefreshTokenResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20063
 */
export interface InlineResponse20063 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20063
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetBuyRatesResponse}
     * @memberof InlineResponse20063
     */
    data?: WidgetBuyRatesResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20064
 */
export interface InlineResponse20064 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20064
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetBuyResponse}
     * @memberof InlineResponse20064
     */
    data?: WidgetBuyResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20065
 */
export interface InlineResponse20065 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20065
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetTransactionResponse}
     * @memberof InlineResponse20065
     */
    data?: WidgetTransactionResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20066
 */
export interface InlineResponse20066 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20066
     */
    success?: boolean;
    /**
     * 
     * @type {InlineResponse20066Data}
     * @memberof InlineResponse20066
     */
    data?: InlineResponse20066Data;
}
/**
 * 
 * @export
 * @interface InlineResponse20066Data
 */
export interface InlineResponse20066Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse20066Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<OnRampPaymentResponse>}
     * @memberof InlineResponse20066Data
     */
    data?: Array<OnRampPaymentResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse20067
 */
export interface InlineResponse20067 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20067
     */
    success?: boolean;
    /**
     * 
     * @type {OnRampPaymentResponse}
     * @memberof InlineResponse20067
     */
    data?: OnRampPaymentResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse20068
 */
export interface InlineResponse20068 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20068
     */
    success?: boolean;
    /**
     * 
     * @type {WidgetKYCResponse}
     * @memberof InlineResponse20068
     */
    data?: WidgetKYCResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2006Data
 */
export interface InlineResponse2006Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse2006Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<CheckoutResponse>}
     * @memberof InlineResponse2006Data
     */
    data?: Array<CheckoutResponse>;
}
/**
 * 
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2007
     */
    success?: boolean;
    /**
     * 
     * @type {CheckoutResponse}
     * @memberof InlineResponse2007
     */
    data?: CheckoutResponse;
}
/**
 * 
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2008
     */
    cache_id?: string;
    /**
     * 
     * @type {object}
     * @memberof InlineResponse2008
     */
    versions?: object;
}
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse2009
     */
    success?: boolean;
}
/**
 * 
 * @export
 * @interface InlineResponse200Data
 */
export interface InlineResponse200Data {
    /**
     * 
     * @type {Pagination}
     * @memberof InlineResponse200Data
     */
    pagination?: Pagination;
    /**
     * 
     * @type {Array<ChargeResponse>}
     * @memberof InlineResponse200Data
     */
    data?: Array<ChargeResponse>;
}
/**
 * 
 * @export
 * @interface InvoiceResponse
 */
export interface InvoiceResponse {
    /**
     * Unique identifier for the object
     * @type {string}
     * @memberof InvoiceResponse
     */
    id?: string;
    /**
     * ID of project
     * @type {string}
     * @memberof InvoiceResponse
     */
    project_id?: string;
    /**
     * 
     * @type {V20InvoicesFiatPrice}
     * @memberof InvoiceResponse
     */
    fiat_price?: V20InvoicesFiatPrice;
    /**
     * The customer’s full name or business name
     * @type {string}
     * @memberof InvoiceResponse
     */
    customer_name?: string;
    /**
     * Customer’s email address
     * @type {string}
     * @memberof InvoiceResponse
     */
    customer_email?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponse
     */
    status?: InvoiceResponseStatusEnum;
    /**
     * Time at which the object was created
     * @type {string}
     * @memberof InvoiceResponse
     */
    created_at?: string;
    /**
     * Time at which the object was updated
     * @type {string}
     * @memberof InvoiceResponse
     */
    updated_at?: string;
    /**
     * Time at which the object was voided
     * @type {string}
     * @memberof InvoiceResponse
     */
    void_at?: string | null;
    /**
     * 
     * @type {InvoiceResponseHosted}
     * @memberof InvoiceResponse
     */
    hosted?: InvoiceResponseHosted;
    /**
     * 
     * @type {ChargeResponse}
     * @memberof InvoiceResponse
     */
    charge?: ChargeResponse;
}

/**
    * @export
    * @enum {string}
    */
export enum InvoiceResponseStatusEnum {
    Open = 'open',
    Viewed = 'viewed',
    Paid = 'paid',
    Void = 'void',
    Unresolved = 'unresolved'
}

/**
 * 
 * @export
 * @interface InvoiceResponseHosted
 */
export interface InvoiceResponseHosted {
    /**
     * 
     * @type {string}
     * @memberof InvoiceResponseHosted
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface KYBUrlResponse
 */
export interface KYBUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof KYBUrlResponse
     */
    url: string;
}
/**
 * No data returns in case if the merchant has no operations
 * @export
 * @interface LimitsResponse
 */
export interface LimitsResponse {
    /**
     * 
     * @type {string}
     * @memberof LimitsResponse
     */
    network: LimitsResponseNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof LimitsResponse
     */
    symbol: LimitsResponseSymbolEnum;
    /**
     * 
     * @type {Turnover}
     * @memberof LimitsResponse
     */
    turnover: Turnover;
}

/**
    * @export
    * @enum {string}
    */
export enum LimitsResponseNetworkEnum {
    Fiat = 'fiat'
}
/**
    * @export
    * @enum {string}
    */
export enum LimitsResponseSymbolEnum {
    Usd = 'USD'
}

/**
 * 
 * @export
 * @interface MassPayoutJsonCreate
 */
export interface MassPayoutJsonCreate {
    /**
     * Unique ID of mass payout (UUID format)
     * @type {string}
     * @memberof MassPayoutJsonCreate
     */
    id: string;
    /**
     * Merchant\'s external ID for mass payout.
     * @type {string}
     * @memberof MassPayoutJsonCreate
     */
    external_id?: string;
    /**
     * Merchant\'s callback URL.
     * @type {string}
     * @memberof MassPayoutJsonCreate
     */
    callback_url?: string;
    /**
     * Fee payer.
     * @type {string}
     * @memberof MassPayoutJsonCreate
     */
    fee_payer?: MassPayoutJsonCreateFeePayerEnum;
    /**
     * List of payout objects.
     * @type {Array<MassPayoutJsonCreatePayouts>}
     * @memberof MassPayoutJsonCreate
     */
    payouts: Array<MassPayoutJsonCreatePayouts>;
    /**
     * OTP code (if enabled)
     * @type {string}
     * @memberof MassPayoutJsonCreate
     */
    otp?: string;
    /**
     * whether mass payout sending should be confirmed with [/send](#/MassPayouts/send) call.
     * @type {boolean}
     * @memberof MassPayoutJsonCreate
     */
    with_confirmation?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum MassPayoutJsonCreateFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * 
 * @export
 * @interface MassPayoutJsonCreatePayouts
 */
export interface MassPayoutJsonCreatePayouts {
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof MassPayoutJsonCreatePayouts
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof MassPayoutJsonCreatePayouts
     */
    symbol: SymbolCrypto;
    /**
     * Crypto address.
     * @type {string}
     * @memberof MassPayoutJsonCreatePayouts
     */
    address: string;
    /**
     * Amount to send.
     * @type {string}
     * @memberof MassPayoutJsonCreatePayouts
     */
    amount: string;
    /**
     * Merchant\'s external ID for this payout.
     * @type {string}
     * @memberof MassPayoutJsonCreatePayouts
     */
    external_id?: string;
}
/**
 * single payout from a mass payout
 * @export
 * @interface MassPayoutPayoutResponse
 */
export interface MassPayoutPayoutResponse {
    /**
     * 
     * @type {string}
     * @memberof MassPayoutPayoutResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutPayoutResponse
     */
    status: MassPayoutPayoutResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutPayoutResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutPayoutResponse
     */
    callback_url?: string;
    /**
     * 
     * @type {PayoutError}
     * @memberof MassPayoutPayoutResponse
     */
    error?: PayoutError;
    /**
     * 
     * @type {WithdrawalResponseTravelRule}
     * @memberof MassPayoutPayoutResponse
     */
    travel_rule?: WithdrawalResponseTravelRule;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutPayoutResponse
     */
    created_at?: string;
    /**
     * 
     * @type {WithdrawalResponseData}
     * @memberof MassPayoutPayoutResponse
     */
    data: WithdrawalResponseData;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutPayoutResponse
     */
    mass_payout_id: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MassPayoutPayoutResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Failed = 'failed',
    Completed = 'completed',
    Cancelled = 'cancelled'
}

/**
 * 
 * @export
 * @interface MassPayoutPayoutResponseAllOf
 */
export interface MassPayoutPayoutResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof MassPayoutPayoutResponseAllOf
     */
    mass_payout_id: string;
}
/**
 * 
 * @export
 * @interface MassPayoutResponse
 */
export interface MassPayoutResponse {
    /**
     * ID of mass payout.
     * @type {string}
     * @memberof MassPayoutResponse
     */
    id: string;
    /**
     * Status of mass payout.
     * @type {string}
     * @memberof MassPayoutResponse
     */
    status: MassPayoutResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponse
     */
    fee_payer: MassPayoutResponseFeePayerEnum;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponse
     */
    external_id?: string;
    /**
     * List of payouts related to this mass payout.
     * @type {Array<MassPayoutResponsePayouts>}
     * @memberof MassPayoutResponse
     */
    payouts: Array<MassPayoutResponsePayouts>;
    /**
     * Mass payout creation date.
     * @type {string}
     * @memberof MassPayoutResponse
     */
    created_at?: string;
    /**
     * Mass payout expiration date (if present).
     * @type {string}
     * @memberof MassPayoutResponse
     */
    expires_at?: string;
    /**
     * 
     * @type {Array<SummaryItem>}
     * @memberof MassPayoutResponse
     */
    summary?: Array<SummaryItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum MassPayoutResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Processed = 'processed'
}
/**
    * @export
    * @enum {string}
    */
export enum MassPayoutResponseFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * 
 * @export
 * @interface MassPayoutResponsePayouts
 */
export interface MassPayoutResponsePayouts {
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponsePayouts
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponsePayouts
     */
    status?: MassPayoutResponsePayoutsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponsePayouts
     */
    ext_tx_id?: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof MassPayoutResponsePayouts
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof MassPayoutResponsePayouts
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponsePayouts
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponsePayouts
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponsePayouts
     */
    callback_url?: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutResponsePayouts
     */
    external_id?: string;
    /**
     * 
     * @type {Fee}
     * @memberof MassPayoutResponsePayouts
     */
    fees?: Fee | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MassPayoutResponsePayoutsStatusEnum {
    New = 'new',
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed',
    Cancelled = 'cancelled'
}

/**
 * mass payout container without inner payouts
 * @export
 * @interface MassPayoutShort
 */
export interface MassPayoutShort {
    /**
     * 
     * @type {string}
     * @memberof MassPayoutShort
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutShort
     */
    status: MassPayoutShortStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutShort
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutShort
     */
    fee_payer: MassPayoutShortFeePayerEnum;
    /**
     * 
     * @type {MassPayoutShortStats}
     * @memberof MassPayoutShort
     */
    stats?: MassPayoutShortStats;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutShort
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof MassPayoutShort
     */
    expires_at?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MassPayoutShortStatusEnum {
    New = 'new',
    Pending = 'pending',
    Processed = 'processed'
}
/**
    * @export
    * @enum {string}
    */
export enum MassPayoutShortFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * 
 * @export
 * @interface MassPayoutShortStats
 */
export interface MassPayoutShortStats {
    /**
     * Total number of payouts
     * @type {number}
     * @memberof MassPayoutShortStats
     */
    total: number;
    /**
     * Number of successful payouts
     * @type {number}
     * @memberof MassPayoutShortStats
     */
    sent: number;
    /**
     * Number of failed payouts
     * @type {number}
     * @memberof MassPayoutShortStats
     */
    failed: number;
}
/**
 * 
 * @export
 * @interface MerchantPrice
 */
export interface MerchantPrice {
    /**
     * 
     * @type {string}
     * @memberof MerchantPrice
     */
    network?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantPrice
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantPrice
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantPrice
     */
    amount_rest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantPrice
     */
    amount_paid?: string;
}
/**
 * 
 * @export
 * @interface MerchantResponse
 */
export interface MerchantResponse {
    /**
     * 
     * @type {string}
     * @memberof MerchantResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponse
     */
    user_type?: MerchantResponseUserTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MerchantResponse
     */
    kyb_level?: number;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponse
     */
    ticker?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantResponse
     */
    is_confirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantResponse
     */
    is_otp_enabled?: boolean;
    /**
     * Callback URL for payouts
     * @type {string}
     * @memberof MerchantResponse
     */
    callback_url?: string;
    /**
     * Signature key for payout callback
     * @type {string}
     * @memberof MerchantResponse
     */
    callback_signature_key?: string;
    /**
     * 
     * @type {MerchantResponseExchangeTo}
     * @memberof MerchantResponse
     */
    exchange_to?: MerchantResponseExchangeTo;
    /**
     * 
     * @type {MerchantResponseFiatWithdrawalTransfers}
     * @memberof MerchantResponse
     */
    fiat_withdrawal_transfers?: MerchantResponseFiatWithdrawalTransfers;
    /**
     * 
     * @type {MerchantResponseResolveCharges}
     * @memberof MerchantResponse
     */
    resolve_charges?: MerchantResponseResolveCharges;
    /**
     * 
     * @type {MerchantResponseDetails}
     * @memberof MerchantResponse
     */
    details?: MerchantResponseDetails | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponse
     */
    referral_link_id?: string | null;
    /**
     * A flag indicating whether widgets are enabled for this merchant.
     * @type {boolean}
     * @memberof MerchantResponse
     */
    is_widgets_enabled?: boolean;
    /**
     * 
     * @type {SubmerchantResponse}
     * @memberof MerchantResponse
     */
    submerchant?: SubmerchantResponse;
}

/**
    * @export
    * @enum {string}
    */
export enum MerchantResponseUserTypeEnum {
    Merchant = 'merchant',
    Referrer = 'referrer'
}

/**
 * 
 * @export
 * @interface MerchantResponseDetails
 */
export interface MerchantResponseDetails {
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseDetails
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseDetails
     */
    company_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseDetails
     */
    company_website?: string;
    /**
     * 
     * @type {Array<ReferrerResponseDetailsContacts>}
     * @memberof MerchantResponseDetails
     */
    contacts?: Array<ReferrerResponseDetailsContacts>;
}
/**
 * 
 * @export
 * @interface MerchantResponseExchangeTo
 */
export interface MerchantResponseExchangeTo {
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseExchangeTo
     */
    network?: MerchantResponseExchangeToNetworkEnum;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseExchangeTo
     */
    symbol?: MerchantResponseExchangeToSymbolEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantResponseExchangeTo
     */
    possible_to_change?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseExchangeTo
     */
    changed_at?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MerchantResponseExchangeToNetworkEnum {
    Fiat = 'fiat',
    Tron = 'tron'
}
/**
    * @export
    * @enum {string}
    */
export enum MerchantResponseExchangeToSymbolEnum {
    Usd = 'USD',
    Eur = 'EUR',
    Usdt = 'USDT'
}

/**
 * 
 * @export
 * @interface MerchantResponseFiatWithdrawalTransfers
 */
export interface MerchantResponseFiatWithdrawalTransfers {
    /**
     * 
     * @type {MerchantResponseFiatWithdrawalTransfersSepa}
     * @memberof MerchantResponseFiatWithdrawalTransfers
     */
    sepa?: MerchantResponseFiatWithdrawalTransfersSepa;
    /**
     * 
     * @type {MerchantResponseFiatWithdrawalTransfersSwift}
     * @memberof MerchantResponseFiatWithdrawalTransfers
     */
    swift?: MerchantResponseFiatWithdrawalTransfersSwift;
}
/**
 * 
 * @export
 * @interface MerchantResponseFiatWithdrawalTransfersSepa
 */
export interface MerchantResponseFiatWithdrawalTransfersSepa {
    /**
     * 
     * @type {MerchantResponseFiatWithdrawalTransfersSepaFees}
     * @memberof MerchantResponseFiatWithdrawalTransfersSepa
     */
    fees?: MerchantResponseFiatWithdrawalTransfersSepaFees;
}
/**
 * 
 * @export
 * @interface MerchantResponseFiatWithdrawalTransfersSepaFees
 */
export interface MerchantResponseFiatWithdrawalTransfersSepaFees {
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseFiatWithdrawalTransfersSepaFees
     */
    percent?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseFiatWithdrawalTransfersSepaFees
     */
    fix?: string;
}
/**
 * 
 * @export
 * @interface MerchantResponseFiatWithdrawalTransfersSwift
 */
export interface MerchantResponseFiatWithdrawalTransfersSwift {
    /**
     * 
     * @type {MerchantResponseFiatWithdrawalTransfersSwiftFees}
     * @memberof MerchantResponseFiatWithdrawalTransfersSwift
     */
    fees?: MerchantResponseFiatWithdrawalTransfersSwiftFees;
}
/**
 * 
 * @export
 * @interface MerchantResponseFiatWithdrawalTransfersSwiftFees
 */
export interface MerchantResponseFiatWithdrawalTransfersSwiftFees {
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseFiatWithdrawalTransfersSwiftFees
     */
    percent?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantResponseFiatWithdrawalTransfersSwiftFees
     */
    fix?: string;
}
/**
 * 
 * @export
 * @interface MerchantResponseResolveCharges
 */
export interface MerchantResponseResolveCharges {
    /**
     * 
     * @type {boolean}
     * @memberof MerchantResponseResolveCharges
     */
    underpaid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantResponseResolveCharges
     */
    overpaid?: boolean;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    target?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    message?: string;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ModelError
     */
    errors?: Array<Error>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum NetworkAll {
    Fiat = 'fiat',
    Ethereum = 'ethereum',
    Bitcoin = 'bitcoin',
    Litecoin = 'litecoin',
    Bsc = 'bsc',
    Tron = 'tron',
    Polygon = 'polygon',
    Ton = 'ton',
    Arbitrum = 'arbitrum',
    Card = 'card',
    Bank = 'bank'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum NetworkCrypto {
    Ethereum = 'ethereum',
    Bitcoin = 'bitcoin',
    Litecoin = 'litecoin',
    Bsc = 'bsc',
    Tron = 'tron',
    Polygon = 'polygon',
    Ton = 'ton',
    Arbitrum = 'arbitrum'
}

/**
 * 
 * @export
 * @interface OnRampCreatePaymentRequest
 */
export interface OnRampCreatePaymentRequest {
    /**
     * Unique payment UUID (idempotency key)
     * @type {string}
     * @memberof OnRampCreatePaymentRequest
     */
    id: string;
    /**
     * ID of project
     * @type {string}
     * @memberof OnRampCreatePaymentRequest
     */
    project_id: string;
    /**
     * Fiat amount to spend
     * @type {string}
     * @memberof OnRampCreatePaymentRequest
     */
    fiat_amount: string;
    /**
     * Fiat currency symbol (e.g. USD, EUR)
     * @type {string}
     * @memberof OnRampCreatePaymentRequest
     */
    fiat_symbol: string;
    /**
     * Merchant-side reference ID
     * @type {string}
     * @memberof OnRampCreatePaymentRequest
     */
    external_id?: string;
    /**
     * URL to receive payment status updates. Takes priority over the project\'s configured callback URL.
     * @type {string}
     * @memberof OnRampCreatePaymentRequest
     */
    callback_url?: string;
    /**
     * URL to redirect the customer back to after payment. Takes priority over the project\'s configured return URL.
     * @type {string}
     * @memberof OnRampCreatePaymentRequest
     */
    return_url?: string;
    /**
     * 
     * @type {OnRampCustomer}
     * @memberof OnRampCreatePaymentRequest
     */
    customer: OnRampCustomer;
}
/**
 * 
 * @export
 * @interface OnRampCustomer
 */
export interface OnRampCustomer {
    /**
     * 
     * @type {string}
     * @memberof OnRampCustomer
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OnRampCustomer
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof OnRampCustomer
     */
    email: string;
}
/**
 * Error details returned when an on-ramp payment operation is declined or fails. Code and message are passed through unmodified from the payment gateway.
 * @export
 * @interface OnRampPaymentError
 */
export interface OnRampPaymentError {
    /**
     * Raw numeric response code from payment gateway, passed through unmodified (no internal mapping).  Code ranges:   - 0 - success   - 100-9999 - general operation/validation codes   - 1400-1499 - Risk Control System (RCS) codes   - 10000-19999 - external card payment system codes   - 20000-29999 - external alternative payment system codes   - 30000-30999 - merchant web service codes  Full reference in guides section of documentation. 
     * @type {number}
     * @memberof OnRampPaymentError
     */
    code?: number;
    /**
     * Human-readable error message from the payment gateway, corresponding to the code above.
     * @type {string}
     * @memberof OnRampPaymentError
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface OnRampPaymentResponse
 */
export interface OnRampPaymentResponse {
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    project_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    status?: OnRampPaymentResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    network?: string;
    /**
     * Cryptocurrency amount
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    fiat_symbol?: string;
    /**
     * Fiat amount charged
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    fiat_amount?: string;
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    external_id?: string;
    /**
     * Payment page URL for the end customer
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    pp_url?: string;
    /**
     * Resolved callback URL (payment\'s own value, or the project\'s configured callback URL as fallback)
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    callback_url?: string;
    /**
     * Resolved return URL (payment\'s own value, or the project\'s configured return URL as fallback)
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    return_url?: string;
    /**
     * 
     * @type {OnRampCustomer}
     * @memberof OnRampPaymentResponse
     */
    customer?: OnRampCustomer;
    /**
     * 
     * @type {OnRampPaymentError}
     * @memberof OnRampPaymentResponse
     */
    error?: OnRampPaymentError;
    /**
     * 
     * @type {string}
     * @memberof OnRampPaymentResponse
     */
    created_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum OnRampPaymentResponseStatusEnum {
    Pending = 'pending',
    Processing = 'processing',
    Completed = 'completed',
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {string}
     * @memberof Pagination
     */
    order: PaginationOrderEnum;
    /**
     * Total number of records.
     * @type {number}
     * @memberof Pagination
     */
    total: number;
    /**
     * A limit on the number of objects to be returned, between 1 and 100.
     * @type {number}
     * @memberof Pagination
     */
    limit: number;
    /**
     * The number of items to skip before starting to collect the result set.
     * @type {number}
     * @memberof Pagination
     */
    offset: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PaginationOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}

/**
 * 
 * @export
 * @interface PayinCallback
 */
export interface PayinCallback {
    /**
     * 
     * @type {string}
     * @memberof PayinCallback
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PayinCallback
     */
    type: string;
    /**
     * 
     * @type {PayinCallbackData}
     * @memberof PayinCallback
     */
    data: PayinCallbackData;
    /**
     * 
     * @type {string}
     * @memberof PayinCallback
     */
    created_at: string;
}
/**
 * 
 * @export
 * @interface PayinCallbackData
 */
export interface PayinCallbackData {
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    id: string;
    /**
     * The charge\'s name, meant to be displayable to the customer
     * @type {string}
     * @memberof PayinCallbackData
     */
    name: string;
    /**
     * The charge\'s description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes
     * @type {string}
     * @memberof PayinCallbackData
     */
    description: string;
    /**
     * ID of project
     * @type {string}
     * @memberof PayinCallbackData
     */
    project_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    pricing_type: string;
    /**
     * Is auto resolve if amount less than what was requested
     * @type {boolean}
     * @memberof PayinCallbackData
     */
    is_resolve_underpaid?: boolean | null;
    /**
     * Is auto resolve if amount more than what was requested
     * @type {boolean}
     * @memberof PayinCallbackData
     */
    is_resolve_overpaid?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    external_id: string;
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    context: string | null;
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    completes_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PayinCallbackData
     */
    expires_at: string | null;
    /**
     * ID of checkout
     * @type {string}
     * @memberof PayinCallbackData
     */
    checkout_id?: string | null;
    /**
     * ID of invoice
     * @type {string}
     * @memberof PayinCallbackData
     */
    invoice_id?: string | null;
    /**
     * status change history
     * @type {Array<object>}
     * @memberof PayinCallbackData
     */
    timeline: Array<object>;
    /**
     * 
     * @type {Pricing}
     * @memberof PayinCallbackData
     */
    pricing: Pricing;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof PayinCallbackData
     */
    payments: Array<Payment>;
    /**
     * 
     * @type {Array<EnabledCrypto>}
     * @memberof PayinCallbackData
     */
    enabled_crypto: Array<EnabledCrypto>;
    /**
     * 
     * @type {InitPrice}
     * @memberof PayinCallbackData
     */
    init_price?: InitPrice | null;
    /**
     * 
     * @type {MerchantPrice}
     * @memberof PayinCallbackData
     */
    merchant_price?: MerchantPrice | null;
    /**
     * 
     * @type {HostedResponse}
     * @memberof PayinCallbackData
     */
    hosted?: HostedResponse;
}
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * Unique identifier for the object
     * @type {string}
     * @memberof Payment
     */
    id: string;
    /**
     * ID of charge
     * @type {string}
     * @memberof Payment
     */
    charge_id: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    pricing_type?: PaymentPricingTypeEnum;
    /**
     * ID of blockchain
     * @type {string}
     * @memberof Payment
     */
    tx_id: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof Payment
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof Payment
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    address_from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    address_to: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     * @deprecated
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    status: PaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    aml_level?: PaymentAmlLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    detected_at: string;
    /**
     * 
     * @type {PaymentExchange}
     * @memberof Payment
     */
    exchange?: PaymentExchange;
    /**
     * ID of refund
     * @type {string}
     * @memberof Payment
     */
    refund_id?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentPricingTypeEnum {
    FixedPrice = 'fixed_price',
    NoPrice = 'no_price',
    Deposit = 'deposit',
    Topup = 'topup'
}
/**
    * @export
    * @enum {string}
    */
export enum PaymentStatusEnum {
    Pending = 'pending',
    Confirmed = 'confirmed',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum PaymentAmlLevelEnum {
    Low = 'low',
    Medium = 'medium',
    High = 'high'
}

/**
 * 
 * @export
 * @interface PaymentExchange
 */
export interface PaymentExchange {
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof PaymentExchange
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof PaymentExchange
     */
    symbol?: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof PaymentExchange
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentExchange
     */
    rate?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentExchange
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentExchange
     */
    is_real_exchanged?: boolean;
}
/**
 * 
 * @export
 * @interface PayoutCallback
 */
export interface PayoutCallback {
    /**
     * 
     * @type {string}
     * @memberof PayoutCallback
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallback
     */
    type: string;
    /**
     * 
     * @type {PayoutCallbackData}
     * @memberof PayoutCallback
     */
    data: PayoutCallbackData;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallback
     */
    created_at: string;
}
/**
 * 
 * @export
 * @interface PayoutCallbackData
 */
export interface PayoutCallbackData {
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    id: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof PayoutCallbackData
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof PayoutCallbackData
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof PayoutCallbackData
     */
    amount: number;
    /**
     * 
     * @type {PayoutResponseDataFromFiat}
     * @memberof PayoutCallbackData
     */
    from_fiat?: PayoutResponseDataFromFiat;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    ext_tx_id: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    callback_url: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    external_id: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    mass_payout_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    fee_payer: PayoutCallbackDataFeePayerEnum;
    /**
     * 
     * @type {Fee}
     * @memberof PayoutCallbackData
     */
    fees?: Fee | null;
    /**
     * 
     * @type {PayoutError}
     * @memberof PayoutCallbackData
     */
    error?: PayoutError;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutCallbackData
     */
    updated_at: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PayoutCallbackDataFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * @type PayoutCreate
 * request body for creating a crypto payout
 * @export
 */
export type PayoutCreate = any;

/**
 * error object for failed withdrawal
 * @export
 * @interface PayoutError
 */
export interface PayoutError {
    /**
     * Payout processing error code.  Available code list:   - 1000 - internal processing error.   - 1001 - payout limit exceeded.   - 1002 - insufficient balance.   - 1003 - AML check failed. 
     * @type {number}
     * @memberof PayoutError
     */
    code: number;
    /**
     * error description
     * @type {string}
     * @memberof PayoutError
     */
    message: string;
}
/**
 * 
 * @export
 * @interface PayoutResponse
 */
export interface PayoutResponse {
    /**
     * 
     * @type {string}
     * @memberof PayoutResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponse
     */
    status: PayoutResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponse
     */
    callback_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponse
     */
    mass_payout_id?: string;
    /**
     * 
     * @type {PayoutError}
     * @memberof PayoutResponse
     */
    error?: PayoutError;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponse
     */
    created_at?: string;
    /**
     * 
     * @type {PayoutResponseData}
     * @memberof PayoutResponse
     */
    data: PayoutResponseData;
}

/**
    * @export
    * @enum {string}
    */
export enum PayoutResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Failed = 'failed',
    Completed = 'completed',
    Cancelled = 'cancelled'
}

/**
 * 
 * @export
 * @interface PayoutResponseData
 */
export interface PayoutResponseData {
    /**
     * 
     * @type {string}
     * @memberof PayoutResponseData
     */
    ext_tx_id?: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof PayoutResponseData
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof PayoutResponseData
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponseData
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponseData
     */
    amount: string;
    /**
     * 
     * @type {PayoutResponseDataFromFiat}
     * @memberof PayoutResponseData
     */
    from_fiat?: PayoutResponseDataFromFiat;
    /**
     * 
     * @type {string}
     * @memberof PayoutResponseData
     */
    fee_payer?: PayoutResponseDataFeePayerEnum;
    /**
     * 
     * @type {Fee}
     * @memberof PayoutResponseData
     */
    fees?: Fee | null;
}

/**
    * @export
    * @enum {string}
    */
export enum PayoutResponseDataFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * Original fiat amount used to calculate the crypto payout amount.
 * @export
 * @interface PayoutResponseDataFromFiat
 */
export interface PayoutResponseDataFromFiat {
    /**
     * 
     * @type {string}
     * @memberof PayoutResponseDataFromFiat
     */
    amount: string;
    /**
     * Three-letter ISO currency code, in uppercase
     * @type {string}
     * @memberof PayoutResponseDataFromFiat
     */
    symbol: string;
}
/**
 * 
 * @export
 * @interface Pricing
 */
export interface Pricing {
    /**
     * 
     * @type {PricingTronTRX}
     * @memberof Pricing
     */
    tron_TRX?: PricingTronTRX;
}
/**
 * 
 * @export
 * @interface PricingTronTRX
 */
export interface PricingTronTRX {
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof PricingTronTRX
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof PricingTronTRX
     */
    symbol?: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof PricingTronTRX
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof PricingTronTRX
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PricingTronTRX
     */
    rate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PricingTronTRX
     */
    amount_rest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PricingTronTRX
     */
    amount_paid?: string;
}
/**
 * 
 * @export
 * @interface ProjectRequest
 */
export interface ProjectRequest {
    /**
     * The project\'s name.
     * @type {string}
     * @memberof ProjectRequest
     */
    name: string;
    /**
     * A description of what the project is used for.
     * @type {string}
     * @memberof ProjectRequest
     */
    description: string;
    /**
     * The list of cryptocurrencies to enable for this project.
     * @type {Array<EnabledCrypto>}
     * @memberof ProjectRequest
     */
    enabled_crypto: Array<EnabledCrypto>;
    /**
     * The status of the project. It can be active or inactive.
     * @type {string}
     * @memberof ProjectRequest
     */
    status: ProjectRequestStatusEnum;
    /**
     * The URL of the callback endpoint.
     * @type {string}
     * @memberof ProjectRequest
     */
    callback_url?: string | null;
    /**
     * The URL to redirect your customer back to after they authenticate or cancel their payment.
     * @type {string}
     * @memberof ProjectRequest
     */
    return_url?: string | null;
    /**
     * The theme of the payment page. It can be light or dark.
     * @type {string}
     * @memberof ProjectRequest
     */
    theme?: ProjectRequestThemeEnum;
    /**
     * 
     * @type {ProjectRequestLogo}
     * @memberof ProjectRequest
     */
    logo?: ProjectRequestLogo;
    /**
     * 
     * @type {ProjectRequestImage}
     * @memberof ProjectRequest
     */
    image?: ProjectRequestImage;
}

/**
    * @export
    * @enum {string}
    */
export enum ProjectRequestStatusEnum {
    Active = 'active',
    Inactive = 'inactive'
}
/**
    * @export
    * @enum {string}
    */
export enum ProjectRequestThemeEnum {
    Light = 'light',
    Dark = 'dark'
}

/**
 * An image for the project that will be used in payment page.
 * @export
 * @interface ProjectRequestImage
 */
export interface ProjectRequestImage {
    /**
     * ID of a file upload /cache/image
     * @type {string}
     * @memberof ProjectRequestImage
     */
    cache_id?: string;
}
/**
 * A logo for the project that will be used in payment page.
 * @export
 * @interface ProjectRequestLogo
 */
export interface ProjectRequestLogo {
    /**
     * ID of a file upload /cache/logo
     * @type {string}
     * @memberof ProjectRequestLogo
     */
    cache_id?: string;
}
/**
 * 
 * @export
 * @interface ProjectResponse
 */
export interface ProjectResponse {
    /**
     * Unique identifier for the object.
     * @type {string}
     * @memberof ProjectResponse
     */
    id?: string;
    /**
     * The project\'s name.
     * @type {string}
     * @memberof ProjectResponse
     */
    name?: string;
    /**
     * A description of what the project is used for.
     * @type {string}
     * @memberof ProjectResponse
     */
    description?: string;
    /**
     * The list of cryptocurrencies to enable for this project.
     * @type {Array<EnabledCrypto>}
     * @memberof ProjectResponse
     */
    enabled_crypto?: Array<EnabledCrypto>;
    /**
     * The status of the project. It can be active or inactive.
     * @type {string}
     * @memberof ProjectResponse
     */
    status?: ProjectResponseStatusEnum;
    /**
     * The URL of the callback endpoint.
     * @type {string}
     * @memberof ProjectResponse
     */
    callback_url?: string | null;
    /**
     * A key will be randomly generated.
     * @type {string}
     * @memberof ProjectResponse
     */
    callback_signature_key?: string;
    /**
     * 
     * @type {ProjectResponseLogo}
     * @memberof ProjectResponse
     */
    logo?: ProjectResponseLogo;
    /**
     * 
     * @type {ProjectResponseImage}
     * @memberof ProjectResponse
     */
    image?: ProjectResponseImage;
    /**
     * 
     * @type {ProjectResponseHosted}
     * @memberof ProjectResponse
     */
    hosted?: ProjectResponseHosted;
    /**
     * Time at which the object was created.
     * @type {string}
     * @memberof ProjectResponse
     */
    created_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProjectResponseStatusEnum {
    Active = 'active',
    Inactive = 'inactive'
}

/**
 * 
 * @export
 * @interface ProjectResponseHosted
 */
export interface ProjectResponseHosted {
    /**
     * The URL to redirect your customer back to after they authenticate or cancel their payment.
     * @type {string}
     * @memberof ProjectResponseHosted
     */
    return_url?: string | null;
    /**
     * The theme of the payment page. It can be light or dark.
     * @type {string}
     * @memberof ProjectResponseHosted
     */
    theme?: ProjectResponseHostedThemeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ProjectResponseHostedThemeEnum {
    Light = 'light',
    Dark = 'dark'
}

/**
 * An image for the project that will be used in payment page.
 * @export
 * @interface ProjectResponseImage
 */
export interface ProjectResponseImage {
    /**
     * 
     * @type {ProjectResponseImageVersions}
     * @memberof ProjectResponseImage
     */
    versions?: ProjectResponseImageVersions;
}
/**
 * 
 * @export
 * @interface ProjectResponseImageVersions
 */
export interface ProjectResponseImageVersions {
    /**
     * 
     * @type {string}
     * @memberof ProjectResponseImageVersions
     */
    original?: string;
}
/**
 * A logo for the project that will be used in payment page.
 * @export
 * @interface ProjectResponseLogo
 */
export interface ProjectResponseLogo {
    /**
     * 
     * @type {ProjectResponseLogoVersions}
     * @memberof ProjectResponseLogo
     */
    versions?: ProjectResponseLogoVersions;
}
/**
 * 
 * @export
 * @interface ProjectResponseLogoVersions
 */
export interface ProjectResponseLogoVersions {
    /**
     * 
     * @type {string}
     * @memberof ProjectResponseLogoVersions
     */
    original?: string;
}
/**
 * 
 * @export
 * @interface RatesResponse
 */
export interface RatesResponse {
    /**
     * 
     * @type {string}
     * @memberof RatesResponse
     */
    rate?: string;
    /**
     * 
     * @type {string}
     * @memberof RatesResponse
     */
    amount?: string;
}
/**
 * 
 * @export
 * @interface ReferrerResponse
 */
export interface ReferrerResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    user_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferrerResponse
     */
    is_confirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferrerResponse
     */
    is_otp_enabled?: boolean;
    /**
     * 
     * @type {ReferrerResponseDetails}
     * @memberof ReferrerResponse
     */
    details?: ReferrerResponseDetails | null;
}
/**
 * 
 * @export
 * @interface ReferrerResponseDetails
 */
export interface ReferrerResponseDetails {
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponseDetails
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponseDetails
     */
    company_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponseDetails
     */
    country_code_alpha_3?: string;
    /**
     * 
     * @type {Array<ReferrerResponseDetailsContacts>}
     * @memberof ReferrerResponseDetails
     */
    contacts?: Array<ReferrerResponseDetailsContacts>;
}
/**
 * 
 * @export
 * @interface ReferrerResponseDetailsContacts
 */
export interface ReferrerResponseDetailsContacts {
    /**
     * Property type
     * @type {string}
     * @memberof ReferrerResponseDetailsContacts
     */
    type?: ReferrerResponseDetailsContactsTypeEnum;
    /**
     * Account identifier
     * @type {string}
     * @memberof ReferrerResponseDetailsContacts
     */
    value?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ReferrerResponseDetailsContactsTypeEnum {
    Email = 'email',
    Phone = 'phone',
    Whatsapp = 'whatsapp',
    Telegram = 'telegram',
    Line = 'line'
}

/**
 * request body for creating a refund
 * @export
 * @interface RefundCreate
 */
export interface RefundCreate {
    /**
     * Payment ID for refund
     * @type {string}
     * @memberof RefundCreate
     */
    payment_id: string;
    /**
     * Crypto address for refund
     * @type {string}
     * @memberof RefundCreate
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof RefundCreate
     */
    fee_payer: RefundCreateFeePayerEnum;
    /**
     * Convert [token](#/Converts/get_convert_token). Required when payment amount we are going to refund was converted to another crypto.
     * @type {string}
     * @memberof RefundCreate
     */
    convert_token?: string;
    /**
     * OTP code (if enabled)
     * @type {string}
     * @memberof RefundCreate
     */
    otp: string;
}

/**
    * @export
    * @enum {string}
    */
export enum RefundCreateFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * 
 * @export
 * @interface RefundResponse
 */
export interface RefundResponse {
    /**
     * ID of refund
     * @type {string}
     * @memberof RefundResponse
     */
    id?: string;
    /**
     * ID of payment that was refunded
     * @type {string}
     * @memberof RefundResponse
     */
    payment_id?: string;
    /**
     * ID of charge
     * @type {string}
     * @memberof RefundResponse
     */
    charge_id?: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof RefundResponse
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof RefundResponse
     */
    symbol?: SymbolCrypto;
    /**
     * Refund amount
     * @type {string}
     * @memberof RefundResponse
     */
    amount?: string;
    /**
     * Address refund was sent to
     * @type {string}
     * @memberof RefundResponse
     */
    address_to?: string;
    /**
     * Refund status
     * @type {string}
     * @memberof RefundResponse
     */
    status?: RefundResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    fee_payer?: RefundResponseFeePayerEnum;
    /**
     * Blockchain transaction ID
     * @type {string}
     * @memberof RefundResponse
     */
    tx_id?: string;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    created_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum RefundResponseStatusEnum {
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum RefundResponseFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * request body for creating a report
 * @export
 * @interface ReportCreate
 */
export interface ReportCreate {
    /**
     * Report type. `balance` returns a snapshot of the merchant\'s balances across all currencies/networks and ignores date_from/date_to/project_id.
     * @type {string}
     * @memberof ReportCreate
     */
    type?: ReportCreateTypeEnum;
    /**
     * Start Date
     * @type {string}
     * @memberof ReportCreate
     */
    date_from?: string;
    /**
     * End Date
     * @type {string}
     * @memberof ReportCreate
     */
    date_to?: string;
    /**
     * Filter by Project ID
     * @type {string}
     * @memberof ReportCreate
     */
    project_id?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ReportCreateTypeEnum {
    Transactions = 'transactions',
    Balance = 'balance'
}

/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {boolean}
     * @memberof Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof Response
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof Response
     */
    data?: object;
    /**
     * 
     * @type {Error}
     * @memberof Response
     */
    error?: Error;
}
/**
 * 
 * @export
 * @interface SessionResponse
 */
export interface SessionResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    ip: string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    agent: string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    last_accessed_at: string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponse
     */
    created_at: string;
}
/**
 * 
 * @export
 * @interface SignupDetailsRequest
 */
export interface SignupDetailsRequest {
    /**
     * User type
     * @type {string}
     * @memberof SignupDetailsRequest
     */
    user_type: SignupDetailsRequestUserTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SignupDetailsRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SignupDetailsRequest
     */
    company_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupDetailsRequest
     */
    company_website?: string;
    /**
     * ISO3166 Alpha 3 country code
     * @type {string}
     * @memberof SignupDetailsRequest
     */
    country_code_alpha_3?: string;
    /**
     * 
     * @type {Array<SignupDetailsRequestContacts>}
     * @memberof SignupDetailsRequest
     */
    contacts?: Array<SignupDetailsRequestContacts>;
    /**
     * 
     * @type {SignupDetailsRequestUtms}
     * @memberof SignupDetailsRequest
     */
    utms?: SignupDetailsRequestUtms;
    /**
     * 
     * @type {SignupDetailsRequestFbPixel}
     * @memberof SignupDetailsRequest
     */
    fb_pixel?: SignupDetailsRequestFbPixel;
}

/**
    * @export
    * @enum {string}
    */
export enum SignupDetailsRequestUserTypeEnum {
    Merchant = 'merchant',
    Referrer = 'referrer'
}

/**
 * 
 * @export
 * @interface SignupDetailsRequestContacts
 */
export interface SignupDetailsRequestContacts {
    /**
     * Property type
     * @type {string}
     * @memberof SignupDetailsRequestContacts
     */
    type?: SignupDetailsRequestContactsTypeEnum;
    /**
     * Account identifier
     * @type {string}
     * @memberof SignupDetailsRequestContacts
     */
    value?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SignupDetailsRequestContactsTypeEnum {
    Email = 'email',
    Phone = 'phone',
    Whatsapp = 'whatsapp',
    Telegram = 'telegram',
    Line = 'line'
}

/**
 * 
 * @export
 * @interface SignupDetailsRequestFbPixel
 */
export interface SignupDetailsRequestFbPixel {
    /**
     * The Facebook pixel ID
     * @type {string}
     * @memberof SignupDetailsRequestFbPixel
     */
    fb_pixel?: string;
    /**
     * The Facebook click ID value is stored in the _fbc browser cookie under your domain. The format is: fb.${subdomain_index}.${creation_time}.${fbclid}.
     * @type {string}
     * @memberof SignupDetailsRequestFbPixel
     */
    fb_click?: string;
}
/**
 * 
 * @export
 * @interface SignupDetailsRequestUtms
 */
export interface SignupDetailsRequestUtms {
    /**
     * Identifies which site sent the traffic, and is a required parameter
     * @type {string}
     * @memberof SignupDetailsRequestUtms
     */
    utm_source?: string;
    /**
     * Identifies what type of link was used, such as email or pay-per-click advertising
     * @type {string}
     * @memberof SignupDetailsRequestUtms
     */
    utm_medium?: string;
    /**
     * Identifies a specific product promotion or strategic campaign
     * @type {string}
     * @memberof SignupDetailsRequestUtms
     */
    utm_campaign?: string;
    /**
     * Identifies search terms
     * @type {string}
     * @memberof SignupDetailsRequestUtms
     */
    utm_term?: string;
    /**
     * Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link
     * @type {string}
     * @memberof SignupDetailsRequestUtms
     */
    utm_content?: string;
}
/**
 * 
 * @export
 * @interface SignupRequest
 */
export interface SignupRequest {
    /**
     * Merchant\'s or Referral\'s email
     * @type {string}
     * @memberof SignupRequest
     */
    email: string;
    /**
     * Merchant\'s or Referral\'s password
     * @type {string}
     * @memberof SignupRequest
     */
    password: string;
    /**
     * ReCaptcha token
     * @type {string}
     * @memberof SignupRequest
     */
    re_captcha: string;
    /**
     * Is terms of service and privacy policy accepted?
     * @type {boolean}
     * @memberof SignupRequest
     */
    tos: boolean;
    /**
     * 
     * @type {SignupDetailsRequest}
     * @memberof SignupRequest
     */
    details: SignupDetailsRequest;
    /**
     * Referral code from URL
     * @type {string}
     * @memberof SignupRequest
     */
    referral_link_id?: string;
}
/**
 * 
 * @export
 * @interface SubmerchantRegisterRequest
 */
export interface SubmerchantRegisterRequest {
    /**
     * Merchant\'s or Referral\'s email
     * @type {string}
     * @memberof SubmerchantRegisterRequest
     */
    email: string;
    /**
     * Merchant\'s or Referral\'s password
     * @type {string}
     * @memberof SubmerchantRegisterRequest
     */
    password: string;
    /**
     * Password confirmation
     * @type {string}
     * @memberof SubmerchantRegisterRequest
     */
    confirm_password: string;
    /**
     * Set a submerchant access to the dashboard. \"View\" is the default value.
     * @type {Array<string>}
     * @memberof SubmerchantRegisterRequest
     */
    access_control_groups?: Array<string>;
}
/**
 * 
 * @export
 * @interface SubmerchantResponse
 */
export interface SubmerchantResponse {
    /**
     * 
     * @type {string}
     * @memberof SubmerchantResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmerchantResponse
     */
    merchant_id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmerchantResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SubmerchantResponse
     */
    status: SubmerchantResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SubmerchantResponse
     */
    is_otp_enabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubmerchantResponse
     */
    access_control_groups: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum SubmerchantResponseStatusEnum {
    Pending = 'pending',
    Confirmed = 'confirmed',
    Unconfirmed = 'unconfirmed',
    Blocked = 'blocked'
}

/**
 * 
 * @export
 * @interface SummaryCardItem
 */
export interface SummaryCardItem {
    /**
     * 
     * @type {SymbolCard}
     * @memberof SummaryCardItem
     */
    symbol?: SymbolCard;
    /**
     * 
     * @type {SummaryCardItemTotals}
     * @memberof SummaryCardItem
     */
    totals?: SummaryCardItemTotals;
}
/**
 * 
 * @export
 * @interface SummaryCardItemTotals
 */
export interface SummaryCardItemTotals {
    /**
     * 
     * @type {string}
     * @memberof SummaryCardItemTotals
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryCardItemTotals
     */
    fee: string;
}
/**
 * 
 * @export
 * @interface SummaryItem
 */
export interface SummaryItem {
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof SummaryItem
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof SummaryItem
     */
    symbol?: SymbolCrypto;
    /**
     * 
     * @type {SummaryItemTotals}
     * @memberof SummaryItem
     */
    totals?: SummaryItemTotals;
}
/**
 * 
 * @export
 * @interface SummaryItemTotals
 */
export interface SummaryItemTotals {
    /**
     * 
     * @type {string}
     * @memberof SummaryItemTotals
     */
    amount: string;
    /**
     * 
     * @type {SummaryItemTotalsFees}
     * @memberof SummaryItemTotals
     */
    fees: SummaryItemTotalsFees;
}
/**
 * 
 * @export
 * @interface SummaryItemTotalsFees
 */
export interface SummaryItemTotalsFees {
    /**
     * 
     * @type {string}
     * @memberof SummaryItemTotalsFees
     */
    merchant: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryItemTotalsFees
     */
    customer: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SymbolAll {
    Eur = 'EUR',
    Usd = 'USD',
    Btc = 'BTC',
    Eth = 'ETH',
    Trx = 'TRX',
    Ltc = 'LTC',
    Bnb = 'BNB',
    Usdt = 'USDT',
    Usdt0 = 'USDT0',
    Usdc = 'USDC',
    Eurc = 'EURC',
    Dai = 'DAI',
    Pol = 'POL',
    Ton = 'TON',
    Bscusd = 'BSCUSD',
    Gbp = 'GBP'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SymbolBank {
    Usd = 'USD',
    Cop = 'COP',
    Pen = 'PEN'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SymbolCard {
    Eur = 'EUR',
    Usd = 'USD',
    Gbp = 'GBP'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SymbolCrypto {
    Btc = 'BTC',
    Eth = 'ETH',
    Trx = 'TRX',
    Ltc = 'LTC',
    Bnb = 'BNB',
    Usdt = 'USDT',
    Usdt0 = 'USDT0',
    Usdc = 'USDC',
    Eurc = 'EURC',
    Dai = 'DAI',
    Pol = 'POL',
    Ton = 'TON',
    Bscusd = 'BSCUSD'
}

/**
 * 
 * @export
 * @interface TopupAddressResponse
 */
export interface TopupAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof TopupAddressResponse
     */
    id?: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof TopupAddressResponse
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof TopupAddressResponse
     */
    symbol?: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof TopupAddressResponse
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopupAddressResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupAddressResponse
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface TopupBankAccountDetails
 */
export interface TopupBankAccountDetails {
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountDetails
     */
    beneficiary_account_name: string;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountDetails
     */
    beneficiary_account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountDetails
     */
    beneficiary_address: string;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountDetails
     */
    bank_name: string;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountDetails
     */
    bank_address: string;
    /**
     * BIC/SWIFT code
     * @type {string}
     * @memberof TopupBankAccountDetails
     */
    bic_swift_code: string;
    /**
     * IBAN
     * @type {string}
     * @memberof TopupBankAccountDetails
     */
    iban?: string;
}
/**
 * 
 * @export
 * @interface TopupBankAccountResponse
 */
export interface TopupBankAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountResponse
     */
    transfer?: TopupBankAccountResponseTransferEnum;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountResponse
     */
    currency?: TopupBankAccountResponseCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountResponse
     */
    fee_percent?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupBankAccountResponse
     */
    ticker?: string | null;
    /**
     * 
     * @type {TopupBankAccountDetails}
     * @memberof TopupBankAccountResponse
     */
    details?: TopupBankAccountDetails;
}

/**
    * @export
    * @enum {string}
    */
export enum TopupBankAccountResponseTransferEnum {
    Swift = 'SWIFT',
    Sepa = 'SEPA'
}
/**
    * @export
    * @enum {string}
    */
export enum TopupBankAccountResponseCurrencyEnum {
    Usd = 'USD',
    Eur = 'EUR'
}

/**
 * 
 * @export
 * @interface TopupPaymentResponse
 */
export interface TopupPaymentResponse {
    /**
     * Unique identifier for the object
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    id?: string;
    /**
     * ID of topup
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    topup_id?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    pricing_type?: TopupPaymentResponsePricingTypeEnum;
    /**
     * ID of blockchain
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    tx_id?: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof TopupPaymentResponse
     */
    network?: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof TopupPaymentResponse
     */
    symbol?: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    address_from?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    address_to?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     * @deprecated
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    status?: TopupPaymentResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    aml_level?: TopupPaymentResponseAmlLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    detected_at?: string;
    /**
     * ID of refund
     * @type {string}
     * @memberof TopupPaymentResponse
     */
    refund_id?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum TopupPaymentResponsePricingTypeEnum {
    Topup = 'topup'
}
/**
    * @export
    * @enum {string}
    */
export enum TopupPaymentResponseStatusEnum {
    Pending = 'pending',
    Confirmed = 'confirmed',
    Failed = 'failed'
}
/**
    * @export
    * @enum {string}
    */
export enum TopupPaymentResponseAmlLevelEnum {
    Low = 'low',
    Medium = 'medium',
    High = 'high'
}

/**
 * 
 * @export
 * @interface TransactionResponse
 */
export interface TransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    status: TransactionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    effective_at: string;
    /**
     * 
     * @type {TransactionResponseOperation}
     * @memberof TransactionResponse
     */
    operation: TransactionResponseOperation;
}

/**
    * @export
    * @enum {string}
    */
export enum TransactionResponseStatusEnum {
    Pending = 'pending',
    Posted = 'posted',
    Archived = 'archived'
}

/**
 * 
 * @export
 * @interface TransactionResponseOperation
 */
export interface TransactionResponseOperation {
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperation
     */
    resource: TransactionResponseOperationResourceEnum;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof TransactionResponseOperation
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof TransactionResponseOperation
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperation
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperation
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperation
     */
    ext_tx_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperation
     */
    project_id?: string;
    /**
     * 
     * @type {TransactionResponseOperationFee}
     * @memberof TransactionResponseOperation
     */
    fee?: TransactionResponseOperationFee;
    /**
     * 
     * @type {TransactionResponseOperationExchange}
     * @memberof TransactionResponseOperation
     */
    exchange?: TransactionResponseOperationExchange;
    /**
     * 
     * @type {TransactionResponseOperationFee}
     * @memberof TransactionResponseOperation
     */
    _final?: TransactionResponseOperationFee;
}

/**
    * @export
    * @enum {string}
    */
export enum TransactionResponseOperationResourceEnum {
    Charge = 'charge',
    Checkout = 'checkout',
    Invoice = 'invoice',
    Deposit = 'deposit',
    Payout = 'payout',
    Withdrawal = 'withdrawal',
    Refund = 'refund',
    Exchange = 'exchange',
    Topup = 'topup'
}

/**
 * Exchange data when auto exchange enabled for charge
 * @export
 * @interface TransactionResponseOperationExchange
 */
export interface TransactionResponseOperationExchange {
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof TransactionResponseOperationExchange
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof TransactionResponseOperationExchange
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperationExchange
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperationExchange
     */
    rate: string;
}
/**
 * 
 * @export
 * @interface TransactionResponseOperationFee
 */
export interface TransactionResponseOperationFee {
    /**
     * 
     * @type {string}
     * @memberof TransactionResponseOperationFee
     */
    amount: string;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof TransactionResponseOperationFee
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof TransactionResponseOperationFee
     */
    network: NetworkCrypto;
}
/**
 * 
 * @export
 * @interface Turnover
 */
export interface Turnover {
    /**
     * The max sum value of the merchant\'s operations. Null if unlimited.
     * @type {number}
     * @memberof Turnover
     */
    allowed?: number;
    /**
     * The total amount available for the merchant\'s operations. Null if unlimited.
     * @type {number}
     * @memberof Turnover
     */
    available?: number;
    /**
     * The amount of the merchant\'s \"in\" operations.
     * @type {number}
     * @memberof Turnover
     */
    _in: number;
    /**
     * The amount of the merchant\'s \"out\" operations.
     * @type {number}
     * @memberof Turnover
     */
    out: number;
    /**
     * The total amount of the merchant\'s operations.
     * @type {number}
     * @memberof Turnover
     */
    total: number;
}
/**
 * 
 * @export
 * @interface V20BankAccountsDetails
 */
export interface V20BankAccountsDetails {
    /**
     * 
     * @type {string}
     * @memberof V20BankAccountsDetails
     */
    beneficiary_account_name?: string;
    /**
     * 
     * @type {string}
     * @memberof V20BankAccountsDetails
     */
    beneficiary_account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof V20BankAccountsDetails
     */
    beneficiary_address?: string;
    /**
     * 
     * @type {string}
     * @memberof V20BankAccountsDetails
     */
    bank_name?: string;
    /**
     * 
     * @type {string}
     * @memberof V20BankAccountsDetails
     */
    bank_address?: string;
    /**
     * BIC/SWIFT code
     * @type {string}
     * @memberof V20BankAccountsDetails
     */
    bic_swift_code?: string;
}
/**
 * 
 * @export
 * @interface V20ChargesCrypto
 */
export interface V20ChargesCrypto {
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof V20ChargesCrypto
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof V20ChargesCrypto
     */
    symbol: SymbolCrypto;
}
/**
 * Required for pricing_type: fixed_price
 * @export
 * @interface V20ChargesFiatPrice
 */
export interface V20ChargesFiatPrice {
    /**
     * A positive float in fiat representing how much to charge
     * @type {string}
     * @memberof V20ChargesFiatPrice
     */
    amount?: string;
    /**
     * Three-letter ISO currency code, in uppercase
     * @type {string}
     * @memberof V20ChargesFiatPrice
     */
    symbol?: V20ChargesFiatPriceSymbolEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum V20ChargesFiatPriceSymbolEnum {
    Usd = 'USD'
}

/**
 * 
 * @export
 * @interface V20InvoicesFiatPrice
 */
export interface V20InvoicesFiatPrice {
    /**
     * A positive float in fiat representing how much to charge
     * @type {string}
     * @memberof V20InvoicesFiatPrice
     */
    amount?: string;
    /**
     * Three-letter ISO currency code, in uppercase
     * @type {string}
     * @memberof V20InvoicesFiatPrice
     */
    symbol?: string;
}
/**
 * Required when travel rule is enabled
 * @export
 * @interface V20MerchantWhitelistAddressesTravelRule
 */
export interface V20MerchantWhitelistAddressesTravelRule {
    /**
     * 
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRule
     */
    address_type: V20MerchantWhitelistAddressesTravelRuleAddressTypeEnum;
    /**
     * VASP identifier from /travel-rule/vasp-list
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRule
     */
    vasp_id?: string;
    /**
     * address verification redirect url
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRule
     */
    redirect_url?: string;
    /**
     * 
     * @type {V20MerchantWhitelistAddressesTravelRuleOriginator}
     * @memberof V20MerchantWhitelistAddressesTravelRule
     */
    originator: V20MerchantWhitelistAddressesTravelRuleOriginator;
    /**
     * 
     * @type {V20MerchantWhitelistAddressesTravelRuleBeneficiary}
     * @memberof V20MerchantWhitelistAddressesTravelRule
     */
    beneficiary: V20MerchantWhitelistAddressesTravelRuleBeneficiary;
}

/**
    * @export
    * @enum {string}
    */
export enum V20MerchantWhitelistAddressesTravelRuleAddressTypeEnum {
    Custodial = 'custodial',
    NonCustodial = 'non_custodial'
}

/**
 * 
 * @export
 * @interface V20MerchantWhitelistAddressesTravelRuleBeneficiary
 */
export interface V20MerchantWhitelistAddressesTravelRuleBeneficiary {
    /**
     * 
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRuleBeneficiary
     */
    name: string;
}
/**
 * 
 * @export
 * @interface V20MerchantWhitelistAddressesTravelRuleOriginator
 */
export interface V20MerchantWhitelistAddressesTravelRuleOriginator {
    /**
     * 
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRuleOriginator
     */
    name: string;
    /**
     * Format: YYYY-MM-DD
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRuleOriginator
     */
    date_of_birth: string;
    /**
     * 
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRuleOriginator
     */
    place_of_birth: string;
    /**
     * 
     * @type {string}
     * @memberof V20MerchantWhitelistAddressesTravelRuleOriginator
     */
    account_number: string;
}
/**
 * 
 * @export
 * @interface VerificationOperationCodeSendRequest
 */
export interface VerificationOperationCodeSendRequest {
    /**
     * Type of operation
     * @type {string}
     * @memberof VerificationOperationCodeSendRequest
     */
    type: VerificationOperationCodeSendRequestTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum VerificationOperationCodeSendRequestTypeEnum {
    MassPayoutsCreate = 'mass-payouts-create',
    MassPayoutsSend = 'mass-payouts-send',
    WithdrawalCreate = 'withdrawal-create',
    FiatWithdrawalCreate = 'fiat-withdrawal-create',
    Refund = 'refund'
}

/**
 * verification operation code response
 * @export
 * @interface VerificationOperationCodeSendResponse
 */
export interface VerificationOperationCodeSendResponse {
    /**
     * Length of verification operation code
     * @type {number}
     * @memberof VerificationOperationCodeSendResponse
     */
    code_length: number;
    /**
     * 
     * @type {string}
     * @memberof VerificationOperationCodeSendResponse
     */
    expires_at: string;
}
/**
 * 
 * @export
 * @interface WhitelistAddress
 */
export interface WhitelistAddress {
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    network?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    status?: WhitelistAddressStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    symbol?: string;
    /**
     * 
     * @type {WhitelistAddressTravelRule}
     * @memberof WhitelistAddress
     */
    travel_rule?: WhitelistAddressTravelRule | null;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddress
     */
    updated_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum WhitelistAddressStatusEnum {
    Pending = 'pending',
    Confirmed = 'confirmed',
    Waiting = 'waiting',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface WhitelistAddressTravelRule
 */
export interface WhitelistAddressTravelRule {
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddressTravelRule
     */
    address_type?: WhitelistAddressTravelRuleAddressTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddressTravelRule
     */
    vasp_id?: string;
    /**
     * 
     * @type {WithdrawalResponseTravelRuleOriginator}
     * @memberof WhitelistAddressTravelRule
     */
    originator?: WithdrawalResponseTravelRuleOriginator;
    /**
     * 
     * @type {InlineObject21}
     * @memberof WhitelistAddressTravelRule
     */
    beneficiary?: InlineObject21;
    /**
     * 
     * @type {WhitelistAddressTravelRuleWallet}
     * @memberof WhitelistAddressTravelRule
     */
    wallet?: WhitelistAddressTravelRuleWallet | null;
}

/**
    * @export
    * @enum {string}
    */
export enum WhitelistAddressTravelRuleAddressTypeEnum {
    Custodial = 'custodial',
    NonCustodial = 'non_custodial'
}

/**
 * 
 * @export
 * @interface WhitelistAddressTravelRuleWallet
 */
export interface WhitelistAddressTravelRuleWallet {
    /**
     * 
     * @type {string}
     * @memberof WhitelistAddressTravelRuleWallet
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface WhitelistIPsAddress
 */
export interface WhitelistIPsAddress {
    /**
     * 
     * @type {string}
     * @memberof WhitelistIPsAddress
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistIPsAddress
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistIPsAddress
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistIPsAddress
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelistIPsAddress
     */
    updated_at: string;
}
/**
 * request body for widget auth code
 * @export
 * @interface WidgetAuthCodeRequest
 */
export interface WidgetAuthCodeRequest {
    /**
     * User’s email address
     * @type {string}
     * @memberof WidgetAuthCodeRequest
     */
    email: string;
}
/**
 * widget auth code response
 * @export
 * @interface WidgetAuthCodeResponse
 */
export interface WidgetAuthCodeResponse {
    /**
     * Length of auth code
     * @type {number}
     * @memberof WidgetAuthCodeResponse
     */
    code_length: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetAuthCodeResponse
     */
    expires_at: string;
}
/**
 * Widget refresh token response
 * @export
 * @interface WidgetAuthRefreshTokenResponse
 */
export interface WidgetAuthRefreshTokenResponse {
    /**
     * widget auth token
     * @type {string}
     * @memberof WidgetAuthRefreshTokenResponse
     */
    token: string;
}
/**
 * request body for widget auth
 * @export
 * @interface WidgetAuthRequest
 */
export interface WidgetAuthRequest {
    /**
     * User’s email address
     * @type {string}
     * @memberof WidgetAuthRequest
     */
    email: string;
    /**
     * Widget auth confirmation code
     * @type {string}
     * @memberof WidgetAuthRequest
     */
    code: string;
}
/**
 * Widget auth response
 * @export
 * @interface WidgetAuthResponse
 */
export interface WidgetAuthResponse {
    /**
     * widget auth token
     * @type {string}
     * @memberof WidgetAuthResponse
     */
    token: string;
}
/**
 * 
 * @export
 * @interface WidgetBuyRatesDetail
 */
export interface WidgetBuyRatesDetail {
    /**
     * 
     * @type {WidgetBuyRatesDetailItem}
     * @memberof WidgetBuyRatesDetail
     */
    from: WidgetBuyRatesDetailItem;
    /**
     * 
     * @type {WidgetBuyRatesDetailItem}
     * @memberof WidgetBuyRatesDetail
     */
    to: WidgetBuyRatesDetailItem;
}
/**
 * 
 * @export
 * @interface WidgetBuyRatesDetailItem
 */
export interface WidgetBuyRatesDetailItem {
    /**
     * 
     * @type {string}
     * @memberof WidgetBuyRatesDetailItem
     */
    network: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetBuyRatesDetailItem
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetBuyRatesDetailItem
     */
    amount: string;
}
/**
 * Widget buy rates response
 * @export
 * @interface WidgetBuyRatesResponse
 */
export interface WidgetBuyRatesResponse {
    /**
     * Buy token to complete a transaction. User must be authorized to obtain token.
     * @type {string}
     * @memberof WidgetBuyRatesResponse
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetBuyRatesResponse
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetBuyRatesResponse
     */
    rate: string;
    /**
     * 
     * @type {WidgetBuyRatesDetail}
     * @memberof WidgetBuyRatesResponse
     */
    fee: WidgetBuyRatesDetail;
    /**
     * 
     * @type {WidgetBuyRatesDetail}
     * @memberof WidgetBuyRatesResponse
     */
    subtotal: WidgetBuyRatesDetail;
    /**
     * 
     * @type {WidgetBuyRatesDetail}
     * @memberof WidgetBuyRatesResponse
     */
    total: WidgetBuyRatesDetail;
    /**
     * Rates expiration date
     * @type {string}
     * @memberof WidgetBuyRatesResponse
     */
    expires_at: string;
}
/**
 * Widget buy request
 * @export
 * @interface WidgetBuyRequest
 */
export interface WidgetBuyRequest {
    /**
     * Buy token returned by the #buy-rates endpoint
     * @type {string}
     * @memberof WidgetBuyRequest
     */
    token: string;
    /**
     * The address to which the crypto should be transferred
     * @type {string}
     * @memberof WidgetBuyRequest
     */
    address: string;
    /**
     * External ID for this transaction
     * @type {string}
     * @memberof WidgetBuyRequest
     */
    external_id?: string;
}
/**
 * Widget buy response
 * @export
 * @interface WidgetBuyResponse
 */
export interface WidgetBuyResponse {
    /**
     * ID for checking transaction status
     * @type {string}
     * @memberof WidgetBuyResponse
     */
    id: string;
    /**
     * Redirect URL
     * @type {string}
     * @memberof WidgetBuyResponse
     */
    redirect_url: string;
}
/**
 * 
 * @export
 * @interface WidgetCallback
 */
export interface WidgetCallback {
    /**
     * 
     * @type {string}
     * @memberof WidgetCallback
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCallback
     */
    type: string;
    /**
     * 
     * @type {WidgetTransactionResponse}
     * @memberof WidgetCallback
     */
    data: WidgetTransactionResponse;
    /**
     * 
     * @type {string}
     * @memberof WidgetCallback
     */
    created_at: string;
}
/**
 * request body for creating a widget
 * @export
 * @interface WidgetCreate
 */
export interface WidgetCreate {
    /**
     * Widget name
     * @type {string}
     * @memberof WidgetCreate
     */
    name: string;
    /**
     * Widget URL
     * @type {string}
     * @memberof WidgetCreate
     */
    url: string;
    /**
     * Callback URL for the widget
     * @type {string}
     * @memberof WidgetCreate
     */
    callback_url?: string;
    /**
     * Sets the widget available for use
     * @type {boolean}
     * @memberof WidgetCreate
     */
    is_enabled?: boolean;
}
/**
 * Widget currency
 * @export
 * @interface WidgetCurrencyResponse
 */
export interface WidgetCurrencyResponse {
    /**
     * 
     * @type {string}
     * @memberof WidgetCurrencyResponse
     */
    network: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCurrencyResponse
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetCurrencyResponse
     */
    token_kind: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetCurrencyResponse
     */
    display_name: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetCurrencyResponse
     */
    decimals: number;
}
/**
 * Widget KYC response
 * @export
 * @interface WidgetKYCResponse
 */
export interface WidgetKYCResponse {
    /**
     * KYC status of the user. Allowed values are:  - `complete`: KYC procedures are successfully complete;  - `incomplete`: SumSub hasn’t started the verification;  - `failed_attempt`: the first attempt to pass the verification failed. Try again;  - `failed`: the verification failed; the user is not allowed to continue the operation. Contact Cryptix support;  - `under_review`: SumSub is verifying the documents. 
     * @type {string}
     * @memberof WidgetKYCResponse
     */
    status: WidgetKYCResponseStatusEnum;
    /**
     * URL to redirect the user to KYC provider.
     * @type {string}
     * @memberof WidgetKYCResponse
     */
    redirect_url?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum WidgetKYCResponseStatusEnum {
    Incomplete = 'incomplete',
    Complete = 'complete',
    FailedAttempt = 'failed_attempt',
    Failed = 'failed',
    UnderReview = 'under_review'
}

/**
 * limit item
 * @export
 * @interface WidgetLimitItem
 */
export interface WidgetLimitItem {
    /**
     * min operation limit
     * @type {string}
     * @memberof WidgetLimitItem
     */
    min: string;
    /**
     * max operation limit
     * @type {string}
     * @memberof WidgetLimitItem
     */
    max: string;
    /**
     * 
     * @type {WidgetLimitItemDay}
     * @memberof WidgetLimitItem
     */
    day?: WidgetLimitItemDay;
    /**
     * 
     * @type {WidgetLimitItemMonth}
     * @memberof WidgetLimitItem
     */
    month?: WidgetLimitItemMonth;
}
/**
 * daily limit
 * @export
 * @interface WidgetLimitItemDay
 */
export interface WidgetLimitItemDay {
    /**
     * total daily limit
     * @type {string}
     * @memberof WidgetLimitItemDay
     */
    total: string;
    /**
     * remain daily limit
     * @type {string}
     * @memberof WidgetLimitItemDay
     */
    remain: string;
}
/**
 * monthly limit
 * @export
 * @interface WidgetLimitItemMonth
 */
export interface WidgetLimitItemMonth {
    /**
     * total monthly limit
     * @type {string}
     * @memberof WidgetLimitItemMonth
     */
    total: string;
    /**
     * remain daily limit
     * @type {string}
     * @memberof WidgetLimitItemMonth
     */
    remain: string;
}
/**
 * limit item
 * @export
 * @interface WidgetLimitUnverifiedItem
 */
export interface WidgetLimitUnverifiedItem {
    /**
     * total limit
     * @type {string}
     * @memberof WidgetLimitUnverifiedItem
     */
    total: string;
    /**
     * remaining limit
     * @type {string}
     * @memberof WidgetLimitUnverifiedItem
     */
    remain: string;
}
/**
 * widget data
 * @export
 * @interface WidgetResponse
 */
export interface WidgetResponse {
    /**
     * Widget ID.
     * @type {string}
     * @memberof WidgetResponse
     */
    id: string;
    /**
     * Widget name
     * @type {string}
     * @memberof WidgetResponse
     */
    name: string;
    /**
     * Widget URL
     * @type {string}
     * @memberof WidgetResponse
     */
    url: string;
    /**
     * Callback URL for the widget
     * @type {string}
     * @memberof WidgetResponse
     */
    callback_url?: string;
    /**
     * Signature key for widget callback
     * @type {string}
     * @memberof WidgetResponse
     */
    callback_signature_key: string;
    /**
     * Sets the widget available for use
     * @type {boolean}
     * @memberof WidgetResponse
     */
    is_enabled: boolean;
    /**
     * Whether the widget approved by Cryptix
     * @type {boolean}
     * @memberof WidgetResponse
     */
    is_approved: boolean;
    /**
     * Widget HTML code
     * @type {string}
     * @memberof WidgetResponse
     */
    code?: string;
    /**
     * Widget creation date
     * @type {string}
     * @memberof WidgetResponse
     */
    created_at: string;
}
/**
 * Widget transaction
 * @export
 * @interface WidgetTransactionResponse
 */
export interface WidgetTransactionResponse {
    /**
     * Transaction ID
     * @type {string}
     * @memberof WidgetTransactionResponse
     */
    id: string;
    /**
     * Transaction status
     * @type {string}
     * @memberof WidgetTransactionResponse
     */
    status: string;
    /**
     * Widget ID
     * @type {string}
     * @memberof WidgetTransactionResponse
     */
    widget_id: string;
    /**
     * Merchant\'s external ID for this transaction
     * @type {string}
     * @memberof WidgetTransactionResponse
     */
    external_id?: string;
    /**
     * 
     * @type {WidgetTransactionResponseFiat}
     * @memberof WidgetTransactionResponse
     */
    fiat: WidgetTransactionResponseFiat;
    /**
     * 
     * @type {WidgetTransactionResponseCrypto}
     * @memberof WidgetTransactionResponse
     */
    crypto: WidgetTransactionResponseCrypto;
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponse
     */
    created_at: string;
}
/**
 * 
 * @export
 * @interface WidgetTransactionResponseCrypto
 */
export interface WidgetTransactionResponseCrypto {
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponseCrypto
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponseCrypto
     */
    network: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponseCrypto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponseCrypto
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponseCrypto
     */
    tx_id?: string;
}
/**
 * 
 * @export
 * @interface WidgetTransactionResponseFiat
 */
export interface WidgetTransactionResponseFiat {
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponseFiat
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetTransactionResponseFiat
     */
    symbol: string;
}
/**
 * request body for updating a widget
 * @export
 * @interface WidgetUpdate
 */
export interface WidgetUpdate {
    /**
     * Widget name
     * @type {string}
     * @memberof WidgetUpdate
     */
    name?: string;
    /**
     * Widget URL
     * @type {string}
     * @memberof WidgetUpdate
     */
    url?: string;
    /**
     * Callback URL for the widget
     * @type {string}
     * @memberof WidgetUpdate
     */
    callback_url?: string;
    /**
     * Sets the widget available for use
     * @type {boolean}
     * @memberof WidgetUpdate
     */
    is_enabled?: boolean;
}
/**
 * request body for creating a withdrawal
 * @export
 * @interface WithdrawalCreate
 */
export interface WithdrawalCreate {
    /**
     * Unique ID of withdrawal
     * @type {string}
     * @memberof WithdrawalCreate
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreate
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreate
     */
    callback_url?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreate
     */
    whitelisted_address_id: string;
    /**
     * Optional form travel rule withdrawals
     * @type {string}
     * @memberof WithdrawalCreate
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreate
     */
    network?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreate
     */
    amount: string;
    /**
     * OTP code (if enabled)
     * @type {string}
     * @memberof WithdrawalCreate
     */
    otp: string;
    /**
     * 
     * @type {WithdrawalCreateTravelRule}
     * @memberof WithdrawalCreate
     */
    travel_rule?: WithdrawalCreateTravelRule | null;
}
/**
 * Travel Rule data. Required when Travel Rule is enabled for the merchant.
 * @export
 * @interface WithdrawalCreateTravelRule
 */
export interface WithdrawalCreateTravelRule {
    /**
     * 
     * @type {WithdrawalCreateTravelRuleOriginator}
     * @memberof WithdrawalCreateTravelRule
     */
    originator?: WithdrawalCreateTravelRuleOriginator;
    /**
     * 
     * @type {WithdrawalCreateTravelRuleBeneficiary}
     * @memberof WithdrawalCreateTravelRule
     */
    beneficiary?: WithdrawalCreateTravelRuleBeneficiary;
}
/**
 * Travel Rule beneficiary data.
 * @export
 * @interface WithdrawalCreateTravelRuleBeneficiary
 */
export interface WithdrawalCreateTravelRuleBeneficiary {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreateTravelRuleBeneficiary
     */
    name?: string;
}
/**
 * Travel Rule originator data.
 * @export
 * @interface WithdrawalCreateTravelRuleOriginator
 */
export interface WithdrawalCreateTravelRuleOriginator {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreateTravelRuleOriginator
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreateTravelRuleOriginator
     */
    date_of_birth?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalCreateTravelRuleOriginator
     */
    place_of_birth?: string;
    /**
     * Unique identifier of the user in the client\'s system.
     * @type {string}
     * @memberof WithdrawalCreateTravelRuleOriginator
     */
    account_number?: string;
}
/**
 * 
 * @export
 * @interface WithdrawalResponse
 */
export interface WithdrawalResponse {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponse
     */
    status: WithdrawalResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponse
     */
    external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponse
     */
    callback_url?: string;
    /**
     * 
     * @type {PayoutError}
     * @memberof WithdrawalResponse
     */
    error?: PayoutError;
    /**
     * 
     * @type {WithdrawalResponseTravelRule}
     * @memberof WithdrawalResponse
     */
    travel_rule?: WithdrawalResponseTravelRule;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponse
     */
    created_at?: string;
    /**
     * 
     * @type {WithdrawalResponseData}
     * @memberof WithdrawalResponse
     */
    data: WithdrawalResponseData;
}

/**
    * @export
    * @enum {string}
    */
export enum WithdrawalResponseStatusEnum {
    New = 'new',
    Pending = 'pending',
    Failed = 'failed',
    Completed = 'completed',
    Cancelled = 'cancelled'
}

/**
 * 
 * @export
 * @interface WithdrawalResponseData
 */
export interface WithdrawalResponseData {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseData
     */
    ext_tx_id?: string;
    /**
     * 
     * @type {NetworkCrypto}
     * @memberof WithdrawalResponseData
     */
    network: NetworkCrypto;
    /**
     * 
     * @type {SymbolCrypto}
     * @memberof WithdrawalResponseData
     */
    symbol: SymbolCrypto;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseData
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseData
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseData
     */
    fee_payer?: WithdrawalResponseDataFeePayerEnum;
    /**
     * 
     * @type {Fee}
     * @memberof WithdrawalResponseData
     */
    fees?: Fee | null;
}

/**
    * @export
    * @enum {string}
    */
export enum WithdrawalResponseDataFeePayerEnum {
    Merchant = 'merchant',
    Customer = 'customer'
}

/**
 * 
 * @export
 * @interface WithdrawalResponseTravelRule
 */
export interface WithdrawalResponseTravelRule {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRule
     */
    status?: WithdrawalResponseTravelRuleStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRule
     */
    reason?: string;
    /**
     * 
     * @type {WithdrawalResponseTravelRuleOriginator}
     * @memberof WithdrawalResponseTravelRule
     */
    originator?: WithdrawalResponseTravelRuleOriginator;
    /**
     * 
     * @type {WithdrawalResponseTravelRuleBeneficiary}
     * @memberof WithdrawalResponseTravelRule
     */
    beneficiary?: WithdrawalResponseTravelRuleBeneficiary;
    /**
     * 
     * @type {WithdrawalResponseTravelRuleRiskScore}
     * @memberof WithdrawalResponseTravelRule
     */
    risk_score?: WithdrawalResponseTravelRuleRiskScore;
    /**
     * 
     * @type {Array<WithdrawalResponseTravelRuleWarnings>}
     * @memberof WithdrawalResponseTravelRule
     */
    warnings?: Array<WithdrawalResponseTravelRuleWarnings>;
}

/**
    * @export
    * @enum {string}
    */
export enum WithdrawalResponseTravelRuleStatusEnum {
    New = 'new',
    Pending = 'pending',
    Rejected = 'rejected',
    Accepted = 'accepted'
}

/**
 * 
 * @export
 * @interface WithdrawalResponseTravelRuleBeneficiary
 */
export interface WithdrawalResponseTravelRuleBeneficiary {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleBeneficiary
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleBeneficiary
     */
    account_number?: string;
}
/**
 * 
 * @export
 * @interface WithdrawalResponseTravelRuleOriginator
 */
export interface WithdrawalResponseTravelRuleOriginator {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleOriginator
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleOriginator
     */
    date_of_birth?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleOriginator
     */
    place_of_birth?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleOriginator
     */
    account_number?: string;
}
/**
 * 
 * @export
 * @interface WithdrawalResponseTravelRuleRiskScore
 */
export interface WithdrawalResponseTravelRuleRiskScore {
    /**
     * 
     * @type {number}
     * @memberof WithdrawalResponseTravelRuleRiskScore
     */
    originator_risk_score?: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleRiskScore
     */
    originator_risk_severity?: string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawalResponseTravelRuleRiskScore
     */
    beneficiary_risk_score?: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleRiskScore
     */
    beneficiary_risk_severity?: string;
}
/**
 * 
 * @export
 * @interface WithdrawalResponseTravelRuleWarnings
 */
export interface WithdrawalResponseTravelRuleWarnings {
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleWarnings
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawalResponseTravelRuleWarnings
     */
    message?: string;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Confirms merchant account
         * @summary Resend confirmation mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/auth/register/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirms merchant account
         * @summary Confirmation of merchant registration
         * @param {InlineObject10} inlineObject10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmations: async (inlineObject10: InlineObject10, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject10' is not null or undefined
            assertParamExists('confirmations', 'inlineObject10', inlineObject10)
            const localVarPath = `/v2.0/auth/register/end`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject10, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Login a merchant. To generate re-captcha use \'login\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=login\">here</a>.
         * @summary Login
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (inlineObject11: InlineObject11, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject11' is not null or undefined
            assertParamExists('login', 'inlineObject11', inlineObject11)
            const localVarPath = `/v2.0/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject11, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recover
         * @summary Password recovery (finish)
         * @param {InlineObject13} inlineObject13 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoveryEnd: async (inlineObject13: InlineObject13, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject13' is not null or undefined
            assertParamExists('recoveryEnd', 'inlineObject13', inlineObject13)
            const localVarPath = `/v2.0/auth/recover/end`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject13, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Password recovery. To generate re-captcha use \'recover\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=recover\">here</a>.
         * @summary Password recovery
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoveryStart: async (inlineObject12: InlineObject12, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject12' is not null or undefined
            assertParamExists('recoveryStart', 'inlineObject12', inlineObject12)
            const localVarPath = `/v2.0/auth/recover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Signup a new merchant or referrer. To generate re-captcha use \'register\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=register\">here</a>.
         * @summary Signup of new merchant or referrer
         * @param {SignupRequest} signupRequest Merchant form data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (signupRequest: SignupRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupRequest' is not null or undefined
            assertParamExists('signup', 'signupRequest', signupRequest)
            const localVarPath = `/v2.0/auth/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Confirms merchant account
         * @summary Resend confirmation mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirm(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationOperationCodeSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirm(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Confirms merchant account
         * @summary Confirmation of merchant registration
         * @param {InlineObject10} inlineObject10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmations(inlineObject10: InlineObject10, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmations(inlineObject10, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Login a merchant. To generate re-captcha use \'login\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=login\">here</a>.
         * @summary Login
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(inlineObject11: InlineObject11, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(inlineObject11, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Logout
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recover
         * @summary Password recovery (finish)
         * @param {InlineObject13} inlineObject13 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recoveryEnd(inlineObject13: InlineObject13, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recoveryEnd(inlineObject13, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Password recovery. To generate re-captcha use \'recover\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=recover\">here</a>.
         * @summary Password recovery
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recoveryStart(inlineObject12: InlineObject12, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recoveryStart(inlineObject12, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Signup a new merchant or referrer. To generate re-captcha use \'register\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=register\">here</a>.
         * @summary Signup of new merchant or referrer
         * @param {SignupRequest} signupRequest Merchant form data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(signupRequest: SignupRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(signupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Confirms merchant account
         * @summary Resend confirmation mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirm(options?: any): AxiosPromise<VerificationOperationCodeSendResponse> {
            return localVarFp.confirm(options).then((request) => request(axios, basePath));
        },
        /**
         * Confirms merchant account
         * @summary Confirmation of merchant registration
         * @param {InlineObject10} inlineObject10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmations(inlineObject10: InlineObject10, options?: any): AxiosPromise<Response> {
            return localVarFp.confirmations(inlineObject10, options).then((request) => request(axios, basePath));
        },
        /**
         * Login a merchant. To generate re-captcha use \'login\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=login\">here</a>.
         * @summary Login
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(inlineObject11: InlineObject11, options?: any): AxiosPromise<Response> {
            return localVarFp.login(inlineObject11, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Recover
         * @summary Password recovery (finish)
         * @param {InlineObject13} inlineObject13 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoveryEnd(inlineObject13: InlineObject13, options?: any): AxiosPromise<Response> {
            return localVarFp.recoveryEnd(inlineObject13, options).then((request) => request(axios, basePath));
        },
        /**
         * Password recovery. To generate re-captcha use \'recover\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=recover\">here</a>.
         * @summary Password recovery
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recoveryStart(inlineObject12: InlineObject12, options?: any): AxiosPromise<Response> {
            return localVarFp.recoveryStart(inlineObject12, options).then((request) => request(axios, basePath));
        },
        /**
         * Signup a new merchant or referrer. To generate re-captcha use \'register\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=register\">here</a>.
         * @summary Signup of new merchant or referrer
         * @param {SignupRequest} signupRequest Merchant form data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(signupRequest: SignupRequest, options?: any): AxiosPromise<Response> {
            return localVarFp.signup(signupRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Confirms merchant account
     * @summary Resend confirmation mail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirm(options?: any) {
        return AuthApiFp(this.configuration).confirm(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirms merchant account
     * @summary Confirmation of merchant registration
     * @param {InlineObject10} inlineObject10 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirmations(inlineObject10: InlineObject10, options?: any) {
        return AuthApiFp(this.configuration).confirmations(inlineObject10, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Login a merchant. To generate re-captcha use \'login\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=login\">here</a>.
     * @summary Login
     * @param {InlineObject11} inlineObject11 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(inlineObject11: InlineObject11, options?: any) {
        return AuthApiFp(this.configuration).login(inlineObject11, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logout(options?: any) {
        return AuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recover
     * @summary Password recovery (finish)
     * @param {InlineObject13} inlineObject13 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public recoveryEnd(inlineObject13: InlineObject13, options?: any) {
        return AuthApiFp(this.configuration).recoveryEnd(inlineObject13, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Password recovery. To generate re-captcha use \'recover\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=recover\">here</a>.
     * @summary Password recovery
     * @param {InlineObject12} inlineObject12 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public recoveryStart(inlineObject12: InlineObject12, options?: any) {
        return AuthApiFp(this.configuration).recoveryStart(inlineObject12, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Signup a new merchant or referrer. To generate re-captcha use \'register\' action. Generate reCaptcha <a target=\"_blank\" href=\"./pages/recaptcha.html?action=register\">here</a>.
     * @summary Signup of new merchant or referrer
     * @param {SignupRequest} signupRequest Merchant form data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signup(signupRequest: SignupRequest, options?: any) {
        return AuthApiFp(this.configuration).signup(signupRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BankAccountsApi - axios parameter creator
 * @export
 */
export const BankAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a bank account
         * @summary Create a bank account
         * @param {InlineObject26} inlineObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount: async (inlineObject26: InlineObject26, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject26' is not null or undefined
            assertParamExists('createBankAccount', 'inlineObject26', inlineObject26)
            const localVarPath = `/v2.0/bank-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject26, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete bank account
         * @param {string} id ID of bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBankAccount', 'id', id)
            const localVarPath = `/v2.0/bank-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of a bank account that has been previously created.
         * @summary Show a bank account
         * @param {string} id ID of bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccount: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBankAccount', 'id', id)
            const localVarPath = `/v2.0/bank-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all bank accounts
         * @summary List bank accounts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts: async (order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/bank-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankAccountsApi - functional programming interface
 * @export
 */
export const BankAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a bank account
         * @summary Create a bank account
         * @param {InlineObject26} inlineObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankAccount(inlineObject26: InlineObject26, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20034>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankAccount(inlineObject26, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete bank account
         * @param {string} id ID of bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBankAccount(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBankAccount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the details of a bank account that has been previously created.
         * @summary Show a bank account
         * @param {string} id ID of bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccount(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20034>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccount(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all bank accounts
         * @summary List bank accounts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccounts(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20033>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccounts(order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BankAccountsApi - factory interface
 * @export
 */
export const BankAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankAccountsApiFp(configuration)
    return {
        /**
         * Create a bank account
         * @summary Create a bank account
         * @param {InlineObject26} inlineObject26 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount(inlineObject26: InlineObject26, options?: any): AxiosPromise<InlineResponse20034> {
            return localVarFp.createBankAccount(inlineObject26, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete bank account
         * @param {string} id ID of bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteBankAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the details of a bank account that has been previously created.
         * @summary Show a bank account
         * @param {string} id ID of bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccount(id: string, options?: any): AxiosPromise<InlineResponse20034> {
            return localVarFp.getBankAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all bank accounts
         * @summary List bank accounts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20033> {
            return localVarFp.getBankAccounts(order, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BankAccountsApi - object-oriented interface
 * @export
 * @class BankAccountsApi
 * @extends {BaseAPI}
 */
export class BankAccountsApi extends BaseAPI {
    /**
     * Create a bank account
     * @summary Create a bank account
     * @param {InlineObject26} inlineObject26 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    public createBankAccount(inlineObject26: InlineObject26, options?: any) {
        return BankAccountsApiFp(this.configuration).createBankAccount(inlineObject26, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete bank account
     * @param {string} id ID of bank account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    public deleteBankAccount(id: string, options?: any) {
        return BankAccountsApiFp(this.configuration).deleteBankAccount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the details of a bank account that has been previously created.
     * @summary Show a bank account
     * @param {string} id ID of bank account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    public getBankAccount(id: string, options?: any) {
        return BankAccountsApiFp(this.configuration).getBankAccount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all bank accounts
     * @summary List bank accounts
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountsApi
     */
    public getBankAccounts(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return BankAccountsApiFp(this.configuration).getBankAccounts(order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BankPayoutsApi - axios parameter creator
 * @export
 */
export const BankPayoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a bank payout
         * @summary Create a bank payout
         * @param {BankPayoutCreate} bankPayoutCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankPayout: async (bankPayoutCreate: BankPayoutCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankPayoutCreate' is not null or undefined
            assertParamExists('createBankPayout', 'bankPayoutCreate', bankPayoutCreate)
            const localVarPath = `/v2.0/bank-payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankPayoutCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns bank payout by ID
         * @summary Get bank payout
         * @param {string} id Payout ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankPayout: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBankPayout', 'id', id)
            const localVarPath = `/v2.0/bank-payouts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of bank payouts
         * @summary List of bank payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankPayouts: async (externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/bank-payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns banks list for country
         * @summary List banks by country
         * @param {'Colombia' | 'Peru' | 'Ecuador'} country country name
         * @param {'PEN' | 'COP' | 'USD'} symbol symbol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankPayoutsBanks: async (country: 'Colombia' | 'Peru' | 'Ecuador', symbol: 'PEN' | 'COP' | 'USD', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('listBankPayoutsBanks', 'country', country)
            // verify required parameter 'symbol' is not null or undefined
            assertParamExists('listBankPayoutsBanks', 'symbol', symbol)
            const localVarPath = `/v2.0/bank-payouts/banks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankPayoutsApi - functional programming interface
 * @export
 */
export const BankPayoutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankPayoutsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a bank payout
         * @summary Create a bank payout
         * @param {BankPayoutCreate} bankPayoutCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankPayout(bankPayoutCreate: BankPayoutCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20019>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankPayout(bankPayoutCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns bank payout by ID
         * @summary Get bank payout
         * @param {string} id Payout ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankPayout(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20019>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankPayout(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of bank payouts
         * @summary List of bank payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBankPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBankPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns banks list for country
         * @summary List banks by country
         * @param {'Colombia' | 'Peru' | 'Ecuador'} country country name
         * @param {'PEN' | 'COP' | 'USD'} symbol symbol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBankPayoutsBanks(country: 'Colombia' | 'Peru' | 'Ecuador', symbol: 'PEN' | 'COP' | 'USD', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBankPayoutsBanks(country, symbol, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BankPayoutsApi - factory interface
 * @export
 */
export const BankPayoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankPayoutsApiFp(configuration)
    return {
        /**
         * Create a bank payout
         * @summary Create a bank payout
         * @param {BankPayoutCreate} bankPayoutCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankPayout(bankPayoutCreate: BankPayoutCreate, options?: any): AxiosPromise<InlineResponse20019> {
            return localVarFp.createBankPayout(bankPayoutCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns bank payout by ID
         * @summary Get bank payout
         * @param {string} id Payout ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankPayout(id: string, options?: any): AxiosPromise<InlineResponse20019> {
            return localVarFp.getBankPayout(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List of bank payouts
         * @summary List of bank payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20018> {
            return localVarFp.listBankPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns banks list for country
         * @summary List banks by country
         * @param {'Colombia' | 'Peru' | 'Ecuador'} country country name
         * @param {'PEN' | 'COP' | 'USD'} symbol symbol
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBankPayoutsBanks(country: 'Colombia' | 'Peru' | 'Ecuador', symbol: 'PEN' | 'COP' | 'USD', options?: any): AxiosPromise<Response & object> {
            return localVarFp.listBankPayoutsBanks(country, symbol, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BankPayoutsApi - object-oriented interface
 * @export
 * @class BankPayoutsApi
 * @extends {BaseAPI}
 */
export class BankPayoutsApi extends BaseAPI {
    /**
     * Create a bank payout
     * @summary Create a bank payout
     * @param {BankPayoutCreate} bankPayoutCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankPayoutsApi
     */
    public createBankPayout(bankPayoutCreate: BankPayoutCreate, options?: any) {
        return BankPayoutsApiFp(this.configuration).createBankPayout(bankPayoutCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns bank payout by ID
     * @summary Get bank payout
     * @param {string} id Payout ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankPayoutsApi
     */
    public getBankPayout(id: string, options?: any) {
        return BankPayoutsApiFp(this.configuration).getBankPayout(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of bank payouts
     * @summary List of bank payouts
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankPayoutsApi
     */
    public listBankPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return BankPayoutsApiFp(this.configuration).listBankPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns banks list for country
     * @summary List banks by country
     * @param {'Colombia' | 'Peru' | 'Ecuador'} country country name
     * @param {'PEN' | 'COP' | 'USD'} symbol symbol
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankPayoutsApi
     */
    public listBankPayoutsBanks(country: 'Colombia' | 'Peru' | 'Ecuador', symbol: 'PEN' | 'COP' | 'USD', options?: any) {
        return BankPayoutsApiFp(this.configuration).listBankPayoutsBanks(country, symbol, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CardMassPayoutsApi - axios parameter creator
 * @export
 */
export const CardMassPayoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel unconfirmed card mass payout.
         * @summary Cancel unconfirmed card mass payout.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardMassPayoutsDelete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardMassPayoutsDelete', 'id', id)
            const localVarPath = `/v2.0/card-mass-payouts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm sending of card mass payout.
         * @summary Confirm sending of card mass payout.
         * @param {string} id 
         * @param {InlineObject6} inlineObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardMassPayoutsSend: async (id: string, inlineObject6: InlineObject6, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cardMassPayoutsSend', 'id', id)
            // verify required parameter 'inlineObject6' is not null or undefined
            assertParamExists('cardMassPayoutsSend', 'inlineObject6', inlineObject6)
            const localVarPath = `/v2.0/card-mass-payouts/{id}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a card mass payout
         * @summary Create a card mass payout
         * @param {CardMassPayoutJsonCreate} cardMassPayoutJsonCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCardMassPayout: async (cardMassPayoutJsonCreate: CardMassPayoutJsonCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardMassPayoutJsonCreate' is not null or undefined
            assertParamExists('createCardMassPayout', 'cardMassPayoutJsonCreate', cardMassPayoutJsonCreate)
            const localVarPath = `/v2.0/card-mass-payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardMassPayoutJsonCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of card mass payouts
         * @summary List of card mass payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardMassPayouts: async (externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/card-mass-payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of card payouts from a mass payout
         * @summary List of card payouts from a mass payout
         * @param {string} id 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardPayouts: async (id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listCardPayouts', 'id', id)
            const localVarPath = `/v2.0/card-mass-payouts/{id}/payouts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardMassPayoutsApi - functional programming interface
 * @export
 */
export const CardMassPayoutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardMassPayoutsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel unconfirmed card mass payout.
         * @summary Cancel unconfirmed card mass payout.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardMassPayoutsDelete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardMassPayoutsDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Confirm sending of card mass payout.
         * @summary Confirm sending of card mass payout.
         * @param {string} id 
         * @param {InlineObject6} inlineObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardMassPayoutsSend(id: string, inlineObject6: InlineObject6, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardMassPayoutsSend(id, inlineObject6, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a card mass payout
         * @summary Create a card mass payout
         * @param {CardMassPayoutJsonCreate} cardMassPayoutJsonCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCardMassPayout(cardMassPayoutJsonCreate: CardMassPayoutJsonCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCardMassPayout(cardMassPayoutJsonCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of card mass payouts
         * @summary List of card mass payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCardMassPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCardMassPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of card payouts from a mass payout
         * @summary List of card payouts from a mass payout
         * @param {string} id 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCardPayouts(id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCardPayouts(id, externalId, createdAtFrom, createdAtTo, status, order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CardMassPayoutsApi - factory interface
 * @export
 */
export const CardMassPayoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardMassPayoutsApiFp(configuration)
    return {
        /**
         * Cancel unconfirmed card mass payout.
         * @summary Cancel unconfirmed card mass payout.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardMassPayoutsDelete(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.cardMassPayoutsDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm sending of card mass payout.
         * @summary Confirm sending of card mass payout.
         * @param {string} id 
         * @param {InlineObject6} inlineObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardMassPayoutsSend(id: string, inlineObject6: InlineObject6, options?: any): AxiosPromise<InlineResponse20016> {
            return localVarFp.cardMassPayoutsSend(id, inlineObject6, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a card mass payout
         * @summary Create a card mass payout
         * @param {CardMassPayoutJsonCreate} cardMassPayoutJsonCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCardMassPayout(cardMassPayoutJsonCreate: CardMassPayoutJsonCreate, options?: any): AxiosPromise<InlineResponse20016> {
            return localVarFp.createCardMassPayout(cardMassPayoutJsonCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * List of card mass payouts
         * @summary List of card mass payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardMassPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20015> {
            return localVarFp.listCardMassPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List of card payouts from a mass payout
         * @summary List of card payouts from a mass payout
         * @param {string} id 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardPayouts(id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20017> {
            return localVarFp.listCardPayouts(id, externalId, createdAtFrom, createdAtTo, status, order, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CardMassPayoutsApi - object-oriented interface
 * @export
 * @class CardMassPayoutsApi
 * @extends {BaseAPI}
 */
export class CardMassPayoutsApi extends BaseAPI {
    /**
     * Cancel unconfirmed card mass payout.
     * @summary Cancel unconfirmed card mass payout.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardMassPayoutsApi
     */
    public cardMassPayoutsDelete(id: string, options?: any) {
        return CardMassPayoutsApiFp(this.configuration).cardMassPayoutsDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm sending of card mass payout.
     * @summary Confirm sending of card mass payout.
     * @param {string} id 
     * @param {InlineObject6} inlineObject6 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardMassPayoutsApi
     */
    public cardMassPayoutsSend(id: string, inlineObject6: InlineObject6, options?: any) {
        return CardMassPayoutsApiFp(this.configuration).cardMassPayoutsSend(id, inlineObject6, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a card mass payout
     * @summary Create a card mass payout
     * @param {CardMassPayoutJsonCreate} cardMassPayoutJsonCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardMassPayoutsApi
     */
    public createCardMassPayout(cardMassPayoutJsonCreate: CardMassPayoutJsonCreate, options?: any) {
        return CardMassPayoutsApiFp(this.configuration).createCardMassPayout(cardMassPayoutJsonCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of card mass payouts
     * @summary List of card mass payouts
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardMassPayoutsApi
     */
    public listCardMassPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return CardMassPayoutsApiFp(this.configuration).listCardMassPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of card payouts from a mass payout
     * @summary List of card payouts from a mass payout
     * @param {string} id 
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardMassPayoutsApi
     */
    public listCardPayouts(id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return CardMassPayoutsApiFp(this.configuration).listCardPayouts(id, externalId, createdAtFrom, createdAtTo, status, order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ChargesApi - axios parameter creator
 * @export
 */
export const ChargesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Complete a charge that has been previously marked as unresolved underpaid.
         * @summary Complete a charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCharge: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeCharge', 'id', id)
            const localVarPath = `/v2.0/charges/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
         * @summary Create a charge
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCharge: async (inlineObject: InlineObject, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject' is not null or undefined
            assertParamExists('createCharge', 'inlineObject', inlineObject)
            const localVarPath = `/v2.0/charges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
         * @summary Create a charge (public)
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChargePublic: async (inlineObject1: InlineObject1, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject1' is not null or undefined
            assertParamExists('createChargePublic', 'inlineObject1', inlineObject1)
            const localVarPath = `/v2.0/charges/public-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable a crypto in a charge
         * @summary Enable a crypto in a charge
         * @param {string} id ID of charge
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCryptoCharge: async (id: string, inlineObject2: InlineObject2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableCryptoCharge', 'id', id)
            // verify required parameter 'inlineObject2' is not null or undefined
            assertParamExists('enableCryptoCharge', 'inlineObject2', inlineObject2)
            const localVarPath = `/v2.0/charges/{id}/enable-crypto`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of a charge that has been previously created.
         * @summary Show a charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCharge: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCharge', 'id', id)
            const localVarPath = `/v2.0/charges/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all charges
         * @summary List charges
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCharges: async (order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/charges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh pricing for invoice
         * @summary Refresh pricing for invoice
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCharge: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshCharge', 'id', id)
            const localVarPath = `/v2.0/charges/{id}/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a charge that has been previously marked as unresolved underpaid or overpaid.
         * @summary Resolve charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resoleCharge: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resoleCharge', 'id', id)
            const localVarPath = `/v2.0/charges/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChargesApi - functional programming interface
 * @export
 */
export const ChargesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChargesApiAxiosParamCreator(configuration)
    return {
        /**
         * Complete a charge that has been previously marked as unresolved underpaid.
         * @summary Complete a charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeCharge(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeCharge(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
         * @summary Create a charge
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCharge(inlineObject: InlineObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCharge(inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
         * @summary Create a charge (public)
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChargePublic(inlineObject1: InlineObject1, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChargePublic(inlineObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Enable a crypto in a charge
         * @summary Enable a crypto in a charge
         * @param {string} id ID of charge
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableCryptoCharge(id: string, inlineObject2: InlineObject2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableCryptoCharge(id, inlineObject2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the details of a charge that has been previously created.
         * @summary Show a charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCharge(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCharge(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all charges
         * @summary List charges
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCharges(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCharges(order, offset, limit, projectId, externalId, createdAtFrom, createdAtTo, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refresh pricing for invoice
         * @summary Refresh pricing for invoice
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshCharge(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshCharge(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolve a charge that has been previously marked as unresolved underpaid or overpaid.
         * @summary Resolve charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resoleCharge(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resoleCharge(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChargesApi - factory interface
 * @export
 */
export const ChargesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChargesApiFp(configuration)
    return {
        /**
         * Complete a charge that has been previously marked as unresolved underpaid.
         * @summary Complete a charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCharge(id: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.completeCharge(id, options).then((request) => request(axios, basePath));
        },
        /**
         * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
         * @summary Create a charge
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCharge(inlineObject: InlineObject, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.createCharge(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
         * @summary Create a charge (public)
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChargePublic(inlineObject1: InlineObject1, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.createChargePublic(inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable a crypto in a charge
         * @summary Enable a crypto in a charge
         * @param {string} id ID of charge
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCryptoCharge(id: string, inlineObject2: InlineObject2, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.enableCryptoCharge(id, inlineObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the details of a charge that has been previously created.
         * @summary Show a charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCharge(id: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.getCharge(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all charges
         * @summary List charges
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCharges(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled', options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.getCharges(order, offset, limit, projectId, externalId, createdAtFrom, createdAtTo, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh pricing for invoice
         * @summary Refresh pricing for invoice
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCharge(id: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.refreshCharge(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a charge that has been previously marked as unresolved underpaid or overpaid.
         * @summary Resolve charge
         * @param {string} id ID of charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resoleCharge(id: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.resoleCharge(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChargesApi - object-oriented interface
 * @export
 * @class ChargesApi
 * @extends {BaseAPI}
 */
export class ChargesApi extends BaseAPI {
    /**
     * Complete a charge that has been previously marked as unresolved underpaid.
     * @summary Complete a charge
     * @param {string} id ID of charge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public completeCharge(id: string, options?: any) {
        return ChargesApiFp(this.configuration).completeCharge(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
     * @summary Create a charge
     * @param {InlineObject} inlineObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public createCharge(inlineObject: InlineObject, options?: any) {
        return ChargesApiFp(this.configuration).createCharge(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To get paid in cryptocurrency, you need to create a charge object and provide the user with a cryptocurrency address to which they must send cryptocurrency. Once a charge is created a customer must broadcast a payment to the blockchain before the charge expires.
     * @summary Create a charge (public)
     * @param {InlineObject1} inlineObject1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public createChargePublic(inlineObject1: InlineObject1, options?: any) {
        return ChargesApiFp(this.configuration).createChargePublic(inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable a crypto in a charge
     * @summary Enable a crypto in a charge
     * @param {string} id ID of charge
     * @param {InlineObject2} inlineObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public enableCryptoCharge(id: string, inlineObject2: InlineObject2, options?: any) {
        return ChargesApiFp(this.configuration).enableCryptoCharge(id, inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the details of a charge that has been previously created.
     * @summary Show a charge
     * @param {string} id ID of charge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public getCharge(id: string, options?: any) {
        return ChargesApiFp(this.configuration).getCharge(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all charges
     * @summary List charges
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [projectId] 
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled'} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public getCharges(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'expired' | 'unresolved' | 'resolving' | 'resolved' | 'canceled', options?: any) {
        return ChargesApiFp(this.configuration).getCharges(order, offset, limit, projectId, externalId, createdAtFrom, createdAtTo, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh pricing for invoice
     * @summary Refresh pricing for invoice
     * @param {string} id ID of charge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public refreshCharge(id: string, options?: any) {
        return ChargesApiFp(this.configuration).refreshCharge(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a charge that has been previously marked as unresolved underpaid or overpaid.
     * @summary Resolve charge
     * @param {string} id ID of charge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChargesApi
     */
    public resoleCharge(id: string, options?: any) {
        return ChargesApiFp(this.configuration).resoleCharge(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CheckoutsApi - axios parameter creator
 * @export
 */
export const CheckoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cache image for checkout
         * @summary Cache image for checkout
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheCheckoutImage: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/checkouts/cache/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new checkout
         * @summary Create a checkout
         * @param {CheckoutCreateRequest} checkoutCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckout: async (checkoutCreateRequest: CheckoutCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutCreateRequest' is not null or undefined
            assertParamExists('createCheckout', 'checkoutCreateRequest', checkoutCreateRequest)
            const localVarPath = `/v2.0/checkouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a checkout
         * @summary Delete a checkout
         * @param {string} id ID of checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCheckout: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCheckout', 'id', id)
            const localVarPath = `/v2.0/checkouts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of an checkout and validates domain related to project
         * @summary Check the project related domain
         * @param {string} checkoutId ID of checkout
         * @param {string} origin Origin domain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embedCheckoutCheck: async (checkoutId: string, origin: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutId' is not null or undefined
            assertParamExists('embedCheckoutCheck', 'checkoutId', checkoutId)
            // verify required parameter 'origin' is not null or undefined
            assertParamExists('embedCheckoutCheck', 'origin', origin)
            const localVarPath = `/v2.0/embed/checkout/{checkout_id}`
                .replace(`{${"checkout_id"}}`, encodeURIComponent(String(checkoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a single checkout
         * @summary Show a checkout
         * @param {string} id ID of checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckout: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCheckout', 'id', id)
            const localVarPath = `/v2.0/checkouts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all checkouts
         * @summary List checkouts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [projectId] 
         * @param {'fixed_price' | 'no_price'} [pricingType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckouts: async (order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, projectId?: string, pricingType?: 'fixed_price' | 'no_price', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/checkouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (pricingType !== undefined) {
                localVarQueryParameter['pricing_type'] = pricingType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a checkout
         * @summary Update a checkout
         * @param {string} id ID of checkout
         * @param {CheckoutUpdateRequest} checkoutUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCheckout: async (id: string, checkoutUpdateRequest: CheckoutUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCheckout', 'id', id)
            // verify required parameter 'checkoutUpdateRequest' is not null or undefined
            assertParamExists('updateCheckout', 'checkoutUpdateRequest', checkoutUpdateRequest)
            const localVarPath = `/v2.0/checkouts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckoutsApi - functional programming interface
 * @export
 */
export const CheckoutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CheckoutsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cache image for checkout
         * @summary Cache image for checkout
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheCheckoutImage(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheCheckoutImage(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new checkout
         * @summary Create a checkout
         * @param {CheckoutCreateRequest} checkoutCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCheckout(checkoutCreateRequest: CheckoutCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckout(checkoutCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a checkout
         * @summary Delete a checkout
         * @param {string} id ID of checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCheckout(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCheckout(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the details of an checkout and validates domain related to project
         * @summary Check the project related domain
         * @param {string} checkoutId ID of checkout
         * @param {string} origin Origin domain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async embedCheckoutCheck(checkoutId: string, origin: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.embedCheckoutCheck(checkoutId, origin, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a single checkout
         * @summary Show a checkout
         * @param {string} id ID of checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckout(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckout(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all checkouts
         * @summary List checkouts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [projectId] 
         * @param {'fixed_price' | 'no_price'} [pricingType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckouts(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, projectId?: string, pricingType?: 'fixed_price' | 'no_price', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckouts(order, offset, limit, id, projectId, pricingType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a checkout
         * @summary Update a checkout
         * @param {string} id ID of checkout
         * @param {CheckoutUpdateRequest} checkoutUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCheckout(id: string, checkoutUpdateRequest: CheckoutUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCheckout(id, checkoutUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CheckoutsApi - factory interface
 * @export
 */
export const CheckoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CheckoutsApiFp(configuration)
    return {
        /**
         * Cache image for checkout
         * @summary Cache image for checkout
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheCheckoutImage(file?: any, options?: any): AxiosPromise<InlineResponse2008> {
            return localVarFp.cacheCheckoutImage(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new checkout
         * @summary Create a checkout
         * @param {CheckoutCreateRequest} checkoutCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckout(checkoutCreateRequest: CheckoutCreateRequest, options?: any): AxiosPromise<InlineResponse2007> {
            return localVarFp.createCheckout(checkoutCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a checkout
         * @summary Delete a checkout
         * @param {string} id ID of checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCheckout(id: string, options?: any): AxiosPromise<InlineResponse2009> {
            return localVarFp.deleteCheckout(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the details of an checkout and validates domain related to project
         * @summary Check the project related domain
         * @param {string} checkoutId ID of checkout
         * @param {string} origin Origin domain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        embedCheckoutCheck(checkoutId: string, origin: string, options?: any): AxiosPromise<InlineResponse2009> {
            return localVarFp.embedCheckoutCheck(checkoutId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a single checkout
         * @summary Show a checkout
         * @param {string} id ID of checkout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckout(id: string, options?: any): AxiosPromise<InlineResponse2007> {
            return localVarFp.getCheckout(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all checkouts
         * @summary List checkouts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [projectId] 
         * @param {'fixed_price' | 'no_price'} [pricingType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckouts(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, projectId?: string, pricingType?: 'fixed_price' | 'no_price', options?: any): AxiosPromise<InlineResponse2006> {
            return localVarFp.getCheckouts(order, offset, limit, id, projectId, pricingType, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a checkout
         * @summary Update a checkout
         * @param {string} id ID of checkout
         * @param {CheckoutUpdateRequest} checkoutUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCheckout(id: string, checkoutUpdateRequest: CheckoutUpdateRequest, options?: any): AxiosPromise<InlineResponse2007> {
            return localVarFp.updateCheckout(id, checkoutUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CheckoutsApi - object-oriented interface
 * @export
 * @class CheckoutsApi
 * @extends {BaseAPI}
 */
export class CheckoutsApi extends BaseAPI {
    /**
     * Cache image for checkout
     * @summary Cache image for checkout
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutsApi
     */
    public cacheCheckoutImage(file?: any, options?: any) {
        return CheckoutsApiFp(this.configuration).cacheCheckoutImage(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new checkout
     * @summary Create a checkout
     * @param {CheckoutCreateRequest} checkoutCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutsApi
     */
    public createCheckout(checkoutCreateRequest: CheckoutCreateRequest, options?: any) {
        return CheckoutsApiFp(this.configuration).createCheckout(checkoutCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a checkout
     * @summary Delete a checkout
     * @param {string} id ID of checkout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutsApi
     */
    public deleteCheckout(id: string, options?: any) {
        return CheckoutsApiFp(this.configuration).deleteCheckout(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the details of an checkout and validates domain related to project
     * @summary Check the project related domain
     * @param {string} checkoutId ID of checkout
     * @param {string} origin Origin domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutsApi
     */
    public embedCheckoutCheck(checkoutId: string, origin: string, options?: any) {
        return CheckoutsApiFp(this.configuration).embedCheckoutCheck(checkoutId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a single checkout
     * @summary Show a checkout
     * @param {string} id ID of checkout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutsApi
     */
    public getCheckout(id: string, options?: any) {
        return CheckoutsApiFp(this.configuration).getCheckout(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all checkouts
     * @summary List checkouts
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [id] 
     * @param {string} [projectId] 
     * @param {'fixed_price' | 'no_price'} [pricingType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutsApi
     */
    public getCheckouts(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, projectId?: string, pricingType?: 'fixed_price' | 'no_price', options?: any) {
        return CheckoutsApiFp(this.configuration).getCheckouts(order, offset, limit, id, projectId, pricingType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a checkout
     * @summary Update a checkout
     * @param {string} id ID of checkout
     * @param {CheckoutUpdateRequest} checkoutUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckoutsApi
     */
    public updateCheckout(id: string, checkoutUpdateRequest: CheckoutUpdateRequest, options?: any) {
        return CheckoutsApiFp(this.configuration).updateCheckout(id, checkoutUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommonApi - axios parameter creator
 * @export
 */
export const CommonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get rates
         * @summary Get rates
         * @param {NetworkAll} networkFrom Network to convert from
         * @param {SymbolAll} symbolFrom Symbol to convert from
         * @param {NetworkAll} networkTo Network to convert to
         * @param {SymbolAll} symbolTo Symbol to convert to
         * @param {string} amount Amount to be converted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRates: async (networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkFrom' is not null or undefined
            assertParamExists('getRates', 'networkFrom', networkFrom)
            // verify required parameter 'symbolFrom' is not null or undefined
            assertParamExists('getRates', 'symbolFrom', symbolFrom)
            // verify required parameter 'networkTo' is not null or undefined
            assertParamExists('getRates', 'networkTo', networkTo)
            // verify required parameter 'symbolTo' is not null or undefined
            assertParamExists('getRates', 'symbolTo', symbolTo)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getRates', 'amount', amount)
            const localVarPath = `/v2.0/rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (networkFrom !== undefined) {
                localVarQueryParameter['network_from'] = networkFrom;
            }

            if (symbolFrom !== undefined) {
                localVarQueryParameter['symbol_from'] = symbolFrom;
            }

            if (networkTo !== undefined) {
                localVarQueryParameter['network_to'] = networkTo;
            }

            if (symbolTo !== undefined) {
                localVarQueryParameter['symbol_to'] = symbolTo;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonApi - functional programming interface
 * @export
 */
export const CommonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonApiAxiosParamCreator(configuration)
    return {
        /**
         * Get rates
         * @summary Get rates
         * @param {NetworkAll} networkFrom Network to convert from
         * @param {SymbolAll} symbolFrom Symbol to convert from
         * @param {NetworkAll} networkTo Network to convert to
         * @param {SymbolAll} symbolTo Symbol to convert to
         * @param {string} amount Amount to be converted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRates(networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20047>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRates(networkFrom, symbolFrom, networkTo, symbolTo, amount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommonApi - factory interface
 * @export
 */
export const CommonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonApiFp(configuration)
    return {
        /**
         * Get rates
         * @summary Get rates
         * @param {NetworkAll} networkFrom Network to convert from
         * @param {SymbolAll} symbolFrom Symbol to convert from
         * @param {NetworkAll} networkTo Network to convert to
         * @param {SymbolAll} symbolTo Symbol to convert to
         * @param {string} amount Amount to be converted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRates(networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options?: any): AxiosPromise<InlineResponse20047> {
            return localVarFp.getRates(networkFrom, symbolFrom, networkTo, symbolTo, amount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonApi - object-oriented interface
 * @export
 * @class CommonApi
 * @extends {BaseAPI}
 */
export class CommonApi extends BaseAPI {
    /**
     * Get rates
     * @summary Get rates
     * @param {NetworkAll} networkFrom Network to convert from
     * @param {SymbolAll} symbolFrom Symbol to convert from
     * @param {NetworkAll} networkTo Network to convert to
     * @param {SymbolAll} symbolTo Symbol to convert to
     * @param {string} amount Amount to be converted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public getRates(networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options?: any) {
        return CommonApiFp(this.configuration).getRates(networkFrom, symbolFrom, networkTo, symbolTo, amount, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConfigApi - axios parameter creator
 * @export
 */
export const ConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        config: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async config(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20020>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.config(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        config(options?: any): AxiosPromise<InlineResponse20020> {
            return localVarFp.config(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public config(options?: any) {
        return ConfigApiFp(this.configuration).config(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ConvertsApi - axios parameter creator
 * @export
 */
export const ConvertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Show a convert
         * @summary Show a convert
         * @param {string} id ID of convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvert: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getConvert', 'id', id)
            const localVarPath = `/v2.0/converts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get convert token with amount and rate
         * @summary Get convert token with amount and rate
         * @param {NetworkAll} networkFrom Network to convert from
         * @param {SymbolAll} symbolFrom Symbol to convert from
         * @param {NetworkAll} networkTo Network to convert to
         * @param {SymbolAll} symbolTo Symbol to convert to
         * @param {string} amount Amount to be converted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertToken: async (networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkFrom' is not null or undefined
            assertParamExists('getConvertToken', 'networkFrom', networkFrom)
            // verify required parameter 'symbolFrom' is not null or undefined
            assertParamExists('getConvertToken', 'symbolFrom', symbolFrom)
            // verify required parameter 'networkTo' is not null or undefined
            assertParamExists('getConvertToken', 'networkTo', networkTo)
            // verify required parameter 'symbolTo' is not null or undefined
            assertParamExists('getConvertToken', 'symbolTo', symbolTo)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getConvertToken', 'amount', amount)
            const localVarPath = `/v2.0/converts/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (networkFrom !== undefined) {
                localVarQueryParameter['network_from'] = networkFrom;
            }

            if (symbolFrom !== undefined) {
                localVarQueryParameter['symbol_from'] = symbolFrom;
            }

            if (networkTo !== undefined) {
                localVarQueryParameter['network_to'] = networkTo;
            }

            if (symbolTo !== undefined) {
                localVarQueryParameter['symbol_to'] = symbolTo;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all converts
         * @summary List converts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {'pending' | 'success' | 'failed'} [status] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConverts: async (order?: 'asc' | 'desc', limit?: number, offset?: number, status?: 'pending' | 'success' | 'failed', id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/converts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all converts pairs
         * @summary List converts pairs
         * @param {'card' | 'bank'} [type] pairs type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertsPairs: async (type?: 'card' | 'bank', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/converts/pairs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schedule to convert
         * @summary Schedule to convert
         * @param {InlineObject31} inlineObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleToConvert: async (inlineObject31: InlineObject31, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject31' is not null or undefined
            assertParamExists('scheduleToConvert', 'inlineObject31', inlineObject31)
            const localVarPath = `/v2.0/converts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject31, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConvertsApi - functional programming interface
 * @export
 */
export const ConvertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConvertsApiAxiosParamCreator(configuration)
    return {
        /**
         * Show a convert
         * @summary Show a convert
         * @param {string} id ID of convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConvert(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20045>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConvert(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get convert token with amount and rate
         * @summary Get convert token with amount and rate
         * @param {NetworkAll} networkFrom Network to convert from
         * @param {SymbolAll} symbolFrom Symbol to convert from
         * @param {NetworkAll} networkTo Network to convert to
         * @param {SymbolAll} symbolTo Symbol to convert to
         * @param {string} amount Amount to be converted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConvertToken(networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20046>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConvertToken(networkFrom, symbolFrom, networkTo, symbolTo, amount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all converts
         * @summary List converts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {'pending' | 'success' | 'failed'} [status] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConverts(order?: 'asc' | 'desc', limit?: number, offset?: number, status?: 'pending' | 'success' | 'failed', id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20044>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConverts(order, limit, offset, status, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all converts pairs
         * @summary List converts pairs
         * @param {'card' | 'bank'} [type] pairs type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConvertsPairs(type?: 'card' | 'bank', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20043>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConvertsPairs(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Schedule to convert
         * @summary Schedule to convert
         * @param {InlineObject31} inlineObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleToConvert(inlineObject31: InlineObject31, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20045>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleToConvert(inlineObject31, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConvertsApi - factory interface
 * @export
 */
export const ConvertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConvertsApiFp(configuration)
    return {
        /**
         * Show a convert
         * @summary Show a convert
         * @param {string} id ID of convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvert(id: string, options?: any): AxiosPromise<InlineResponse20045> {
            return localVarFp.getConvert(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get convert token with amount and rate
         * @summary Get convert token with amount and rate
         * @param {NetworkAll} networkFrom Network to convert from
         * @param {SymbolAll} symbolFrom Symbol to convert from
         * @param {NetworkAll} networkTo Network to convert to
         * @param {SymbolAll} symbolTo Symbol to convert to
         * @param {string} amount Amount to be converted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertToken(networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options?: any): AxiosPromise<InlineResponse20046> {
            return localVarFp.getConvertToken(networkFrom, symbolFrom, networkTo, symbolTo, amount, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all converts
         * @summary List converts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {'pending' | 'success' | 'failed'} [status] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConverts(order?: 'asc' | 'desc', limit?: number, offset?: number, status?: 'pending' | 'success' | 'failed', id?: string, options?: any): AxiosPromise<InlineResponse20044> {
            return localVarFp.getConverts(order, limit, offset, status, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all converts pairs
         * @summary List converts pairs
         * @param {'card' | 'bank'} [type] pairs type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertsPairs(type?: 'card' | 'bank', options?: any): AxiosPromise<InlineResponse20043> {
            return localVarFp.getConvertsPairs(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Schedule to convert
         * @summary Schedule to convert
         * @param {InlineObject31} inlineObject31 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleToConvert(inlineObject31: InlineObject31, options?: any): AxiosPromise<InlineResponse20045> {
            return localVarFp.scheduleToConvert(inlineObject31, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConvertsApi - object-oriented interface
 * @export
 * @class ConvertsApi
 * @extends {BaseAPI}
 */
export class ConvertsApi extends BaseAPI {
    /**
     * Show a convert
     * @summary Show a convert
     * @param {string} id ID of convert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvertsApi
     */
    public getConvert(id: string, options?: any) {
        return ConvertsApiFp(this.configuration).getConvert(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get convert token with amount and rate
     * @summary Get convert token with amount and rate
     * @param {NetworkAll} networkFrom Network to convert from
     * @param {SymbolAll} symbolFrom Symbol to convert from
     * @param {NetworkAll} networkTo Network to convert to
     * @param {SymbolAll} symbolTo Symbol to convert to
     * @param {string} amount Amount to be converted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvertsApi
     */
    public getConvertToken(networkFrom: NetworkAll, symbolFrom: SymbolAll, networkTo: NetworkAll, symbolTo: SymbolAll, amount: string, options?: any) {
        return ConvertsApiFp(this.configuration).getConvertToken(networkFrom, symbolFrom, networkTo, symbolTo, amount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all converts
     * @summary List converts
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {'pending' | 'success' | 'failed'} [status] 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvertsApi
     */
    public getConverts(order?: 'asc' | 'desc', limit?: number, offset?: number, status?: 'pending' | 'success' | 'failed', id?: string, options?: any) {
        return ConvertsApiFp(this.configuration).getConverts(order, limit, offset, status, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all converts pairs
     * @summary List converts pairs
     * @param {'card' | 'bank'} [type] pairs type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvertsApi
     */
    public getConvertsPairs(type?: 'card' | 'bank', options?: any) {
        return ConvertsApiFp(this.configuration).getConvertsPairs(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schedule to convert
     * @summary Schedule to convert
     * @param {InlineObject31} inlineObject31 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvertsApi
     */
    public scheduleToConvert(inlineObject31: InlineObject31, options?: any) {
        return ConvertsApiFp(this.configuration).scheduleToConvert(inlineObject31, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all countries
         * @summary List countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all countries
         * @summary List countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountriesApiFp(configuration)
    return {
        /**
         * Returns all countries
         * @summary List countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options?: any): AxiosPromise<Response & object> {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
    /**
     * Returns all countries
     * @summary List countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountries(options?: any) {
        return CountriesApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
export const CurrenciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all currencies
         * @summary List currencies
         * @param {'crypto' | 'fiat' | 'card' | 'bank'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60; or &#x60;card&#x60; or &#x60;bank&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: async (type?: 'crypto' | 'fiat' | 'card' | 'bank', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrenciesApi - functional programming interface
 * @export
 */
export const CurrenciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all currencies
         * @summary List currencies
         * @param {'crypto' | 'fiat' | 'card' | 'bank'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60; or &#x60;card&#x60; or &#x60;bank&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencies(type?: 'crypto' | 'fiat' | 'card' | 'bank', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencies(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CurrenciesApi - factory interface
 * @export
 */
export const CurrenciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrenciesApiFp(configuration)
    return {
        /**
         * Returns all currencies
         * @summary List currencies
         * @param {'crypto' | 'fiat' | 'card' | 'bank'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60; or &#x60;card&#x60; or &#x60;bank&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(type?: 'crypto' | 'fiat' | 'card' | 'bank', options?: any): AxiosPromise<Response & object> {
            return localVarFp.getCurrencies(type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrenciesApi - object-oriented interface
 * @export
 * @class CurrenciesApi
 * @extends {BaseAPI}
 */
export class CurrenciesApi extends BaseAPI {
    /**
     * Returns all currencies
     * @summary List currencies
     * @param {'crypto' | 'fiat' | 'card' | 'bank'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60; or &#x60;card&#x60; or &#x60;bank&#x60;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    public getCurrencies(type?: 'crypto' | 'fiat' | 'card' | 'bank', options?: any) {
        return CurrenciesApiFp(this.configuration).getCurrencies(type, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DepositsApi - axios parameter creator
 * @export
 */
export const DepositsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new deposit
         * @summary Create a deposit
         * @param {DepositCreateRequest} depositCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeposit: async (depositCreateRequest: DepositCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'depositCreateRequest' is not null or undefined
            assertParamExists('createDeposit', 'depositCreateRequest', depositCreateRequest)
            const localVarPath = `/v2.0/deposits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(depositCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a single deposit
         * @summary Show a deposit
         * @param {string} id ID of deposit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeposit: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDeposit', 'id', id)
            const localVarPath = `/v2.0/deposits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all deposits
         * @summary List deposits
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeposits: async (order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/deposits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all deposits payments
         * @summary List deposits payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [depositId] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositsPayments: async (order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, depositId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/deposits/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (depositId !== undefined) {
                localVarQueryParameter['deposit_id'] = depositId;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (addressTo !== undefined) {
                localVarQueryParameter['address_to'] = addressTo;
            }

            if (txId !== undefined) {
                localVarQueryParameter['tx_id'] = txId;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (amlLevel !== undefined) {
                localVarQueryParameter['aml_level'] = amlLevel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepositsApi - functional programming interface
 * @export
 */
export const DepositsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepositsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new deposit
         * @summary Create a deposit
         * @param {DepositCreateRequest} depositCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeposit(depositCreateRequest: DepositCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeposit(depositCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a single deposit
         * @summary Show a deposit
         * @param {string} id ID of deposit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeposit(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeposit(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all deposits
         * @summary List deposits
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeposits(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeposits(order, offset, limit, projectId, network, symbol, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all deposits payments
         * @summary List deposits payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [depositId] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositsPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, depositId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositsPayments(order, offset, limit, id, depositId, address, addressTo, txId, network, symbol, status, amlLevel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepositsApi - factory interface
 * @export
 */
export const DepositsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepositsApiFp(configuration)
    return {
        /**
         * Create a new deposit
         * @summary Create a deposit
         * @param {DepositCreateRequest} depositCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeposit(depositCreateRequest: DepositCreateRequest, options?: any): AxiosPromise<InlineResponse2004> {
            return localVarFp.createDeposit(depositCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a single deposit
         * @summary Show a deposit
         * @param {string} id ID of deposit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeposit(id: string, options?: any): AxiosPromise<InlineResponse2004> {
            return localVarFp.getDeposit(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all deposits
         * @summary List deposits
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeposits(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, options?: any): AxiosPromise<InlineResponse2003> {
            return localVarFp.getDeposits(order, offset, limit, projectId, network, symbol, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all deposits payments
         * @summary List deposits payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [depositId] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositsPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, depositId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any): AxiosPromise<InlineResponse2005> {
            return localVarFp.getDepositsPayments(order, offset, limit, id, depositId, address, addressTo, txId, network, symbol, status, amlLevel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepositsApi - object-oriented interface
 * @export
 * @class DepositsApi
 * @extends {BaseAPI}
 */
export class DepositsApi extends BaseAPI {
    /**
     * Create a new deposit
     * @summary Create a deposit
     * @param {DepositCreateRequest} depositCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public createDeposit(depositCreateRequest: DepositCreateRequest, options?: any) {
        return DepositsApiFp(this.configuration).createDeposit(depositCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a single deposit
     * @summary Show a deposit
     * @param {string} id ID of deposit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public getDeposit(id: string, options?: any) {
        return DepositsApiFp(this.configuration).getDeposit(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all deposits
     * @summary List deposits
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [projectId] 
     * @param {NetworkCrypto} [network] 
     * @param {SymbolCrypto} [symbol] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public getDeposits(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, options?: any) {
        return DepositsApiFp(this.configuration).getDeposits(order, offset, limit, projectId, network, symbol, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all deposits payments
     * @summary List deposits payments
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [id] 
     * @param {string} [depositId] 
     * @param {string} [address] 
     * @param {string} [addressTo] 
     * @param {string} [txId] 
     * @param {NetworkCrypto} [network] 
     * @param {SymbolCrypto} [symbol] 
     * @param {'pending' | 'confirmed' | 'failed'} [status] 
     * @param {'low' | 'medium' | 'high'} [amlLevel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public getDepositsPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, depositId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any) {
        return DepositsApiFp(this.configuration).getDepositsPayments(order, offset, limit, id, depositId, address, addressTo, txId, network, symbol, status, amlLevel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FiatWithdrawalsApi - axios parameter creator
 * @export
 */
export const FiatWithdrawalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel a single fiat withdrawal
         * @summary Cancel a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFiatWithdrawal: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelFiatWithdrawal', 'id', id)
            const localVarPath = `/v2.0/fiat-withdrawals/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a fiat withdrawal
         * @summary Create a fiat withdrawal
         * @param {InlineObject29} inlineObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiatWithdrawal: async (inlineObject29: InlineObject29, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject29' is not null or undefined
            assertParamExists('createFiatWithdrawal', 'inlineObject29', inlineObject29)
            const localVarPath = `/v2.0/fiat-withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject29, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a single fiat withdrawal
         * @summary Show a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatWithdrawal: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFiatWithdrawal', 'id', id)
            const localVarPath = `/v2.0/fiat-withdrawals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all fiat withdrawals
         * @summary List fiat withdrawals
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListFiatWithdrawals: async (order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/fiat-withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a single fiat withdrawal
         * @summary Send a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFiatWithdrawal: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendFiatWithdrawal', 'id', id)
            const localVarPath = `/v2.0/fiat-withdrawals/{id}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiatWithdrawalsApi - functional programming interface
 * @export
 */
export const FiatWithdrawalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FiatWithdrawalsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel a single fiat withdrawal
         * @summary Cancel a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelFiatWithdrawal(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20038>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelFiatWithdrawal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a fiat withdrawal
         * @summary Create a fiat withdrawal
         * @param {InlineObject29} inlineObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFiatWithdrawal(inlineObject29: InlineObject29, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20034>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFiatWithdrawal(inlineObject29, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a single fiat withdrawal
         * @summary Show a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiatWithdrawal(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20038>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiatWithdrawal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all fiat withdrawals
         * @summary List fiat withdrawals
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListFiatWithdrawals(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20037>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListFiatWithdrawals(order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send a single fiat withdrawal
         * @summary Send a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFiatWithdrawal(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20038>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFiatWithdrawal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FiatWithdrawalsApi - factory interface
 * @export
 */
export const FiatWithdrawalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FiatWithdrawalsApiFp(configuration)
    return {
        /**
         * Cancel a single fiat withdrawal
         * @summary Cancel a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFiatWithdrawal(id: string, options?: any): AxiosPromise<InlineResponse20038> {
            return localVarFp.cancelFiatWithdrawal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a fiat withdrawal
         * @summary Create a fiat withdrawal
         * @param {InlineObject29} inlineObject29 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiatWithdrawal(inlineObject29: InlineObject29, options?: any): AxiosPromise<InlineResponse20034> {
            return localVarFp.createFiatWithdrawal(inlineObject29, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a single fiat withdrawal
         * @summary Show a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatWithdrawal(id: string, options?: any): AxiosPromise<InlineResponse20038> {
            return localVarFp.getFiatWithdrawal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all fiat withdrawals
         * @summary List fiat withdrawals
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListFiatWithdrawals(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20037> {
            return localVarFp.getListFiatWithdrawals(order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a single fiat withdrawal
         * @summary Send a fiat withdrawal
         * @param {string} id ID of fiat withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFiatWithdrawal(id: string, options?: any): AxiosPromise<InlineResponse20038> {
            return localVarFp.sendFiatWithdrawal(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FiatWithdrawalsApi - object-oriented interface
 * @export
 * @class FiatWithdrawalsApi
 * @extends {BaseAPI}
 */
export class FiatWithdrawalsApi extends BaseAPI {
    /**
     * Cancel a single fiat withdrawal
     * @summary Cancel a fiat withdrawal
     * @param {string} id ID of fiat withdrawal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiatWithdrawalsApi
     */
    public cancelFiatWithdrawal(id: string, options?: any) {
        return FiatWithdrawalsApiFp(this.configuration).cancelFiatWithdrawal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a fiat withdrawal
     * @summary Create a fiat withdrawal
     * @param {InlineObject29} inlineObject29 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiatWithdrawalsApi
     */
    public createFiatWithdrawal(inlineObject29: InlineObject29, options?: any) {
        return FiatWithdrawalsApiFp(this.configuration).createFiatWithdrawal(inlineObject29, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a single fiat withdrawal
     * @summary Show a fiat withdrawal
     * @param {string} id ID of fiat withdrawal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiatWithdrawalsApi
     */
    public getFiatWithdrawal(id: string, options?: any) {
        return FiatWithdrawalsApiFp(this.configuration).getFiatWithdrawal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all fiat withdrawals
     * @summary List fiat withdrawals
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiatWithdrawalsApi
     */
    public getListFiatWithdrawals(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return FiatWithdrawalsApiFp(this.configuration).getListFiatWithdrawals(order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a single fiat withdrawal
     * @summary Send a fiat withdrawal
     * @param {string} id ID of fiat withdrawal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiatWithdrawalsApi
     */
    public sendFiatWithdrawal(id: string, options?: any) {
        return FiatWithdrawalsApiFp(this.configuration).sendFiatWithdrawal(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * To send an invoice in cryptocurrency, you need to create an invoice object and provide the user with the hosted url where they will be able to pay. Once an invoice is viewed at the hosted url, a charge will be generated on the invoice.
         * @summary Create an invoice
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice: async (inlineObject4: InlineObject4, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject4' is not null or undefined
            assertParamExists('createInvoice', 'inlineObject4', inlineObject4)
            const localVarPath = `/v2.0/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of an invoice that has been previously created.
         * @summary Show an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInvoice', 'id', id)
            const localVarPath = `/v2.0/invoices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all invoices
         * @summary List invoices
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {'open' | 'viewed' | 'paid' | 'void' | 'unresolved'} [status] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, status?: 'open' | 'viewed' | 'paid' | 'void' | 'unresolved', id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve an invoice that has been previously marked as unresolved. Supply the unique invoice ID that was returned when the invoice was created.
         * @summary Resolve an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveInvoice: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolveInvoice', 'id', id)
            const localVarPath = `/v2.0/invoices/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Charge will be generated on the invoice.
         * @summary View an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewInvoice: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('viewInvoice', 'id', id)
            const localVarPath = `/v2.0/invoices/{id}/view`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Voids an invoice that has been previously created. Supply the unique invoice ID that was returned when the invoice was created.
         * @summary Void an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidInvoice: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('voidInvoice', 'id', id)
            const localVarPath = `/v2.0/invoices/{id}/void`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * To send an invoice in cryptocurrency, you need to create an invoice object and provide the user with the hosted url where they will be able to pay. Once an invoice is viewed at the hosted url, a charge will be generated on the invoice.
         * @summary Create an invoice
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoice(inlineObject4: InlineObject4, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoice(inlineObject4, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves the details of an invoice that has been previously created.
         * @summary Show an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoice(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all invoices
         * @summary List invoices
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {'open' | 'viewed' | 'paid' | 'void' | 'unresolved'} [status] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, status?: 'open' | 'viewed' | 'paid' | 'void' | 'unresolved', id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20010>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(order, offset, limit, projectId, status, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resolve an invoice that has been previously marked as unresolved. Supply the unique invoice ID that was returned when the invoice was created.
         * @summary Resolve an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveInvoice(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Charge will be generated on the invoice.
         * @summary View an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewInvoice(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Voids an invoice that has been previously created. Supply the unique invoice ID that was returned when the invoice was created.
         * @summary Void an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voidInvoice(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20011>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voidInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * To send an invoice in cryptocurrency, you need to create an invoice object and provide the user with the hosted url where they will be able to pay. Once an invoice is viewed at the hosted url, a charge will be generated on the invoice.
         * @summary Create an invoice
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoice(inlineObject4: InlineObject4, options?: any): AxiosPromise<InlineResponse20011> {
            return localVarFp.createInvoice(inlineObject4, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the details of an invoice that has been previously created.
         * @summary Show an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice(id: string, options?: any): AxiosPromise<InlineResponse20011> {
            return localVarFp.getInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all invoices
         * @summary List invoices
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [projectId] 
         * @param {'open' | 'viewed' | 'paid' | 'void' | 'unresolved'} [status] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, status?: 'open' | 'viewed' | 'paid' | 'void' | 'unresolved', id?: string, options?: any): AxiosPromise<InlineResponse20010> {
            return localVarFp.getInvoices(order, offset, limit, projectId, status, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve an invoice that has been previously marked as unresolved. Supply the unique invoice ID that was returned when the invoice was created.
         * @summary Resolve an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveInvoice(id: string, options?: any): AxiosPromise<InlineResponse20011> {
            return localVarFp.resolveInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Charge will be generated on the invoice.
         * @summary View an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewInvoice(id: string, options?: any): AxiosPromise<InlineResponse20011> {
            return localVarFp.viewInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Voids an invoice that has been previously created. Supply the unique invoice ID that was returned when the invoice was created.
         * @summary Void an invoice
         * @param {string} id ID of invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidInvoice(id: string, options?: any): AxiosPromise<InlineResponse20011> {
            return localVarFp.voidInvoice(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI {
    /**
     * To send an invoice in cryptocurrency, you need to create an invoice object and provide the user with the hosted url where they will be able to pay. Once an invoice is viewed at the hosted url, a charge will be generated on the invoice.
     * @summary Create an invoice
     * @param {InlineObject4} inlineObject4 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public createInvoice(inlineObject4: InlineObject4, options?: any) {
        return InvoicesApiFp(this.configuration).createInvoice(inlineObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the details of an invoice that has been previously created.
     * @summary Show an invoice
     * @param {string} id ID of invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoice(id: string, options?: any) {
        return InvoicesApiFp(this.configuration).getInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all invoices
     * @summary List invoices
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [projectId] 
     * @param {'open' | 'viewed' | 'paid' | 'void' | 'unresolved'} [status] 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoices(order?: 'asc' | 'desc', offset?: number, limit?: number, projectId?: string, status?: 'open' | 'viewed' | 'paid' | 'void' | 'unresolved', id?: string, options?: any) {
        return InvoicesApiFp(this.configuration).getInvoices(order, offset, limit, projectId, status, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve an invoice that has been previously marked as unresolved. Supply the unique invoice ID that was returned when the invoice was created.
     * @summary Resolve an invoice
     * @param {string} id ID of invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public resolveInvoice(id: string, options?: any) {
        return InvoicesApiFp(this.configuration).resolveInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Charge will be generated on the invoice.
     * @summary View an invoice
     * @param {string} id ID of invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public viewInvoice(id: string, options?: any) {
        return InvoicesApiFp(this.configuration).viewInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Voids an invoice that has been previously created. Supply the unique invoice ID that was returned when the invoice was created.
     * @summary Void an invoice
     * @param {string} id ID of invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public voidInvoice(id: string, options?: any) {
        return InvoicesApiFp(this.configuration).voidInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MassPayoutsApi - axios parameter creator
 * @export
 */
export const MassPayoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel unconfirmed mass payout.
         * @summary Cancel unconfirmed mass payout.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/v2.0/mass-payouts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a mass payout
         * @summary Create a mass payout
         * @param {MassPayoutJsonCreate} massPayoutJsonCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMassPayout: async (massPayoutJsonCreate: MassPayoutJsonCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'massPayoutJsonCreate' is not null or undefined
            assertParamExists('createMassPayout', 'massPayoutJsonCreate', massPayoutJsonCreate)
            const localVarPath = `/v2.0/mass-payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(massPayoutJsonCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of mass payouts
         * @summary List of mass payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMassPayouts: async (externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/mass-payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of payouts from a mass payout
         * @summary List of payouts from a mass payout
         * @param {string} id 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayouts: async (id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listPayouts', 'id', id)
            const localVarPath = `/v2.0/mass-payouts/{id}/payouts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm sending of mass payout.
         * @summary Confirm sending of mass payout.
         * @param {string} id 
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: async (id: string, inlineObject5: InlineObject5, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('send', 'id', id)
            // verify required parameter 'inlineObject5' is not null or undefined
            assertParamExists('send', 'inlineObject5', inlineObject5)
            const localVarPath = `/v2.0/mass-payouts/{id}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MassPayoutsApi - functional programming interface
 * @export
 */
export const MassPayoutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MassPayoutsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel unconfirmed mass payout.
         * @summary Cancel unconfirmed mass payout.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a mass payout
         * @summary Create a mass payout
         * @param {MassPayoutJsonCreate} massPayoutJsonCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMassPayout(massPayoutJsonCreate: MassPayoutJsonCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMassPayout(massPayoutJsonCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of mass payouts
         * @summary List of mass payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMassPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMassPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of payouts from a mass payout
         * @summary List of payouts from a mass payout
         * @param {string} id 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPayouts(id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPayouts(id, externalId, createdAtFrom, createdAtTo, status, order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Confirm sending of mass payout.
         * @summary Confirm sending of mass payout.
         * @param {string} id 
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async send(id: string, inlineObject5: InlineObject5, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.send(id, inlineObject5, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MassPayoutsApi - factory interface
 * @export
 */
export const MassPayoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MassPayoutsApiFp(configuration)
    return {
        /**
         * Cancel unconfirmed mass payout.
         * @summary Cancel unconfirmed mass payout.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a mass payout
         * @summary Create a mass payout
         * @param {MassPayoutJsonCreate} massPayoutJsonCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMassPayout(massPayoutJsonCreate: MassPayoutJsonCreate, options?: any): AxiosPromise<InlineResponse20013> {
            return localVarFp.createMassPayout(massPayoutJsonCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * List of mass payouts
         * @summary List of mass payouts
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMassPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20012> {
            return localVarFp.listMassPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List of payouts from a mass payout
         * @summary List of payouts from a mass payout
         * @param {string} id 
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPayouts(id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20014> {
            return localVarFp.listPayouts(id, externalId, createdAtFrom, createdAtTo, status, order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm sending of mass payout.
         * @summary Confirm sending of mass payout.
         * @param {string} id 
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send(id: string, inlineObject5: InlineObject5, options?: any): AxiosPromise<InlineResponse20013> {
            return localVarFp.send(id, inlineObject5, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MassPayoutsApi - object-oriented interface
 * @export
 * @class MassPayoutsApi
 * @extends {BaseAPI}
 */
export class MassPayoutsApi extends BaseAPI {
    /**
     * Cancel unconfirmed mass payout.
     * @summary Cancel unconfirmed mass payout.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MassPayoutsApi
     */
    public _delete(id: string, options?: any) {
        return MassPayoutsApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a mass payout
     * @summary Create a mass payout
     * @param {MassPayoutJsonCreate} massPayoutJsonCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MassPayoutsApi
     */
    public createMassPayout(massPayoutJsonCreate: MassPayoutJsonCreate, options?: any) {
        return MassPayoutsApiFp(this.configuration).createMassPayout(massPayoutJsonCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of mass payouts
     * @summary List of mass payouts
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MassPayoutsApi
     */
    public listMassPayouts(externalId?: string, createdAtFrom?: string, createdAtTo?: string, order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return MassPayoutsApiFp(this.configuration).listMassPayouts(externalId, createdAtFrom, createdAtTo, order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of payouts from a mass payout
     * @summary List of payouts from a mass payout
     * @param {string} id 
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {'new' | 'pending' | 'completed' | 'failed'} [status] Filter by payout status
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MassPayoutsApi
     */
    public listPayouts(id: string, externalId?: string, createdAtFrom?: string, createdAtTo?: string, status?: 'new' | 'pending' | 'completed' | 'failed', order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return MassPayoutsApiFp(this.configuration).listPayouts(id, externalId, createdAtFrom, createdAtTo, status, order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm sending of mass payout.
     * @summary Confirm sending of mass payout.
     * @param {string} id 
     * @param {InlineObject5} inlineObject5 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MassPayoutsApi
     */
    public send(id: string, inlineObject5: InlineObject5, options?: any) {
        return MassPayoutsApiFp(this.configuration).send(id, inlineObject5, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MerchantApi - axios parameter creator
 * @export
 */
export const MerchantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Confirm to change email using code
         * @param {InlineObject17} inlineObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailConfirm: async (inlineObject17: InlineObject17, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject17' is not null or undefined
            assertParamExists('changeEmailConfirm', 'inlineObject17', inlineObject17)
            const localVarPath = `/v2.0/merchant/change_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject17, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate of changing email
         * @param {InlineObject16} inlineObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailStart: async (inlineObject16: InlineObject16, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject16' is not null or undefined
            assertParamExists('changeEmailStart', 'inlineObject16', inlineObject16)
            const localVarPath = `/v2.0/merchant/change_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject16, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get status of change email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailStatus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/change_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schedule report creation
         * @summary Schedule report creation
         * @param {ReportCreate} reportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport: async (reportCreate: ReportCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportCreate' is not null or undefined
            assertParamExists('createReport', 'reportCreate', reportCreate)
            const localVarPath = `/v2.0/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns balances for merchant accounts.  ❗ There are three different balances returned:  **Posted balance**: the money that has fully settled in an Account.  **Pending balance**: the money that\'s expected to settle in or out of an Account plus the money that\'s already settled.  **Available balance**: the money that\'s available to send out of an Account. This balance subtracts money that’s expected to leave an Account, but does not include money that\'s expected to settle in an Account.  **Diff balance**: the difference between **Pending balance** and **Available balance**
         * @summary Get Merchant\'s balances
         * @param {string} [symbol] Filter by symbol
         * @param {string} [network] Filter by network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalances: async (symbol?: string, network?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get amounts of merchant\'s crypto converted to fiat (including total balance).
         * @param {'USD'} symbolTo Symbol to convert
         * @param {'fiat'} [networkTo] Network to convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertedBalances: async (symbolTo: 'USD', networkTo?: 'fiat', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolTo' is not null or undefined
            assertParamExists('getConvertedBalances', 'symbolTo', symbolTo)
            const localVarPath = `/v2.0/balances/converted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (symbolTo !== undefined) {
                localVarQueryParameter['symbol_to'] = symbolTo;
            }

            if (networkTo !== undefined) {
                localVarQueryParameter['network_to'] = networkTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns merchant data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantInfo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For this request the section \"details\" and KYB level 0 must be provided within a merchant profile. Otherwise a 422 error will be returned.
         * @summary Get the merchant\'s KYB url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantKybUrl: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/kyb-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The method returns an information about the user\'s operations balances and limits. Only works with crypto currencies.
         * @summary Get the merchant\'s limits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantLimitsApproximately: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/limits-approximately`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Merchant\'s operations stats for the specified period. All amounts converted to USD
         * @param {'day' | 'week' | 'month' | 'year'} [period] Stat period. Default day
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats: async (period?: 'day' | 'week' | 'month' | 'year', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Merchant\'s transactions
         * @param {string} [projectId] Filter by project ID
         * @param {'pending' | 'posted'} [status] Filter by status of ledger transaction
         * @param {'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout'} [resource] Filter by resource type
         * @param {string} [externalId] Filter by operation External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {string} [symbol] Filter by currency symbol
         * @param {NetworkCrypto} [network] Filter by Network
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {'created_at' | 'effective_at'} [orderBy] Field to order by
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactions: async (projectId?: string, status?: 'pending' | 'posted', resource?: 'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout', externalId?: string, createdAtFrom?: string, createdAtTo?: string, symbol?: string, network?: NetworkCrypto, order?: 'asc' | 'desc', orderBy?: 'created_at' | 'effective_at', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (resource !== undefined) {
                localVarQueryParameter['resource'] = resource;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary (Re)Send verification operation code
         * @param {VerificationOperationCodeSendRequest} verificationOperationCodeSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantVerificationOperationCodeSend: async (verificationOperationCodeSendRequest: VerificationOperationCodeSendRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'verificationOperationCodeSendRequest' is not null or undefined
            assertParamExists('merchantVerificationOperationCodeSend', 'verificationOperationCodeSendRequest', verificationOperationCodeSendRequest)
            const localVarPath = `/v2.0/merchant/verification-operation-code/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationOperationCodeSendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set resolve_overpaid and resolve_underpaid charge options
         * @param {InlineObject19} inlineObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCharges: async (inlineObject19: InlineObject19, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject19' is not null or undefined
            assertParamExists('resolveCharges', 'inlineObject19', inlineObject19)
            const localVarPath = `/v2.0/merchant/resolve-charges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject19, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set of exchange
         * @param {InlineObject18} inlineObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExchangeTo: async (inlineObject18: InlineObject18, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject18' is not null or undefined
            assertParamExists('setExchangeTo', 'inlineObject18', inlineObject18)
            const localVarPath = `/v2.0/merchant/exchange-to`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject18, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantApi - functional programming interface
 * @export
 */
export const MerchantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantApiAxiosParamCreator(configuration)
    return {
        /**
         * Confirm to change email using code
         * @param {InlineObject17} inlineObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmailConfirm(inlineObject17: InlineObject17, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmailConfirm(inlineObject17, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initiate of changing email
         * @param {InlineObject16} inlineObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmailStart(inlineObject16: InlineObject16, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmailStart(inlineObject16, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get status of change email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmailStatus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmailStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Schedule report creation
         * @summary Schedule report creation
         * @param {ReportCreate} reportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReport(reportCreate: ReportCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReport(reportCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns balances for merchant accounts.  ❗ There are three different balances returned:  **Posted balance**: the money that has fully settled in an Account.  **Pending balance**: the money that\'s expected to settle in or out of an Account plus the money that\'s already settled.  **Available balance**: the money that\'s available to send out of an Account. This balance subtracts money that’s expected to leave an Account, but does not include money that\'s expected to settle in an Account.  **Diff balance**: the difference between **Pending balance** and **Available balance**
         * @summary Get Merchant\'s balances
         * @param {string} [symbol] Filter by symbol
         * @param {string} [network] Filter by network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalances(symbol?: string, network?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalances(symbol, network, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get amounts of merchant\'s crypto converted to fiat (including total balance).
         * @param {'USD'} symbolTo Symbol to convert
         * @param {'fiat'} [networkTo] Network to convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConvertedBalances(symbolTo: 'USD', networkTo?: 'fiat', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConvertedBalances(symbolTo, networkTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns merchant data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantInfo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * For this request the section \"details\" and KYB level 0 must be provided within a merchant profile. Otherwise a 422 error will be returned.
         * @summary Get the merchant\'s KYB url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantKybUrl(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantKybUrl(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The method returns an information about the user\'s operations balances and limits. Only works with crypto currencies.
         * @summary Get the merchant\'s limits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantLimitsApproximately(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20023>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantLimitsApproximately(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Merchant\'s operations stats for the specified period. All amounts converted to USD
         * @param {'day' | 'week' | 'month' | 'year'} [period] Stat period. Default day
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStats(period?: 'day' | 'week' | 'month' | 'year', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStats(period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Merchant\'s transactions
         * @param {string} [projectId] Filter by project ID
         * @param {'pending' | 'posted'} [status] Filter by status of ledger transaction
         * @param {'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout'} [resource] Filter by resource type
         * @param {string} [externalId] Filter by operation External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {string} [symbol] Filter by currency symbol
         * @param {NetworkCrypto} [network] Filter by Network
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {'created_at' | 'effective_at'} [orderBy] Field to order by
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactions(projectId?: string, status?: 'pending' | 'posted', resource?: 'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout', externalId?: string, createdAtFrom?: string, createdAtTo?: string, symbol?: string, network?: NetworkCrypto, order?: 'asc' | 'desc', orderBy?: 'created_at' | 'effective_at', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactions(projectId, status, resource, externalId, createdAtFrom, createdAtTo, symbol, network, order, orderBy, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary (Re)Send verification operation code
         * @param {VerificationOperationCodeSendRequest} verificationOperationCodeSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantVerificationOperationCodeSend(verificationOperationCodeSendRequest: VerificationOperationCodeSendRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20031>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantVerificationOperationCodeSend(verificationOperationCodeSendRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set resolve_overpaid and resolve_underpaid charge options
         * @param {InlineObject19} inlineObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveCharges(inlineObject19: InlineObject19, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveCharges(inlineObject19, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set of exchange
         * @param {InlineObject18} inlineObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExchangeTo(inlineObject18: InlineObject18, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExchangeTo(inlineObject18, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MerchantApi - factory interface
 * @export
 */
export const MerchantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantApiFp(configuration)
    return {
        /**
         * Confirm to change email using code
         * @param {InlineObject17} inlineObject17 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailConfirm(inlineObject17: InlineObject17, options?: any): AxiosPromise<Response> {
            return localVarFp.changeEmailConfirm(inlineObject17, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate of changing email
         * @param {InlineObject16} inlineObject16 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailStart(inlineObject16: InlineObject16, options?: any): AxiosPromise<Response> {
            return localVarFp.changeEmailStart(inlineObject16, options).then((request) => request(axios, basePath));
        },
        /**
         * Get status of change email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailStatus(options?: any): AxiosPromise<Response & object> {
            return localVarFp.changeEmailStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Schedule report creation
         * @summary Schedule report creation
         * @param {ReportCreate} reportCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReport(reportCreate: ReportCreate, options?: any): AxiosPromise<void> {
            return localVarFp.createReport(reportCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns balances for merchant accounts.  ❗ There are three different balances returned:  **Posted balance**: the money that has fully settled in an Account.  **Pending balance**: the money that\'s expected to settle in or out of an Account plus the money that\'s already settled.  **Available balance**: the money that\'s available to send out of an Account. This balance subtracts money that’s expected to leave an Account, but does not include money that\'s expected to settle in an Account.  **Diff balance**: the difference between **Pending balance** and **Available balance**
         * @summary Get Merchant\'s balances
         * @param {string} [symbol] Filter by symbol
         * @param {string} [network] Filter by network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalances(symbol?: string, network?: string, options?: any): AxiosPromise<Response & object> {
            return localVarFp.getBalances(symbol, network, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get amounts of merchant\'s crypto converted to fiat (including total balance).
         * @param {'USD'} symbolTo Symbol to convert
         * @param {'fiat'} [networkTo] Network to convert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConvertedBalances(symbolTo: 'USD', networkTo?: 'fiat', options?: any): AxiosPromise<Response & object> {
            return localVarFp.getConvertedBalances(symbolTo, networkTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns merchant data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantInfo(options?: any): AxiosPromise<InlineResponse20021> {
            return localVarFp.getMerchantInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * For this request the section \"details\" and KYB level 0 must be provided within a merchant profile. Otherwise a 422 error will be returned.
         * @summary Get the merchant\'s KYB url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantKybUrl(options?: any): AxiosPromise<InlineResponse20022> {
            return localVarFp.getMerchantKybUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * The method returns an information about the user\'s operations balances and limits. Only works with crypto currencies.
         * @summary Get the merchant\'s limits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantLimitsApproximately(options?: any): AxiosPromise<InlineResponse20023> {
            return localVarFp.getMerchantLimitsApproximately(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Merchant\'s operations stats for the specified period. All amounts converted to USD
         * @param {'day' | 'week' | 'month' | 'year'} [period] Stat period. Default day
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats(period?: 'day' | 'week' | 'month' | 'year', options?: any): AxiosPromise<Response & object> {
            return localVarFp.getStats(period, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Merchant\'s transactions
         * @param {string} [projectId] Filter by project ID
         * @param {'pending' | 'posted'} [status] Filter by status of ledger transaction
         * @param {'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout'} [resource] Filter by resource type
         * @param {string} [externalId] Filter by operation External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {string} [symbol] Filter by currency symbol
         * @param {NetworkCrypto} [network] Filter by Network
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {'created_at' | 'effective_at'} [orderBy] Field to order by
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactions(projectId?: string, status?: 'pending' | 'posted', resource?: 'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout', externalId?: string, createdAtFrom?: string, createdAtTo?: string, symbol?: string, network?: NetworkCrypto, order?: 'asc' | 'desc', orderBy?: 'created_at' | 'effective_at', offset?: number, limit?: number, options?: any): AxiosPromise<Response & object> {
            return localVarFp.getTransactions(projectId, status, resource, externalId, createdAtFrom, createdAtTo, symbol, network, order, orderBy, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary (Re)Send verification operation code
         * @param {VerificationOperationCodeSendRequest} verificationOperationCodeSendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantVerificationOperationCodeSend(verificationOperationCodeSendRequest: VerificationOperationCodeSendRequest, options?: any): AxiosPromise<InlineResponse20031> {
            return localVarFp.merchantVerificationOperationCodeSend(verificationOperationCodeSendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set resolve_overpaid and resolve_underpaid charge options
         * @param {InlineObject19} inlineObject19 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveCharges(inlineObject19: InlineObject19, options?: any): AxiosPromise<InlineResponse20021> {
            return localVarFp.resolveCharges(inlineObject19, options).then((request) => request(axios, basePath));
        },
        /**
         * Set of exchange
         * @param {InlineObject18} inlineObject18 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExchangeTo(inlineObject18: InlineObject18, options?: any): AxiosPromise<InlineResponse20021> {
            return localVarFp.setExchangeTo(inlineObject18, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantApi - object-oriented interface
 * @export
 * @class MerchantApi
 * @extends {BaseAPI}
 */
export class MerchantApi extends BaseAPI {
    /**
     * Confirm to change email using code
     * @param {InlineObject17} inlineObject17 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public changeEmailConfirm(inlineObject17: InlineObject17, options?: any) {
        return MerchantApiFp(this.configuration).changeEmailConfirm(inlineObject17, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate of changing email
     * @param {InlineObject16} inlineObject16 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public changeEmailStart(inlineObject16: InlineObject16, options?: any) {
        return MerchantApiFp(this.configuration).changeEmailStart(inlineObject16, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get status of change email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public changeEmailStatus(options?: any) {
        return MerchantApiFp(this.configuration).changeEmailStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schedule report creation
     * @summary Schedule report creation
     * @param {ReportCreate} reportCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public createReport(reportCreate: ReportCreate, options?: any) {
        return MerchantApiFp(this.configuration).createReport(reportCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns balances for merchant accounts.  ❗ There are three different balances returned:  **Posted balance**: the money that has fully settled in an Account.  **Pending balance**: the money that\'s expected to settle in or out of an Account plus the money that\'s already settled.  **Available balance**: the money that\'s available to send out of an Account. This balance subtracts money that’s expected to leave an Account, but does not include money that\'s expected to settle in an Account.  **Diff balance**: the difference between **Pending balance** and **Available balance**
     * @summary Get Merchant\'s balances
     * @param {string} [symbol] Filter by symbol
     * @param {string} [network] Filter by network
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public getBalances(symbol?: string, network?: string, options?: any) {
        return MerchantApiFp(this.configuration).getBalances(symbol, network, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get amounts of merchant\'s crypto converted to fiat (including total balance).
     * @param {'USD'} symbolTo Symbol to convert
     * @param {'fiat'} [networkTo] Network to convert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public getConvertedBalances(symbolTo: 'USD', networkTo?: 'fiat', options?: any) {
        return MerchantApiFp(this.configuration).getConvertedBalances(symbolTo, networkTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns merchant data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public getMerchantInfo(options?: any) {
        return MerchantApiFp(this.configuration).getMerchantInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For this request the section \"details\" and KYB level 0 must be provided within a merchant profile. Otherwise a 422 error will be returned.
     * @summary Get the merchant\'s KYB url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public getMerchantKybUrl(options?: any) {
        return MerchantApiFp(this.configuration).getMerchantKybUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The method returns an information about the user\'s operations balances and limits. Only works with crypto currencies.
     * @summary Get the merchant\'s limits
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public getMerchantLimitsApproximately(options?: any) {
        return MerchantApiFp(this.configuration).getMerchantLimitsApproximately(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Merchant\'s operations stats for the specified period. All amounts converted to USD
     * @param {'day' | 'week' | 'month' | 'year'} [period] Stat period. Default day
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public getStats(period?: 'day' | 'week' | 'month' | 'year', options?: any) {
        return MerchantApiFp(this.configuration).getStats(period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Merchant\'s transactions
     * @param {string} [projectId] Filter by project ID
     * @param {'pending' | 'posted'} [status] Filter by status of ledger transaction
     * @param {'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout'} [resource] Filter by resource type
     * @param {string} [externalId] Filter by operation External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {string} [symbol] Filter by currency symbol
     * @param {NetworkCrypto} [network] Filter by Network
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {'created_at' | 'effective_at'} [orderBy] Field to order by
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public getTransactions(projectId?: string, status?: 'pending' | 'posted', resource?: 'charge' | 'checkout' | 'invoice' | 'deposit' | 'payout' | 'withdrawal' | 'refund' | 'exchange' | 'topup' | 'card_payout' | 'bank_payout', externalId?: string, createdAtFrom?: string, createdAtTo?: string, symbol?: string, network?: NetworkCrypto, order?: 'asc' | 'desc', orderBy?: 'created_at' | 'effective_at', offset?: number, limit?: number, options?: any) {
        return MerchantApiFp(this.configuration).getTransactions(projectId, status, resource, externalId, createdAtFrom, createdAtTo, symbol, network, order, orderBy, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary (Re)Send verification operation code
     * @param {VerificationOperationCodeSendRequest} verificationOperationCodeSendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantVerificationOperationCodeSend(verificationOperationCodeSendRequest: VerificationOperationCodeSendRequest, options?: any) {
        return MerchantApiFp(this.configuration).merchantVerificationOperationCodeSend(verificationOperationCodeSendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set resolve_overpaid and resolve_underpaid charge options
     * @param {InlineObject19} inlineObject19 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public resolveCharges(inlineObject19: InlineObject19, options?: any) {
        return MerchantApiFp(this.configuration).resolveCharges(inlineObject19, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set of exchange
     * @param {InlineObject18} inlineObject18 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public setExchangeTo(inlineObject18: InlineObject18, options?: any) {
        return MerchantApiFp(this.configuration).setExchangeTo(inlineObject18, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OnRampApi - axios parameter creator
 * @export
 */
export const OnRampApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new on-ramp payment
         * @summary Create an on-ramp payment
         * @param {OnRampCreatePaymentRequest} onRampCreatePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnRampPayment: async (onRampCreatePaymentRequest: OnRampCreatePaymentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'onRampCreatePaymentRequest' is not null or undefined
            assertParamExists('createOnRampPayment', 'onRampCreatePaymentRequest', onRampCreatePaymentRequest)
            const localVarPath = `/v2.0/on-ramp/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onRampCreatePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single on-ramp payment by ID
         * @summary Get an on-ramp payment
         * @param {string} id Payment UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnRampPayment: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOnRampPayment', 'id', id)
            const localVarPath = `/v2.0/on-ramp/payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of on-ramp payments for the authenticated merchant
         * @summary List on-ramp payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {'pending' | 'processing' | 'completed' | 'failed'} [status] Filter by payment status
         * @param {string} [createdAtFrom] Filter by creation date (inclusive)
         * @param {string} [createdAtTo] Filter by creation date (exclusive)
         * @param {string} [projectId] Filter by project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOnRampPayments: async (order?: 'asc' | 'desc', offset?: number, limit?: number, status?: 'pending' | 'processing' | 'completed' | 'failed', createdAtFrom?: string, createdAtTo?: string, projectId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/on-ramp/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnRampApi - functional programming interface
 * @export
 */
export const OnRampApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnRampApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new on-ramp payment
         * @summary Create an on-ramp payment
         * @param {OnRampCreatePaymentRequest} onRampCreatePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOnRampPayment(onRampCreatePaymentRequest: OnRampCreatePaymentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20067>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOnRampPayment(onRampCreatePaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a single on-ramp payment by ID
         * @summary Get an on-ramp payment
         * @param {string} id Payment UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnRampPayment(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20067>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnRampPayment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a paginated list of on-ramp payments for the authenticated merchant
         * @summary List on-ramp payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {'pending' | 'processing' | 'completed' | 'failed'} [status] Filter by payment status
         * @param {string} [createdAtFrom] Filter by creation date (inclusive)
         * @param {string} [createdAtTo] Filter by creation date (exclusive)
         * @param {string} [projectId] Filter by project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOnRampPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, status?: 'pending' | 'processing' | 'completed' | 'failed', createdAtFrom?: string, createdAtTo?: string, projectId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20066>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOnRampPayments(order, offset, limit, status, createdAtFrom, createdAtTo, projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OnRampApi - factory interface
 * @export
 */
export const OnRampApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnRampApiFp(configuration)
    return {
        /**
         * Create a new on-ramp payment
         * @summary Create an on-ramp payment
         * @param {OnRampCreatePaymentRequest} onRampCreatePaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnRampPayment(onRampCreatePaymentRequest: OnRampCreatePaymentRequest, options?: any): AxiosPromise<InlineResponse20067> {
            return localVarFp.createOnRampPayment(onRampCreatePaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single on-ramp payment by ID
         * @summary Get an on-ramp payment
         * @param {string} id Payment UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnRampPayment(id: string, options?: any): AxiosPromise<InlineResponse20067> {
            return localVarFp.getOnRampPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of on-ramp payments for the authenticated merchant
         * @summary List on-ramp payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {'pending' | 'processing' | 'completed' | 'failed'} [status] Filter by payment status
         * @param {string} [createdAtFrom] Filter by creation date (inclusive)
         * @param {string} [createdAtTo] Filter by creation date (exclusive)
         * @param {string} [projectId] Filter by project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOnRampPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, status?: 'pending' | 'processing' | 'completed' | 'failed', createdAtFrom?: string, createdAtTo?: string, projectId?: string, options?: any): AxiosPromise<InlineResponse20066> {
            return localVarFp.listOnRampPayments(order, offset, limit, status, createdAtFrom, createdAtTo, projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnRampApi - object-oriented interface
 * @export
 * @class OnRampApi
 * @extends {BaseAPI}
 */
export class OnRampApi extends BaseAPI {
    /**
     * Create a new on-ramp payment
     * @summary Create an on-ramp payment
     * @param {OnRampCreatePaymentRequest} onRampCreatePaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnRampApi
     */
    public createOnRampPayment(onRampCreatePaymentRequest: OnRampCreatePaymentRequest, options?: any) {
        return OnRampApiFp(this.configuration).createOnRampPayment(onRampCreatePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single on-ramp payment by ID
     * @summary Get an on-ramp payment
     * @param {string} id Payment UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnRampApi
     */
    public getOnRampPayment(id: string, options?: any) {
        return OnRampApiFp(this.configuration).getOnRampPayment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of on-ramp payments for the authenticated merchant
     * @summary List on-ramp payments
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {'pending' | 'processing' | 'completed' | 'failed'} [status] Filter by payment status
     * @param {string} [createdAtFrom] Filter by creation date (inclusive)
     * @param {string} [createdAtTo] Filter by creation date (exclusive)
     * @param {string} [projectId] Filter by project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnRampApi
     */
    public listOnRampPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, status?: 'pending' | 'processing' | 'completed' | 'failed', createdAtFrom?: string, createdAtTo?: string, projectId?: string, options?: any) {
        return OnRampApiFp(this.configuration).listOnRampPayments(order, offset, limit, status, createdAtFrom, createdAtTo, projectId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lists all payments
         * @summary List payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [chargeId] 
         * @param {'fixed_price' | 'no_price'} [pricingType] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments: async (order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, chargeId?: string, pricingType?: 'fixed_price' | 'no_price', address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (chargeId !== undefined) {
                localVarQueryParameter['charge_id'] = chargeId;
            }

            if (pricingType !== undefined) {
                localVarQueryParameter['pricing_type'] = pricingType;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (addressTo !== undefined) {
                localVarQueryParameter['address_to'] = addressTo;
            }

            if (txId !== undefined) {
                localVarQueryParameter['tx_id'] = txId;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (amlLevel !== undefined) {
                localVarQueryParameter['aml_level'] = amlLevel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Lists all payments
         * @summary List payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [chargeId] 
         * @param {'fixed_price' | 'no_price'} [pricingType] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, chargeId?: string, pricingType?: 'fixed_price' | 'no_price', address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayments(order, offset, limit, id, chargeId, pricingType, address, addressTo, txId, network, symbol, status, amlLevel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * Lists all payments
         * @summary List payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [chargeId] 
         * @param {'fixed_price' | 'no_price'} [pricingType] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, chargeId?: string, pricingType?: 'fixed_price' | 'no_price', address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any): AxiosPromise<InlineResponse2002> {
            return localVarFp.getPayments(order, offset, limit, id, chargeId, pricingType, address, addressTo, txId, network, symbol, status, amlLevel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * Lists all payments
     * @summary List payments
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [id] 
     * @param {string} [chargeId] 
     * @param {'fixed_price' | 'no_price'} [pricingType] 
     * @param {string} [address] 
     * @param {string} [addressTo] 
     * @param {string} [txId] 
     * @param {NetworkCrypto} [network] 
     * @param {SymbolCrypto} [symbol] 
     * @param {'pending' | 'confirmed' | 'failed'} [status] 
     * @param {'low' | 'medium' | 'high'} [amlLevel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, chargeId?: string, pricingType?: 'fixed_price' | 'no_price', address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any) {
        return PaymentsApiFp(this.configuration).getPayments(order, offset, limit, id, chargeId, pricingType, address, addressTo, txId, network, symbol, status, amlLevel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PayoutsApi - axios parameter creator
 * @export
 */
export const PayoutsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a crypto payout to the address provided in the request. Provide either amount in the payout cryptocurrency or from_fiat to convert a fiat amount before sending.
         * @summary Create a crypto payout
         * @param {PayoutCreate} payoutCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCryptoPayout: async (payoutCreate: PayoutCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'payoutCreate' is not null or undefined
            assertParamExists('createCryptoPayout', 'payoutCreate', payoutCreate)
            const localVarPath = `/v2.0/payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payoutCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a single crypto payout
         * @summary Show a crypto payout
         * @param {string} id ID of payout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoPayout: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCryptoPayout', 'id', id)
            const localVarPath = `/v2.0/payouts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List crypto payouts
         * @summary List crypto payouts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCryptoPayouts: async (order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, massPayoutId?: string, type?: 'payout' | 'withdrawal', extTxId?: string, status?: 'new' | 'pending' | 'failed' | 'completed' | 'cancelled', amlLevel?: 'low' | 'medium' | 'high', network?: NetworkCrypto, symbol?: SymbolCrypto, address?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/payouts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }


    
            if (massPayoutId !== undefined) {
                localVarQueryParameter['mass_payout_id'] = massPayoutId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (extTxId !== undefined) {
                localVarQueryParameter['ext_tx_id'] = extTxId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (amlLevel !== undefined) {
                localVarQueryParameter['aml_level'] = amlLevel;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayoutsApi - functional programming interface
 * @export
 */
export const PayoutsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayoutsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a crypto payout to the address provided in the request. Provide either amount in the payout cryptocurrency or from_fiat to convert a fiat amount before sending.
         * @summary Create a crypto payout
         * @param {PayoutCreate} payoutCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCryptoPayout(payoutCreate: PayoutCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20040>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCryptoPayout(payoutCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a single crypto payout
         * @summary Show a crypto payout
         * @param {string} id ID of payout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCryptoPayout(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20040>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCryptoPayout(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List crypto payouts
         * @summary List crypto payouts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCryptoPayouts(order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, massPayoutId?: string, type?: 'payout' | 'withdrawal', extTxId?: string, status?: 'new' | 'pending' | 'failed' | 'completed' | 'cancelled', amlLevel?: 'low' | 'medium' | 'high', network?: NetworkCrypto, symbol?: SymbolCrypto, address?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20039>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCryptoPayouts(order, offset, limit, externalId, createdAtFrom, createdAtTo, massPayoutId, type, extTxId, status, amlLevel, network, symbol, address, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PayoutsApi - factory interface
 * @export
 */
export const PayoutsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayoutsApiFp(configuration)
    return {
        /**
         * Create a crypto payout to the address provided in the request. Provide either amount in the payout cryptocurrency or from_fiat to convert a fiat amount before sending.
         * @summary Create a crypto payout
         * @param {PayoutCreate} payoutCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCryptoPayout(payoutCreate: PayoutCreate, options?: any): AxiosPromise<InlineResponse20040> {
            return localVarFp.createCryptoPayout(payoutCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a single crypto payout
         * @summary Show a crypto payout
         * @param {string} id ID of payout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoPayout(id: string, options?: any): AxiosPromise<InlineResponse20040> {
            return localVarFp.getCryptoPayout(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List crypto payouts
         * @summary List crypto payouts
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCryptoPayouts(order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, massPayoutId?: string, type?: 'payout' | 'withdrawal', extTxId?: string, status?: 'new' | 'pending' | 'failed' | 'completed' | 'cancelled', amlLevel?: 'low' | 'medium' | 'high', network?: NetworkCrypto, symbol?: SymbolCrypto, address?: string, options?: any): AxiosPromise<InlineResponse20039> {
            return localVarFp.listCryptoPayouts(order, offset, limit, externalId, createdAtFrom, createdAtTo, massPayoutId, type, extTxId, status, amlLevel, network, symbol, address, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayoutsApi - object-oriented interface
 * @export
 * @class PayoutsApi
 * @extends {BaseAPI}
 */
export class PayoutsApi extends BaseAPI {
    /**
     * Create a crypto payout to the address provided in the request. Provide either amount in the payout cryptocurrency or from_fiat to convert a fiat amount before sending.
     * @summary Create a crypto payout
     * @param {PayoutCreate} payoutCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    public createCryptoPayout(payoutCreate: PayoutCreate, options?: any) {
        return PayoutsApiFp(this.configuration).createCryptoPayout(payoutCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a single crypto payout
     * @summary Show a crypto payout
     * @param {string} id ID of payout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    public getCryptoPayout(id: string, options?: any) {
        return PayoutsApiFp(this.configuration).getCryptoPayout(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List crypto payouts
     * @summary List crypto payouts
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsApi
     */
    public listCryptoPayouts(order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, massPayoutId?: string, type?: 'payout' | 'withdrawal', extTxId?: string, status?: 'new' | 'pending' | 'failed' | 'completed' | 'cancelled', amlLevel?: 'low' | 'medium' | 'high', network?: NetworkCrypto, symbol?: SymbolCrypto, address?: string, options?: any) {
        return PayoutsApiFp(this.configuration).listCryptoPayouts(order, offset, limit, externalId, createdAtFrom, createdAtTo, massPayoutId, type, extTxId, status, amlLevel, network, symbol, address, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cache image for project
         * @summary Cache image for project
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheProjectImage: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/projects/cache/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cache logo for project
         * @summary Cache logo for project
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheProjectLogo: async (file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/projects/cache/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new project object.
         * @summary Create a project
         * @param {ProjectRequest} projectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (projectRequest: ProjectRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectRequest' is not null or undefined
            assertParamExists('createProject', 'projectRequest', projectRequest)
            const localVarPath = `/v2.0/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a single project
         * @summary Show a project
         * @param {string} id ID of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProject', 'id', id)
            const localVarPath = `/v2.0/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all projects
         * @summary List projects
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: async (order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a project
         * @summary Update a project
         * @param {string} id ID of project
         * @param {ProjectRequest} projectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: async (id: string, projectRequest: ProjectRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProject', 'id', id)
            // verify required parameter 'projectRequest' is not null or undefined
            assertParamExists('updateProject', 'projectRequest', projectRequest)
            const localVarPath = `/v2.0/projects/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cache image for project
         * @summary Cache image for project
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheProjectImage(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheProjectImage(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Cache logo for project
         * @summary Cache logo for project
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheProjectLogo(file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheProjectLogo(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new project object.
         * @summary Create a project
         * @param {ProjectRequest} projectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(projectRequest: ProjectRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20036>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(projectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a single project
         * @summary Show a project
         * @param {string} id ID of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProject(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20036>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all projects
         * @summary List projects
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjects(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20035>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjects(order, offset, limit, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a project
         * @summary Update a project
         * @param {string} id ID of project
         * @param {ProjectRequest} projectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProject(id: string, projectRequest: ProjectRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20036>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(id, projectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * Cache image for project
         * @summary Cache image for project
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheProjectImage(file?: any, options?: any): AxiosPromise<InlineResponse2008> {
            return localVarFp.cacheProjectImage(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Cache logo for project
         * @summary Cache logo for project
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheProjectLogo(file?: any, options?: any): AxiosPromise<InlineResponse2008> {
            return localVarFp.cacheProjectLogo(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new project object.
         * @summary Create a project
         * @param {ProjectRequest} projectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(projectRequest: ProjectRequest, options?: any): AxiosPromise<InlineResponse20036> {
            return localVarFp.createProject(projectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a single project
         * @summary Show a project
         * @param {string} id ID of project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(id: string, options?: any): AxiosPromise<InlineResponse20036> {
            return localVarFp.getProject(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all projects
         * @summary List projects
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, options?: any): AxiosPromise<InlineResponse20035> {
            return localVarFp.getProjects(order, offset, limit, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a project
         * @summary Update a project
         * @param {string} id ID of project
         * @param {ProjectRequest} projectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject(id: string, projectRequest: ProjectRequest, options?: any): AxiosPromise<InlineResponse20036> {
            return localVarFp.updateProject(id, projectRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * Cache image for project
     * @summary Cache image for project
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public cacheProjectImage(file?: any, options?: any) {
        return ProjectsApiFp(this.configuration).cacheProjectImage(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cache logo for project
     * @summary Cache logo for project
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public cacheProjectLogo(file?: any, options?: any) {
        return ProjectsApiFp(this.configuration).cacheProjectLogo(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new project object.
     * @summary Create a project
     * @param {ProjectRequest} projectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public createProject(projectRequest: ProjectRequest, options?: any) {
        return ProjectsApiFp(this.configuration).createProject(projectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a single project
     * @summary Show a project
     * @param {string} id ID of project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProject(id: string, options?: any) {
        return ProjectsApiFp(this.configuration).getProject(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all projects
     * @summary List projects
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjects(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, options?: any) {
        return ProjectsApiFp(this.configuration).getProjects(order, offset, limit, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a project
     * @summary Update a project
     * @param {string} id ID of project
     * @param {ProjectRequest} projectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public updateProject(id: string, projectRequest: ProjectRequest, options?: any) {
        return ProjectsApiFp(this.configuration).updateProject(id, projectRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReferrerApi - axios parameter creator
 * @export
 */
export const ReferrerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferrerReferralLink: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/referrer/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete referral link
         * @param {string} id referral link id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReferrerReferralLink: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReferrerReferralLink', 'id', id)
            const localVarPath = `/v2.0/referrer/links/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns referrer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrer: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/referrer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns generated links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerReferralLinks: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/referrer/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns referral merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerReferrals: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/referrer/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferrerApi - functional programming interface
 * @export
 */
export const ReferrerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferrerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReferrerReferralLink(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20053>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReferrerReferralLink(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete referral link
         * @param {string} id referral link id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReferrerReferralLink(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReferrerReferralLink(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns referrer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferrer(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20050>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferrer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns generated links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferrerReferralLinks(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20052>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferrerReferralLinks(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns referral merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferrerReferrals(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20051>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferrerReferrals(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReferrerApi - factory interface
 * @export
 */
export const ReferrerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferrerApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate referral link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReferrerReferralLink(options?: any): AxiosPromise<InlineResponse20053> {
            return localVarFp.createReferrerReferralLink(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete referral link
         * @param {string} id referral link id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReferrerReferralLink(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteReferrerReferralLink(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns referrer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrer(options?: any): AxiosPromise<InlineResponse20050> {
            return localVarFp.getReferrer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns generated links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerReferralLinks(options?: any): AxiosPromise<InlineResponse20052> {
            return localVarFp.getReferrerReferralLinks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns referral merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrerReferrals(options?: any): AxiosPromise<InlineResponse20051> {
            return localVarFp.getReferrerReferrals(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferrerApi - object-oriented interface
 * @export
 * @class ReferrerApi
 * @extends {BaseAPI}
 */
export class ReferrerApi extends BaseAPI {
    /**
     * 
     * @summary Generate referral link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrerApi
     */
    public createReferrerReferralLink(options?: any) {
        return ReferrerApiFp(this.configuration).createReferrerReferralLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete referral link
     * @param {string} id referral link id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrerApi
     */
    public deleteReferrerReferralLink(id: string, options?: any) {
        return ReferrerApiFp(this.configuration).deleteReferrerReferralLink(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns referrer data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrerApi
     */
    public getReferrer(options?: any) {
        return ReferrerApiFp(this.configuration).getReferrer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns generated links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrerApi
     */
    public getReferrerReferralLinks(options?: any) {
        return ReferrerApiFp(this.configuration).getReferrerReferralLinks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns referral merchant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferrerApi
     */
    public getReferrerReferrals(options?: any) {
        return ReferrerApiFp(this.configuration).getReferrerReferrals(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RefundsApi - axios parameter creator
 * @export
 */
export const RefundsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a refund
         * @summary Create a refund
         * @param {RefundCreate} refundCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund: async (refundCreate: RefundCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'refundCreate' is not null or undefined
            assertParamExists('createRefund', 'refundCreate', refundCreate)
            const localVarPath = `/v2.0/refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single refund by ID
         * @summary Get a refund
         * @param {string} id ID of refund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefund: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRefund', 'id', id)
            const localVarPath = `/v2.0/refunds/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all refunds
         * @summary List refunds
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [paymentId] Filter by payment ID
         * @param {string} [network] Filter by network
         * @param {string} [symbol] Filter by symbol
         * @param {'pending' | 'completed' | 'failed'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRefunds: async (order?: 'asc' | 'desc', offset?: number, limit?: number, paymentId?: string, network?: string, symbol?: string, status?: 'pending' | 'completed' | 'failed', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['payment_id'] = paymentId;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefundsApi - functional programming interface
 * @export
 */
export const RefundsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefundsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a refund
         * @summary Create a refund
         * @param {RefundCreate} refundCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefund(refundCreate: RefundCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20049>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRefund(refundCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a single refund by ID
         * @summary Get a refund
         * @param {string} id ID of refund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefund(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20049>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRefund(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all refunds
         * @summary List refunds
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [paymentId] Filter by payment ID
         * @param {string} [network] Filter by network
         * @param {string} [symbol] Filter by symbol
         * @param {'pending' | 'completed' | 'failed'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRefunds(order?: 'asc' | 'desc', offset?: number, limit?: number, paymentId?: string, network?: string, symbol?: string, status?: 'pending' | 'completed' | 'failed', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20048>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRefunds(order, offset, limit, paymentId, network, symbol, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RefundsApi - factory interface
 * @export
 */
export const RefundsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefundsApiFp(configuration)
    return {
        /**
         * Create a refund
         * @summary Create a refund
         * @param {RefundCreate} refundCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund(refundCreate: RefundCreate, options?: any): AxiosPromise<InlineResponse20049> {
            return localVarFp.createRefund(refundCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single refund by ID
         * @summary Get a refund
         * @param {string} id ID of refund
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefund(id: string, options?: any): AxiosPromise<InlineResponse20049> {
            return localVarFp.getRefund(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all refunds
         * @summary List refunds
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [paymentId] Filter by payment ID
         * @param {string} [network] Filter by network
         * @param {string} [symbol] Filter by symbol
         * @param {'pending' | 'completed' | 'failed'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRefunds(order?: 'asc' | 'desc', offset?: number, limit?: number, paymentId?: string, network?: string, symbol?: string, status?: 'pending' | 'completed' | 'failed', options?: any): AxiosPromise<InlineResponse20048> {
            return localVarFp.listRefunds(order, offset, limit, paymentId, network, symbol, status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RefundsApi - object-oriented interface
 * @export
 * @class RefundsApi
 * @extends {BaseAPI}
 */
export class RefundsApi extends BaseAPI {
    /**
     * Create a refund
     * @summary Create a refund
     * @param {RefundCreate} refundCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public createRefund(refundCreate: RefundCreate, options?: any) {
        return RefundsApiFp(this.configuration).createRefund(refundCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single refund by ID
     * @summary Get a refund
     * @param {string} id ID of refund
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public getRefund(id: string, options?: any) {
        return RefundsApiFp(this.configuration).getRefund(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all refunds
     * @summary List refunds
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [paymentId] Filter by payment ID
     * @param {string} [network] Filter by network
     * @param {string} [symbol] Filter by symbol
     * @param {'pending' | 'completed' | 'failed'} [status] Filter by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefundsApi
     */
    public listRefunds(order?: 'asc' | 'desc', offset?: number, limit?: number, paymentId?: string, network?: string, symbol?: string, status?: 'pending' | 'completed' | 'failed', options?: any) {
        return RefundsApiFp(this.configuration).listRefunds(order, offset, limit, paymentId, network, symbol, status, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SecurityApi - axios parameter creator
 * @export
 */
export const SecurityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change password
         * @param {InlineObject9} inlineObject9 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (inlineObject9: InlineObject9, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject9' is not null or undefined
            assertParamExists('changePassword', 'inlineObject9', inlineObject9)
            const localVarPath = `/v2.0/merchant/change_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject9, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate new OTP secret/uri. You can generate QR code from uri <a target=\"_blank\" href=\"./pages/qr.html\">here</a> to scan in Google Authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpGenerate: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set OTP for merchant
         * @param {InlineObject7} inlineObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpSet: async (inlineObject7: InlineObject7, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject7' is not null or undefined
            assertParamExists('otpSet', 'inlineObject7', inlineObject7)
            const localVarPath = `/v2.0/merchant/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject7, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove OTP for merchant
         * @param {InlineObject8} inlineObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpUnset: async (inlineObject8: InlineObject8, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject8' is not null or undefined
            assertParamExists('otpUnset', 'inlineObject8', inlineObject8)
            const localVarPath = `/v2.0/merchant/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecurityApi - functional programming interface
 * @export
 */
export const SecurityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecurityApiAxiosParamCreator(configuration)
    return {
        /**
         * Change password
         * @param {InlineObject9} inlineObject9 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(inlineObject9: InlineObject9, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(inlineObject9, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generate new OTP secret/uri. You can generate QR code from uri <a target=\"_blank\" href=\"./pages/qr.html\">here</a> to scan in Google Authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpGenerate(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpGenerate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set OTP for merchant
         * @param {InlineObject7} inlineObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpSet(inlineObject7: InlineObject7, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpSet(inlineObject7, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove OTP for merchant
         * @param {InlineObject8} inlineObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async otpUnset(inlineObject8: InlineObject8, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.otpUnset(inlineObject8, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecurityApi - factory interface
 * @export
 */
export const SecurityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecurityApiFp(configuration)
    return {
        /**
         * Change password
         * @param {InlineObject9} inlineObject9 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(inlineObject9: InlineObject9, options?: any): AxiosPromise<Response & object> {
            return localVarFp.changePassword(inlineObject9, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate new OTP secret/uri. You can generate QR code from uri <a target=\"_blank\" href=\"./pages/qr.html\">here</a> to scan in Google Authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpGenerate(options?: any): AxiosPromise<Response & object> {
            return localVarFp.otpGenerate(options).then((request) => request(axios, basePath));
        },
        /**
         * Set OTP for merchant
         * @param {InlineObject7} inlineObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpSet(inlineObject7: InlineObject7, options?: any): AxiosPromise<Response & object> {
            return localVarFp.otpSet(inlineObject7, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove OTP for merchant
         * @param {InlineObject8} inlineObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otpUnset(inlineObject8: InlineObject8, options?: any): AxiosPromise<Response & object> {
            return localVarFp.otpUnset(inlineObject8, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecurityApi - object-oriented interface
 * @export
 * @class SecurityApi
 * @extends {BaseAPI}
 */
export class SecurityApi extends BaseAPI {
    /**
     * Change password
     * @param {InlineObject9} inlineObject9 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public changePassword(inlineObject9: InlineObject9, options?: any) {
        return SecurityApiFp(this.configuration).changePassword(inlineObject9, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate new OTP secret/uri. You can generate QR code from uri <a target=\"_blank\" href=\"./pages/qr.html\">here</a> to scan in Google Authentication.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public otpGenerate(options?: any) {
        return SecurityApiFp(this.configuration).otpGenerate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set OTP for merchant
     * @param {InlineObject7} inlineObject7 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public otpSet(inlineObject7: InlineObject7, options?: any) {
        return SecurityApiFp(this.configuration).otpSet(inlineObject7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove OTP for merchant
     * @param {InlineObject8} inlineObject8 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public otpUnset(inlineObject8: InlineObject8, options?: any) {
        return SecurityApiFp(this.configuration).otpUnset(inlineObject8, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionApi - axios parameter creator
 * @export
 */
export const SessionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete session
         * @param {string} id session id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSession: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSession', 'id', id)
            const localVarPath = `/v2.0/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionApi - functional programming interface
 * @export
 */
export const SessionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete session
         * @param {string} id session id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSession(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSession(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20032>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionApi - factory interface
 * @export
 */
export const SessionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete session
         * @param {string} id session id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSession(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteSession(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns sessions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessions(options?: any): AxiosPromise<InlineResponse20032> {
            return localVarFp.getSessions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
export class SessionApi extends BaseAPI {
    /**
     * 
     * @summary Delete session
     * @param {string} id session id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public deleteSession(id: string, options?: any) {
        return SessionApiFp(this.configuration).deleteSession(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    public getSessions(options?: any) {
        return SessionApiFp(this.configuration).getSessions(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Save callback url for payouts and withdrawals
         * @summary Save callback url for payouts and withdrawals
         * @param {InlineObject30} inlineObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallbackUrl: async (inlineObject30: InlineObject30, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject30' is not null or undefined
            assertParamExists('createCallbackUrl', 'inlineObject30', inlineObject30)
            const localVarPath = `/v2.0/settings/payout_callback_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject30, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Save callback url for payouts and withdrawals
         * @summary Save callback url for payouts and withdrawals
         * @param {InlineObject30} inlineObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCallbackUrl(inlineObject30: InlineObject30, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2009>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCallbackUrl(inlineObject30, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * Save callback url for payouts and withdrawals
         * @summary Save callback url for payouts and withdrawals
         * @param {InlineObject30} inlineObject30 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCallbackUrl(inlineObject30: InlineObject30, options?: any): AxiosPromise<InlineResponse2009> {
            return localVarFp.createCallbackUrl(inlineObject30, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * Save callback url for payouts and withdrawals
     * @summary Save callback url for payouts and withdrawals
     * @param {InlineObject30} inlineObject30 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createCallbackUrl(inlineObject30: InlineObject30, options?: any) {
        return SettingsApiFp(this.configuration).createCallbackUrl(inlineObject30, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SubmerchantsApi - axios parameter creator
 * @export
 */
export const SubmerchantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change a submerchant password
         * @param {string} id Submerchant ID
         * @param {InlineObject14} inlineObject14 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubmerchantPassword: async (id: string, inlineObject14: InlineObject14, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeSubmerchantPassword', 'id', id)
            // verify required parameter 'inlineObject14' is not null or undefined
            assertParamExists('changeSubmerchantPassword', 'inlineObject14', inlineObject14)
            const localVarPath = `/v2.0/merchant/submerchants/{id}/change-password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject14, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a submerchant
         * @param {string} id Submerchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmerchant: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSubmerchant', 'id', id)
            const localVarPath = `/v2.0/merchant/submerchants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The method returns a list of submerchants
         * @summary Get the merchant\'s submerchant list
         * @param {'pending' | 'confirmed' | 'unconfirmed' | 'blocked'} [status] Filter by status of a submerchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmerchants: async (status?: 'pending' | 'confirmed' | 'unconfirmed' | 'blocked', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/submerchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of possible access rights for submerchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmerchantsAccessGroups: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/submerchants/access-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register new submerchant
         * @param {SubmerchantRegisterRequest} submerchantRegisterRequest Submerchant form data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submerchantRegister: async (submerchantRegisterRequest: SubmerchantRegisterRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'submerchantRegisterRequest' is not null or undefined
            assertParamExists('submerchantRegister', 'submerchantRegisterRequest', submerchantRegisterRequest)
            const localVarPath = `/v2.0/merchant/submerchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submerchantRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a submerchant. Set new status or access rights
         * @summary Update a submerchant
         * @param {string} id Submerchant ID
         * @param {InlineObject15} inlineObject15 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubmerchant: async (id: string, inlineObject15: InlineObject15, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSubmerchant', 'id', id)
            // verify required parameter 'inlineObject15' is not null or undefined
            assertParamExists('updateSubmerchant', 'inlineObject15', inlineObject15)
            const localVarPath = `/v2.0/merchant/submerchants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject15, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubmerchantsApi - functional programming interface
 * @export
 */
export const SubmerchantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubmerchantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Change a submerchant password
         * @param {string} id Submerchant ID
         * @param {InlineObject14} inlineObject14 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSubmerchantPassword(id: string, inlineObject14: InlineObject14, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20027>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSubmerchantPassword(id, inlineObject14, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a submerchant
         * @param {string} id Submerchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmerchant(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20025>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmerchant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The method returns a list of submerchants
         * @summary Get the merchant\'s submerchant list
         * @param {'pending' | 'confirmed' | 'unconfirmed' | 'blocked'} [status] Filter by status of a submerchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmerchants(status?: 'pending' | 'confirmed' | 'unconfirmed' | 'blocked', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20024>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmerchants(status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List of possible access rights for submerchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubmerchantsAccessGroups(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20026>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubmerchantsAccessGroups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register new submerchant
         * @param {SubmerchantRegisterRequest} submerchantRegisterRequest Submerchant form data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submerchantRegister(submerchantRegisterRequest: SubmerchantRegisterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20025>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submerchantRegister(submerchantRegisterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a submerchant. Set new status or access rights
         * @summary Update a submerchant
         * @param {string} id Submerchant ID
         * @param {InlineObject15} inlineObject15 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubmerchant(id: string, inlineObject15: InlineObject15, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20025>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubmerchant(id, inlineObject15, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubmerchantsApi - factory interface
 * @export
 */
export const SubmerchantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubmerchantsApiFp(configuration)
    return {
        /**
         * Change a submerchant password
         * @param {string} id Submerchant ID
         * @param {InlineObject14} inlineObject14 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubmerchantPassword(id: string, inlineObject14: InlineObject14, options?: any): AxiosPromise<InlineResponse20027> {
            return localVarFp.changeSubmerchantPassword(id, inlineObject14, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a submerchant
         * @param {string} id Submerchant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmerchant(id: string, options?: any): AxiosPromise<InlineResponse20025> {
            return localVarFp.getSubmerchant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The method returns a list of submerchants
         * @summary Get the merchant\'s submerchant list
         * @param {'pending' | 'confirmed' | 'unconfirmed' | 'blocked'} [status] Filter by status of a submerchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmerchants(status?: 'pending' | 'confirmed' | 'unconfirmed' | 'blocked', options?: any): AxiosPromise<InlineResponse20024> {
            return localVarFp.getSubmerchants(status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of possible access rights for submerchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubmerchantsAccessGroups(options?: any): AxiosPromise<InlineResponse20026> {
            return localVarFp.getSubmerchantsAccessGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register new submerchant
         * @param {SubmerchantRegisterRequest} submerchantRegisterRequest Submerchant form data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submerchantRegister(submerchantRegisterRequest: SubmerchantRegisterRequest, options?: any): AxiosPromise<InlineResponse20025> {
            return localVarFp.submerchantRegister(submerchantRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a submerchant. Set new status or access rights
         * @summary Update a submerchant
         * @param {string} id Submerchant ID
         * @param {InlineObject15} inlineObject15 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubmerchant(id: string, inlineObject15: InlineObject15, options?: any): AxiosPromise<InlineResponse20025> {
            return localVarFp.updateSubmerchant(id, inlineObject15, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubmerchantsApi - object-oriented interface
 * @export
 * @class SubmerchantsApi
 * @extends {BaseAPI}
 */
export class SubmerchantsApi extends BaseAPI {
    /**
     * Change a submerchant password
     * @param {string} id Submerchant ID
     * @param {InlineObject14} inlineObject14 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmerchantsApi
     */
    public changeSubmerchantPassword(id: string, inlineObject14: InlineObject14, options?: any) {
        return SubmerchantsApiFp(this.configuration).changeSubmerchantPassword(id, inlineObject14, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a submerchant
     * @param {string} id Submerchant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmerchantsApi
     */
    public getSubmerchant(id: string, options?: any) {
        return SubmerchantsApiFp(this.configuration).getSubmerchant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The method returns a list of submerchants
     * @summary Get the merchant\'s submerchant list
     * @param {'pending' | 'confirmed' | 'unconfirmed' | 'blocked'} [status] Filter by status of a submerchant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmerchantsApi
     */
    public getSubmerchants(status?: 'pending' | 'confirmed' | 'unconfirmed' | 'blocked', options?: any) {
        return SubmerchantsApiFp(this.configuration).getSubmerchants(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of possible access rights for submerchants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmerchantsApi
     */
    public getSubmerchantsAccessGroups(options?: any) {
        return SubmerchantsApiFp(this.configuration).getSubmerchantsAccessGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register new submerchant
     * @param {SubmerchantRegisterRequest} submerchantRegisterRequest Submerchant form data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmerchantsApi
     */
    public submerchantRegister(submerchantRegisterRequest: SubmerchantRegisterRequest, options?: any) {
        return SubmerchantsApiFp(this.configuration).submerchantRegister(submerchantRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a submerchant. Set new status or access rights
     * @summary Update a submerchant
     * @param {string} id Submerchant ID
     * @param {InlineObject15} inlineObject15 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmerchantsApi
     */
    public updateSubmerchant(id: string, inlineObject15: InlineObject15, options?: any) {
        return SubmerchantsApiFp(this.configuration).updateSubmerchant(id, inlineObject15, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The method allows to create an access token. The field \"scopes\" allows to configure a set of methods a user can access with the token.
         * @summary Create new token
         * @param {InlineObject25} inlineObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTokens: async (inlineObject25: InlineObject25, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject25' is not null or undefined
            assertParamExists('createTokens', 'inlineObject25', inlineObject25)
            const localVarPath = `/v2.0/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject25, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete token
         * @param {string} id token id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTokens: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTokens', 'id', id)
            const localVarPath = `/v2.0/tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all tokens
         * @summary List tokens
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens: async (order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all tokens scopes. Scope described in the so-called “dot” notation with addition of HTTP method at the end of the scope id. For example, ``` - HTTP GET /v2.0/charges transforms into charges.get - HTTP PUT /v2.0/charges/{id}/resolve transforms into charges.id.resolve.put ```
         * @summary List tokens scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokensScopes: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/tokens/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration)
    return {
        /**
         * The method allows to create an access token. The field \"scopes\" allows to configure a set of methods a user can access with the token.
         * @summary Create new token
         * @param {InlineObject25} inlineObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTokens(inlineObject25: InlineObject25, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTokens(inlineObject25, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete token
         * @param {string} id token id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTokens(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTokens(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all tokens
         * @summary List tokens
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokens(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokens(order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all tokens scopes. Scope described in the so-called “dot” notation with addition of HTTP method at the end of the scope id. For example, ``` - HTTP GET /v2.0/charges transforms into charges.get - HTTP PUT /v2.0/charges/{id}/resolve transforms into charges.id.resolve.put ```
         * @summary List tokens scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokensScopes(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokensScopes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokensApiFp(configuration)
    return {
        /**
         * The method allows to create an access token. The field \"scopes\" allows to configure a set of methods a user can access with the token.
         * @summary Create new token
         * @param {InlineObject25} inlineObject25 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTokens(inlineObject25: InlineObject25, options?: any): AxiosPromise<Response & object> {
            return localVarFp.createTokens(inlineObject25, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete token
         * @param {string} id token id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTokens(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteTokens(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all tokens
         * @summary List tokens
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<Response & object> {
            return localVarFp.getTokens(order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all tokens scopes. Scope described in the so-called “dot” notation with addition of HTTP method at the end of the scope id. For example, ``` - HTTP GET /v2.0/charges transforms into charges.get - HTTP PUT /v2.0/charges/{id}/resolve transforms into charges.id.resolve.put ```
         * @summary List tokens scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokensScopes(options?: any): AxiosPromise<Response & object> {
            return localVarFp.getTokensScopes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
    /**
     * The method allows to create an access token. The field \"scopes\" allows to configure a set of methods a user can access with the token.
     * @summary Create new token
     * @param {InlineObject25} inlineObject25 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public createTokens(inlineObject25: InlineObject25, options?: any) {
        return TokensApiFp(this.configuration).createTokens(inlineObject25, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete token
     * @param {string} id token id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public deleteTokens(id: string, options?: any) {
        return TokensApiFp(this.configuration).deleteTokens(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all tokens
     * @summary List tokens
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public getTokens(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return TokensApiFp(this.configuration).getTokens(order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all tokens scopes. Scope described in the so-called “dot” notation with addition of HTTP method at the end of the scope id. For example, ``` - HTTP GET /v2.0/charges transforms into charges.get - HTTP PUT /v2.0/charges/{id}/resolve transforms into charges.id.resolve.put ```
     * @summary List tokens scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public getTokensScopes(options?: any) {
        return TokensApiFp(this.configuration).getTokensScopes(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TopupsApi - axios parameter creator
 * @export
 */
export const TopupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get address to send money to
         * @param {NetworkCrypto} network 
         * @param {SymbolCrypto} symbol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopupAddress: async (network: NetworkCrypto, symbol: SymbolCrypto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'network' is not null or undefined
            assertParamExists('getTopupAddress', 'network', network)
            // verify required parameter 'symbol' is not null or undefined
            assertParamExists('getTopupAddress', 'symbol', symbol)
            const localVarPath = `/v2.0/topups/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all topup bank accounts
         * @summary List topup bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopupBankAccounts: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/topups/bank-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all topup payments
         * @summary List topup payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [topupId] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopupPayments: async (order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, topupId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/topups/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (topupId !== undefined) {
                localVarQueryParameter['topup_id'] = topupId;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (addressTo !== undefined) {
                localVarQueryParameter['address_to'] = addressTo;
            }

            if (txId !== undefined) {
                localVarQueryParameter['tx_id'] = txId;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (amlLevel !== undefined) {
                localVarQueryParameter['aml_level'] = amlLevel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace the existing address with a new one
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTopupAddressReplace: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putTopupAddressReplace', 'id', id)
            const localVarPath = `/v2.0/topups/address/{id}/replace`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TopupsApi - functional programming interface
 * @export
 */
export const TopupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TopupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get address to send money to
         * @param {NetworkCrypto} network 
         * @param {SymbolCrypto} symbol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopupAddress(network: NetworkCrypto, symbol: SymbolCrypto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20028>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopupAddress(network, symbol, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all topup bank accounts
         * @summary List topup bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopupBankAccounts(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20030>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopupBankAccounts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Lists all topup payments
         * @summary List topup payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [topupId] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopupPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, topupId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20029>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopupPayments(order, offset, limit, id, topupId, address, addressTo, txId, network, symbol, status, amlLevel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace the existing address with a new one
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTopupAddressReplace(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20028>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTopupAddressReplace(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TopupsApi - factory interface
 * @export
 */
export const TopupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TopupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get address to send money to
         * @param {NetworkCrypto} network 
         * @param {SymbolCrypto} symbol 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopupAddress(network: NetworkCrypto, symbol: SymbolCrypto, options?: any): AxiosPromise<InlineResponse20028> {
            return localVarFp.getTopupAddress(network, symbol, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all topup bank accounts
         * @summary List topup bank accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopupBankAccounts(options?: any): AxiosPromise<InlineResponse20030> {
            return localVarFp.getTopupBankAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all topup payments
         * @summary List topup payments
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [id] 
         * @param {string} [topupId] 
         * @param {string} [address] 
         * @param {string} [addressTo] 
         * @param {string} [txId] 
         * @param {NetworkCrypto} [network] 
         * @param {SymbolCrypto} [symbol] 
         * @param {'pending' | 'confirmed' | 'failed'} [status] 
         * @param {'low' | 'medium' | 'high'} [amlLevel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopupPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, topupId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any): AxiosPromise<InlineResponse20029> {
            return localVarFp.getTopupPayments(order, offset, limit, id, topupId, address, addressTo, txId, network, symbol, status, amlLevel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace the existing address with a new one
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTopupAddressReplace(id: string, options?: any): AxiosPromise<InlineResponse20028> {
            return localVarFp.putTopupAddressReplace(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TopupsApi - object-oriented interface
 * @export
 * @class TopupsApi
 * @extends {BaseAPI}
 */
export class TopupsApi extends BaseAPI {
    /**
     * 
     * @summary Get address to send money to
     * @param {NetworkCrypto} network 
     * @param {SymbolCrypto} symbol 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopupsApi
     */
    public getTopupAddress(network: NetworkCrypto, symbol: SymbolCrypto, options?: any) {
        return TopupsApiFp(this.configuration).getTopupAddress(network, symbol, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all topup bank accounts
     * @summary List topup bank accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopupsApi
     */
    public getTopupBankAccounts(options?: any) {
        return TopupsApiFp(this.configuration).getTopupBankAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all topup payments
     * @summary List topup payments
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [id] 
     * @param {string} [topupId] 
     * @param {string} [address] 
     * @param {string} [addressTo] 
     * @param {string} [txId] 
     * @param {NetworkCrypto} [network] 
     * @param {SymbolCrypto} [symbol] 
     * @param {'pending' | 'confirmed' | 'failed'} [status] 
     * @param {'low' | 'medium' | 'high'} [amlLevel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopupsApi
     */
    public getTopupPayments(order?: 'asc' | 'desc', offset?: number, limit?: number, id?: string, topupId?: string, address?: string, addressTo?: string, txId?: string, network?: NetworkCrypto, symbol?: SymbolCrypto, status?: 'pending' | 'confirmed' | 'failed', amlLevel?: 'low' | 'medium' | 'high', options?: any) {
        return TopupsApiFp(this.configuration).getTopupPayments(order, offset, limit, id, topupId, address, addressTo, txId, network, symbol, status, amlLevel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace the existing address with a new one
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopupsApi
     */
    public putTopupAddressReplace(id: string, options?: any) {
        return TopupsApiFp(this.configuration).putTopupAddressReplace(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TravelRuleApi - axios parameter creator
 * @export
 */
export const TravelRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all Virtual Asset Service Providers (VASPs) available in CryptoSwift
         * @summary List VASPs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelRuleVaspList: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/travel-rule/vasp-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TravelRuleApi - functional programming interface
 * @export
 */
export const TravelRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TravelRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all Virtual Asset Service Providers (VASPs) available in CryptoSwift
         * @summary List VASPs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTravelRuleVaspList(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTravelRuleVaspList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TravelRuleApi - factory interface
 * @export
 */
export const TravelRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TravelRuleApiFp(configuration)
    return {
        /**
         * Returns a list of all Virtual Asset Service Providers (VASPs) available in CryptoSwift
         * @summary List VASPs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTravelRuleVaspList(options?: any): AxiosPromise<Response & object> {
            return localVarFp.getTravelRuleVaspList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TravelRuleApi - object-oriented interface
 * @export
 * @class TravelRuleApi
 * @extends {BaseAPI}
 */
export class TravelRuleApi extends BaseAPI {
    /**
     * Returns a list of all Virtual Asset Service Providers (VASPs) available in CryptoSwift
     * @summary List VASPs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TravelRuleApi
     */
    public getTravelRuleVaspList(options?: any) {
        return TravelRuleApiFp(this.configuration).getTravelRuleVaspList(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WhitelistAddressesApi - axios parameter creator
 * @export
 */
export const WhitelistAddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new whitelist address
         * @param {InlineObject20} inlineObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelistAddress: async (inlineObject20: InlineObject20, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject20' is not null or undefined
            assertParamExists('createWhitelistAddress', 'inlineObject20', inlineObject20)
            const localVarPath = `/v2.0/merchant/whitelist-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject20, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete whitelist address
         * @param {string} id whitelist address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistAddress: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWhitelistAddress', 'id', id)
            const localVarPath = `/v2.0/merchant/whitelist-addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show whitelist address
         * @param {string} id whitelist address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistAddress: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWhitelistAddress', 'id', id)
            const localVarPath = `/v2.0/merchant/whitelist-addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all whitelist addresses
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [name] Filter by name
         * @param {string} [network] Filter by network
         * @param {string} [symbol] Filter by symbol
         * @param {string} [address] Filter by address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhitelistAddresses: async (order?: 'asc' | 'desc', offset?: number, limit?: number, name?: string, network?: string, symbol?: string, address?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/whitelist-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (symbol !== undefined) {
                localVarQueryParameter['symbol'] = symbol;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update whitelist address
         * @param {string} id whitelist address id
         * @param {InlineObject21} inlineObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelistAddress: async (id: string, inlineObject21: InlineObject21, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWhitelistAddress', 'id', id)
            // verify required parameter 'inlineObject21' is not null or undefined
            assertParamExists('updateWhitelistAddress', 'inlineObject21', inlineObject21)
            const localVarPath = `/v2.0/merchant/whitelist-addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject21, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhitelistAddressesApi - functional programming interface
 * @export
 */
export const WhitelistAddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhitelistAddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new whitelist address
         * @param {InlineObject20} inlineObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWhitelistAddress(inlineObject20: InlineObject20, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWhitelistAddress(inlineObject20, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete whitelist address
         * @param {string} id whitelist address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhitelistAddress(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhitelistAddress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Show whitelist address
         * @param {string} id whitelist address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhitelistAddress(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhitelistAddress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all whitelist addresses
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [name] Filter by name
         * @param {string} [network] Filter by network
         * @param {string} [symbol] Filter by symbol
         * @param {string} [address] Filter by address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWhitelistAddresses(order?: 'asc' | 'desc', offset?: number, limit?: number, name?: string, network?: string, symbol?: string, address?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWhitelistAddresses(order, offset, limit, name, network, symbol, address, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update whitelist address
         * @param {string} id whitelist address id
         * @param {InlineObject21} inlineObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWhitelistAddress(id: string, inlineObject21: InlineObject21, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWhitelistAddress(id, inlineObject21, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WhitelistAddressesApi - factory interface
 * @export
 */
export const WhitelistAddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhitelistAddressesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new whitelist address
         * @param {InlineObject20} inlineObject20 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelistAddress(inlineObject20: InlineObject20, options?: any): AxiosPromise<Response & object> {
            return localVarFp.createWhitelistAddress(inlineObject20, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete whitelist address
         * @param {string} id whitelist address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistAddress(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteWhitelistAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show whitelist address
         * @param {string} id whitelist address id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistAddress(id: string, options?: any): AxiosPromise<Response & object> {
            return localVarFp.getWhitelistAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all whitelist addresses
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [name] Filter by name
         * @param {string} [network] Filter by network
         * @param {string} [symbol] Filter by symbol
         * @param {string} [address] Filter by address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhitelistAddresses(order?: 'asc' | 'desc', offset?: number, limit?: number, name?: string, network?: string, symbol?: string, address?: string, options?: any): AxiosPromise<Response & object> {
            return localVarFp.listWhitelistAddresses(order, offset, limit, name, network, symbol, address, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update whitelist address
         * @param {string} id whitelist address id
         * @param {InlineObject21} inlineObject21 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelistAddress(id: string, inlineObject21: InlineObject21, options?: any): AxiosPromise<Response & object> {
            return localVarFp.updateWhitelistAddress(id, inlineObject21, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhitelistAddressesApi - object-oriented interface
 * @export
 * @class WhitelistAddressesApi
 * @extends {BaseAPI}
 */
export class WhitelistAddressesApi extends BaseAPI {
    /**
     * 
     * @summary Create new whitelist address
     * @param {InlineObject20} inlineObject20 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistAddressesApi
     */
    public createWhitelistAddress(inlineObject20: InlineObject20, options?: any) {
        return WhitelistAddressesApiFp(this.configuration).createWhitelistAddress(inlineObject20, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete whitelist address
     * @param {string} id whitelist address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistAddressesApi
     */
    public deleteWhitelistAddress(id: string, options?: any) {
        return WhitelistAddressesApiFp(this.configuration).deleteWhitelistAddress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show whitelist address
     * @param {string} id whitelist address id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistAddressesApi
     */
    public getWhitelistAddress(id: string, options?: any) {
        return WhitelistAddressesApiFp(this.configuration).getWhitelistAddress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all whitelist addresses
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [name] Filter by name
     * @param {string} [network] Filter by network
     * @param {string} [symbol] Filter by symbol
     * @param {string} [address] Filter by address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistAddressesApi
     */
    public listWhitelistAddresses(order?: 'asc' | 'desc', offset?: number, limit?: number, name?: string, network?: string, symbol?: string, address?: string, options?: any) {
        return WhitelistAddressesApiFp(this.configuration).listWhitelistAddresses(order, offset, limit, name, network, symbol, address, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update whitelist address
     * @param {string} id whitelist address id
     * @param {InlineObject21} inlineObject21 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistAddressesApi
     */
    public updateWhitelistAddress(id: string, inlineObject21: InlineObject21, options?: any) {
        return WhitelistAddressesApiFp(this.configuration).updateWhitelistAddress(id, inlineObject21, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WhitelistDomainsApi - axios parameter creator
 * @export
 */
export const WhitelistDomainsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new whitelist domain
         * @param {InlineObject22} inlineObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelistDomain: async (inlineObject22: InlineObject22, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject22' is not null or undefined
            assertParamExists('createWhitelistDomain', 'inlineObject22', inlineObject22)
            const localVarPath = `/v2.0/merchant/whitelist-domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject22, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete whitelist domain
         * @param {string} id whitelist domain id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistDomain: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWhitelistDomain', 'id', id)
            const localVarPath = `/v2.0/merchant/whitelist-domains/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all whitelist domains
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhitelistDomains: async (order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/whitelist-domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhitelistDomainsApi - functional programming interface
 * @export
 */
export const WhitelistDomainsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhitelistDomainsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new whitelist domain
         * @param {InlineObject22} inlineObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWhitelistDomain(inlineObject22: InlineObject22, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWhitelistDomain(inlineObject22, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete whitelist domain
         * @param {string} id whitelist domain id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhitelistDomain(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhitelistDomain(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all whitelist domains
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWhitelistDomains(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWhitelistDomains(order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WhitelistDomainsApi - factory interface
 * @export
 */
export const WhitelistDomainsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhitelistDomainsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new whitelist domain
         * @param {InlineObject22} inlineObject22 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelistDomain(inlineObject22: InlineObject22, options?: any): AxiosPromise<Response & object> {
            return localVarFp.createWhitelistDomain(inlineObject22, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete whitelist domain
         * @param {string} id whitelist domain id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistDomain(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteWhitelistDomain(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all whitelist domains
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhitelistDomains(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<Response & object> {
            return localVarFp.listWhitelistDomains(order, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhitelistDomainsApi - object-oriented interface
 * @export
 * @class WhitelistDomainsApi
 * @extends {BaseAPI}
 */
export class WhitelistDomainsApi extends BaseAPI {
    /**
     * 
     * @summary Create new whitelist domain
     * @param {InlineObject22} inlineObject22 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistDomainsApi
     */
    public createWhitelistDomain(inlineObject22: InlineObject22, options?: any) {
        return WhitelistDomainsApiFp(this.configuration).createWhitelistDomain(inlineObject22, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete whitelist domain
     * @param {string} id whitelist domain id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistDomainsApi
     */
    public deleteWhitelistDomain(id: string, options?: any) {
        return WhitelistDomainsApiFp(this.configuration).deleteWhitelistDomain(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all whitelist domains
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistDomainsApi
     */
    public listWhitelistDomains(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return WhitelistDomainsApiFp(this.configuration).listWhitelistDomains(order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WhitelistIPsApi - axios parameter creator
 * @export
 */
export const WhitelistIPsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new whitelisted ip address
         * @param {InlineObject23} inlineObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelistIpAddress: async (inlineObject23: InlineObject23, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject23' is not null or undefined
            assertParamExists('createWhitelistIpAddress', 'inlineObject23', inlineObject23)
            const localVarPath = `/v2.0/merchant/whitelist-ips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject23, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete whitelisted IP address
         * @param {string} id ID of whitelist IP address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistIpAddress: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWhitelistIpAddress', 'id', id)
            const localVarPath = `/v2.0/merchant/whitelist-ips/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show whitelisted IP address
         * @param {string} id ID of whitelisted IP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistIpAddress: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWhitelistIpAddress', 'id', id)
            const localVarPath = `/v2.0/merchant/whitelist-ips/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all whitelisted IP addresses
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhitelistIpAddresses: async (order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/merchant/whitelist-ips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update whitelisted IP address
         * @param {string} id ID of whitelisted IP
         * @param {InlineObject24} inlineObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelistIpAddress: async (id: string, inlineObject24: InlineObject24, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWhitelistIpAddress', 'id', id)
            // verify required parameter 'inlineObject24' is not null or undefined
            assertParamExists('updateWhitelistIpAddress', 'inlineObject24', inlineObject24)
            const localVarPath = `/v2.0/merchant/whitelist-ips/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject24, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhitelistIPsApi - functional programming interface
 * @export
 */
export const WhitelistIPsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhitelistIPsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new whitelisted ip address
         * @param {InlineObject23} inlineObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWhitelistIpAddress(inlineObject23: InlineObject23, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWhitelistIpAddress(inlineObject23, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete whitelisted IP address
         * @param {string} id ID of whitelist IP address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhitelistIpAddress(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhitelistIpAddress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Show whitelisted IP address
         * @param {string} id ID of whitelisted IP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhitelistIpAddress(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhitelistIpAddress(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all whitelisted IP addresses
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWhitelistIpAddresses(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWhitelistIpAddresses(order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update whitelisted IP address
         * @param {string} id ID of whitelisted IP
         * @param {InlineObject24} inlineObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWhitelistIpAddress(id: string, inlineObject24: InlineObject24, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWhitelistIpAddress(id, inlineObject24, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WhitelistIPsApi - factory interface
 * @export
 */
export const WhitelistIPsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhitelistIPsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new whitelisted ip address
         * @param {InlineObject23} inlineObject23 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWhitelistIpAddress(inlineObject23: InlineObject23, options?: any): AxiosPromise<Response & object> {
            return localVarFp.createWhitelistIpAddress(inlineObject23, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete whitelisted IP address
         * @param {string} id ID of whitelist IP address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhitelistIpAddress(id: string, options?: any): AxiosPromise<Response> {
            return localVarFp.deleteWhitelistIpAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show whitelisted IP address
         * @param {string} id ID of whitelisted IP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistIpAddress(id: string, options?: any): AxiosPromise<Response & object> {
            return localVarFp.getWhitelistIpAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all whitelisted IP addresses
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhitelistIpAddresses(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<Response & object> {
            return localVarFp.listWhitelistIpAddresses(order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update whitelisted IP address
         * @param {string} id ID of whitelisted IP
         * @param {InlineObject24} inlineObject24 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelistIpAddress(id: string, inlineObject24: InlineObject24, options?: any): AxiosPromise<Response & object> {
            return localVarFp.updateWhitelistIpAddress(id, inlineObject24, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhitelistIPsApi - object-oriented interface
 * @export
 * @class WhitelistIPsApi
 * @extends {BaseAPI}
 */
export class WhitelistIPsApi extends BaseAPI {
    /**
     * 
     * @summary Create new whitelisted ip address
     * @param {InlineObject23} inlineObject23 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistIPsApi
     */
    public createWhitelistIpAddress(inlineObject23: InlineObject23, options?: any) {
        return WhitelistIPsApiFp(this.configuration).createWhitelistIpAddress(inlineObject23, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete whitelisted IP address
     * @param {string} id ID of whitelist IP address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistIPsApi
     */
    public deleteWhitelistIpAddress(id: string, options?: any) {
        return WhitelistIPsApiFp(this.configuration).deleteWhitelistIpAddress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show whitelisted IP address
     * @param {string} id ID of whitelisted IP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistIPsApi
     */
    public getWhitelistIpAddress(id: string, options?: any) {
        return WhitelistIPsApiFp(this.configuration).getWhitelistIpAddress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all whitelisted IP addresses
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistIPsApi
     */
    public listWhitelistIpAddresses(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return WhitelistIPsApiFp(this.configuration).listWhitelistIpAddresses(order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update whitelisted IP address
     * @param {string} id ID of whitelisted IP
     * @param {InlineObject24} inlineObject24 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhitelistIPsApi
     */
    public updateWhitelistIpAddress(id: string, inlineObject24: InlineObject24, options?: any) {
        return WhitelistIPsApiFp(this.configuration).updateWhitelistIpAddress(id, inlineObject24, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WidgetAPIApi - axios parameter creator
 * @export
 */
export const WidgetAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Widget Auth
         * @summary Widget Auth
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetAuthRequest} widgetAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetAuth: async (xWidgetId: string, widgetAuthRequest: WidgetAuthRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetAuth', 'xWidgetId', xWidgetId)
            // verify required parameter 'widgetAuthRequest' is not null or undefined
            assertParamExists('widgetAuth', 'widgetAuthRequest', widgetAuthRequest)
            const localVarPath = `/v2.0/widget/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Auth
         * @summary (Re)Send Auth code
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetAuthCodeRequest} widgetAuthCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetAuthCode: async (xWidgetId: string, widgetAuthCodeRequest: WidgetAuthCodeRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetAuthCode', 'xWidgetId', xWidgetId)
            // verify required parameter 'widgetAuthCodeRequest' is not null or undefined
            assertParamExists('widgetAuthCode', 'widgetAuthCodeRequest', widgetAuthCodeRequest)
            const localVarPath = `/v2.0/widget/auth/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetAuthCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh Auth token
         * @summary Refresh Auth token
         * @param {string} xWidgetId WidgetID header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetAuthRefreshToken: async (xWidgetId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetAuthRefreshToken', 'xWidgetId', xWidgetId)
            const localVarPath = `/v2.0/widget/auth/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WidgetAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-widget-token", configuration)

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Widget buy
         * @summary Create a transaction
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetBuyRequest} widgetBuyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetBuy: async (xWidgetId: string, widgetBuyRequest: WidgetBuyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetBuy', 'xWidgetId', xWidgetId)
            // verify required parameter 'widgetBuyRequest' is not null or undefined
            assertParamExists('widgetBuy', 'widgetBuyRequest', widgetBuyRequest)
            const localVarPath = `/v2.0/widget/buy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WidgetAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-widget-token", configuration)

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetBuyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get final Widget rates and buy-token.
         * @summary Get final Widget rates and buy-token.
         * @param {string} xWidgetId WidgetID header
         * @param {string} symbolFrom Fiat symbol to sell
         * @param {string} symbolTo Cryptocurrency symbol to buy
         * @param {string} networkTo Cryptocurrency network
         * @param {string} [amountFrom] The total amount, including fees, to be converted into cryptocurrency, required if \&#39;amount_to\&#39; empty
         * @param {string} [amountTo] The total amount, including fees, to be received in cryptocurrency, required if \&#39;amount_from\&#39; empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetBuyRates: async (xWidgetId: string, symbolFrom: string, symbolTo: string, networkTo: string, amountFrom?: string, amountTo?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetBuyRates', 'xWidgetId', xWidgetId)
            // verify required parameter 'symbolFrom' is not null or undefined
            assertParamExists('widgetBuyRates', 'symbolFrom', symbolFrom)
            // verify required parameter 'symbolTo' is not null or undefined
            assertParamExists('widgetBuyRates', 'symbolTo', symbolTo)
            // verify required parameter 'networkTo' is not null or undefined
            assertParamExists('widgetBuyRates', 'networkTo', networkTo)
            const localVarPath = `/v2.0/widget/buy-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WidgetAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-widget-token", configuration)

            if (symbolFrom !== undefined) {
                localVarQueryParameter['symbol_from'] = symbolFrom;
            }

            if (symbolTo !== undefined) {
                localVarQueryParameter['symbol_to'] = symbolTo;
            }

            if (networkTo !== undefined) {
                localVarQueryParameter['network_to'] = networkTo;
            }

            if (amountFrom !== undefined) {
                localVarQueryParameter['amount_from'] = amountFrom;
            }

            if (amountTo !== undefined) {
                localVarQueryParameter['amount_to'] = amountTo;
            }

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of widget currencies
         * @summary Get list of widget currencies
         * @param {string} xWidgetId WidgetID header
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {'fiat' | 'crypto'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetCurrencies: async (xWidgetId: string, order?: 'asc' | 'desc', type?: 'fiat' | 'crypto', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetCurrencies', 'xWidgetId', xWidgetId)
            const localVarPath = `/v2.0/widget/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get transaction details
         * @summary Get transaction details
         * @param {string} xWidgetId WidgetID header
         * @param {string} id ID of transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetGetTransaction: async (xWidgetId: string, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetGetTransaction', 'xWidgetId', xWidgetId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('widgetGetTransaction', 'id', id)
            const localVarPath = `/v2.0/widget/transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WidgetAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-widget-token", configuration)

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get kyc status
         * @summary Get kyc status
         * @param {string} xWidgetId WidgetID header
         * @param {'light' | 'dark'} [scheme] Color scheme for KYC redirect link (Default \&#39;light\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetKyc: async (xWidgetId: string, scheme?: 'light' | 'dark', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetKyc', 'xWidgetId', xWidgetId)
            const localVarPath = `/v2.0/widget/kyc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WidgetAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-widget-token", configuration)

            if (scheme !== undefined) {
                localVarQueryParameter['scheme'] = scheme;
            }

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get limits
         * @summary Get limits
         * @param {string} xWidgetId WidgetID header
         * @param {'fiat'} networkFrom Network to convert from.
         * @param {string} symbolFrom Currency to convert from.
         * @param {string} networkTo Network to convert to.
         * @param {string} symbolTo Currency to convert to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetLimits: async (xWidgetId: string, networkFrom: 'fiat', symbolFrom: string, networkTo: string, symbolTo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetLimits', 'xWidgetId', xWidgetId)
            // verify required parameter 'networkFrom' is not null or undefined
            assertParamExists('widgetLimits', 'networkFrom', networkFrom)
            // verify required parameter 'symbolFrom' is not null or undefined
            assertParamExists('widgetLimits', 'symbolFrom', symbolFrom)
            // verify required parameter 'networkTo' is not null or undefined
            assertParamExists('widgetLimits', 'networkTo', networkTo)
            // verify required parameter 'symbolTo' is not null or undefined
            assertParamExists('widgetLimits', 'symbolTo', symbolTo)
            const localVarPath = `/v2.0/widget/limits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WidgetAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-widget-token", configuration)

            if (networkFrom !== undefined) {
                localVarQueryParameter['network_from'] = networkFrom;
            }

            if (symbolFrom !== undefined) {
                localVarQueryParameter['symbol_from'] = symbolFrom;
            }

            if (networkTo !== undefined) {
                localVarQueryParameter['network_to'] = networkTo;
            }

            if (symbolTo !== undefined) {
                localVarQueryParameter['symbol_to'] = symbolTo;
            }

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get limits for unverified users
         * @summary Get limits for unverified users
         * @param {string} xWidgetId WidgetID header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetLimitsUnverified: async (xWidgetId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'xWidgetId' is not null or undefined
            assertParamExists('widgetLimitsUnverified', 'xWidgetId', xWidgetId)
            const localVarPath = `/v2.0/widget/limits/unverified`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication WidgetAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-widget-token", configuration)

            if (xWidgetId !== undefined && xWidgetId !== null) {
                localVarHeaderParameter['x-widget-id'] = String(JSON.stringify(xWidgetId));
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetAPIApi - functional programming interface
 * @export
 */
export const WidgetAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WidgetAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Widget Auth
         * @summary Widget Auth
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetAuthRequest} widgetAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetAuth(xWidgetId: string, widgetAuthRequest: WidgetAuthRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20058>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetAuth(xWidgetId, widgetAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Auth
         * @summary (Re)Send Auth code
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetAuthCodeRequest} widgetAuthCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetAuthCode(xWidgetId: string, widgetAuthCodeRequest: WidgetAuthCodeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20057>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetAuthCode(xWidgetId, widgetAuthCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refresh Auth token
         * @summary Refresh Auth token
         * @param {string} xWidgetId WidgetID header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetAuthRefreshToken(xWidgetId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20062>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetAuthRefreshToken(xWidgetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Widget buy
         * @summary Create a transaction
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetBuyRequest} widgetBuyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetBuy(xWidgetId: string, widgetBuyRequest: WidgetBuyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20064>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetBuy(xWidgetId, widgetBuyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get final Widget rates and buy-token.
         * @summary Get final Widget rates and buy-token.
         * @param {string} xWidgetId WidgetID header
         * @param {string} symbolFrom Fiat symbol to sell
         * @param {string} symbolTo Cryptocurrency symbol to buy
         * @param {string} networkTo Cryptocurrency network
         * @param {string} [amountFrom] The total amount, including fees, to be converted into cryptocurrency, required if \&#39;amount_to\&#39; empty
         * @param {string} [amountTo] The total amount, including fees, to be received in cryptocurrency, required if \&#39;amount_from\&#39; empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetBuyRates(xWidgetId: string, symbolFrom: string, symbolTo: string, networkTo: string, amountFrom?: string, amountTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20063>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetBuyRates(xWidgetId, symbolFrom, symbolTo, networkTo, amountFrom, amountTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of widget currencies
         * @summary Get list of widget currencies
         * @param {string} xWidgetId WidgetID header
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {'fiat' | 'crypto'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetCurrencies(xWidgetId: string, order?: 'asc' | 'desc', type?: 'fiat' | 'crypto', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20061>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetCurrencies(xWidgetId, order, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get transaction details
         * @summary Get transaction details
         * @param {string} xWidgetId WidgetID header
         * @param {string} id ID of transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetGetTransaction(xWidgetId: string, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20065>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetGetTransaction(xWidgetId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get kyc status
         * @summary Get kyc status
         * @param {string} xWidgetId WidgetID header
         * @param {'light' | 'dark'} [scheme] Color scheme for KYC redirect link (Default \&#39;light\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetKyc(xWidgetId: string, scheme?: 'light' | 'dark', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20068>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetKyc(xWidgetId, scheme, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get limits
         * @summary Get limits
         * @param {string} xWidgetId WidgetID header
         * @param {'fiat'} networkFrom Network to convert from.
         * @param {string} symbolFrom Currency to convert from.
         * @param {string} networkTo Network to convert to.
         * @param {string} symbolTo Currency to convert to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetLimits(xWidgetId: string, networkFrom: 'fiat', symbolFrom: string, networkTo: string, symbolTo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20059>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetLimits(xWidgetId, networkFrom, symbolFrom, networkTo, symbolTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get limits for unverified users
         * @summary Get limits for unverified users
         * @param {string} xWidgetId WidgetID header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async widgetLimitsUnverified(xWidgetId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20060>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.widgetLimitsUnverified(xWidgetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WidgetAPIApi - factory interface
 * @export
 */
export const WidgetAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WidgetAPIApiFp(configuration)
    return {
        /**
         * Widget Auth
         * @summary Widget Auth
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetAuthRequest} widgetAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetAuth(xWidgetId: string, widgetAuthRequest: WidgetAuthRequest, options?: any): AxiosPromise<InlineResponse20058> {
            return localVarFp.widgetAuth(xWidgetId, widgetAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Auth
         * @summary (Re)Send Auth code
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetAuthCodeRequest} widgetAuthCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetAuthCode(xWidgetId: string, widgetAuthCodeRequest: WidgetAuthCodeRequest, options?: any): AxiosPromise<InlineResponse20057> {
            return localVarFp.widgetAuthCode(xWidgetId, widgetAuthCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh Auth token
         * @summary Refresh Auth token
         * @param {string} xWidgetId WidgetID header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetAuthRefreshToken(xWidgetId: string, options?: any): AxiosPromise<InlineResponse20062> {
            return localVarFp.widgetAuthRefreshToken(xWidgetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Widget buy
         * @summary Create a transaction
         * @param {string} xWidgetId WidgetID header
         * @param {WidgetBuyRequest} widgetBuyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetBuy(xWidgetId: string, widgetBuyRequest: WidgetBuyRequest, options?: any): AxiosPromise<InlineResponse20064> {
            return localVarFp.widgetBuy(xWidgetId, widgetBuyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get final Widget rates and buy-token.
         * @summary Get final Widget rates and buy-token.
         * @param {string} xWidgetId WidgetID header
         * @param {string} symbolFrom Fiat symbol to sell
         * @param {string} symbolTo Cryptocurrency symbol to buy
         * @param {string} networkTo Cryptocurrency network
         * @param {string} [amountFrom] The total amount, including fees, to be converted into cryptocurrency, required if \&#39;amount_to\&#39; empty
         * @param {string} [amountTo] The total amount, including fees, to be received in cryptocurrency, required if \&#39;amount_from\&#39; empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetBuyRates(xWidgetId: string, symbolFrom: string, symbolTo: string, networkTo: string, amountFrom?: string, amountTo?: string, options?: any): AxiosPromise<InlineResponse20063> {
            return localVarFp.widgetBuyRates(xWidgetId, symbolFrom, symbolTo, networkTo, amountFrom, amountTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of widget currencies
         * @summary Get list of widget currencies
         * @param {string} xWidgetId WidgetID header
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {'fiat' | 'crypto'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetCurrencies(xWidgetId: string, order?: 'asc' | 'desc', type?: 'fiat' | 'crypto', options?: any): AxiosPromise<InlineResponse20061> {
            return localVarFp.widgetCurrencies(xWidgetId, order, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get transaction details
         * @summary Get transaction details
         * @param {string} xWidgetId WidgetID header
         * @param {string} id ID of transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetGetTransaction(xWidgetId: string, id: string, options?: any): AxiosPromise<InlineResponse20065> {
            return localVarFp.widgetGetTransaction(xWidgetId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get kyc status
         * @summary Get kyc status
         * @param {string} xWidgetId WidgetID header
         * @param {'light' | 'dark'} [scheme] Color scheme for KYC redirect link (Default \&#39;light\&#39;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetKyc(xWidgetId: string, scheme?: 'light' | 'dark', options?: any): AxiosPromise<InlineResponse20068> {
            return localVarFp.widgetKyc(xWidgetId, scheme, options).then((request) => request(axios, basePath));
        },
        /**
         * Get limits
         * @summary Get limits
         * @param {string} xWidgetId WidgetID header
         * @param {'fiat'} networkFrom Network to convert from.
         * @param {string} symbolFrom Currency to convert from.
         * @param {string} networkTo Network to convert to.
         * @param {string} symbolTo Currency to convert to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetLimits(xWidgetId: string, networkFrom: 'fiat', symbolFrom: string, networkTo: string, symbolTo: string, options?: any): AxiosPromise<InlineResponse20059> {
            return localVarFp.widgetLimits(xWidgetId, networkFrom, symbolFrom, networkTo, symbolTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Get limits for unverified users
         * @summary Get limits for unverified users
         * @param {string} xWidgetId WidgetID header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetLimitsUnverified(xWidgetId: string, options?: any): AxiosPromise<InlineResponse20060> {
            return localVarFp.widgetLimitsUnverified(xWidgetId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WidgetAPIApi - object-oriented interface
 * @export
 * @class WidgetAPIApi
 * @extends {BaseAPI}
 */
export class WidgetAPIApi extends BaseAPI {
    /**
     * Widget Auth
     * @summary Widget Auth
     * @param {string} xWidgetId WidgetID header
     * @param {WidgetAuthRequest} widgetAuthRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetAuth(xWidgetId: string, widgetAuthRequest: WidgetAuthRequest, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetAuth(xWidgetId, widgetAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Auth
     * @summary (Re)Send Auth code
     * @param {string} xWidgetId WidgetID header
     * @param {WidgetAuthCodeRequest} widgetAuthCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetAuthCode(xWidgetId: string, widgetAuthCodeRequest: WidgetAuthCodeRequest, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetAuthCode(xWidgetId, widgetAuthCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh Auth token
     * @summary Refresh Auth token
     * @param {string} xWidgetId WidgetID header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetAuthRefreshToken(xWidgetId: string, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetAuthRefreshToken(xWidgetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Widget buy
     * @summary Create a transaction
     * @param {string} xWidgetId WidgetID header
     * @param {WidgetBuyRequest} widgetBuyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetBuy(xWidgetId: string, widgetBuyRequest: WidgetBuyRequest, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetBuy(xWidgetId, widgetBuyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get final Widget rates and buy-token.
     * @summary Get final Widget rates and buy-token.
     * @param {string} xWidgetId WidgetID header
     * @param {string} symbolFrom Fiat symbol to sell
     * @param {string} symbolTo Cryptocurrency symbol to buy
     * @param {string} networkTo Cryptocurrency network
     * @param {string} [amountFrom] The total amount, including fees, to be converted into cryptocurrency, required if \&#39;amount_to\&#39; empty
     * @param {string} [amountTo] The total amount, including fees, to be received in cryptocurrency, required if \&#39;amount_from\&#39; empty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetBuyRates(xWidgetId: string, symbolFrom: string, symbolTo: string, networkTo: string, amountFrom?: string, amountTo?: string, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetBuyRates(xWidgetId, symbolFrom, symbolTo, networkTo, amountFrom, amountTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of widget currencies
     * @summary Get list of widget currencies
     * @param {string} xWidgetId WidgetID header
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {'fiat' | 'crypto'} [type] Filter by currency type (&#x60;fiat&#x60; or &#x60;crypto&#x60;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetCurrencies(xWidgetId: string, order?: 'asc' | 'desc', type?: 'fiat' | 'crypto', options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetCurrencies(xWidgetId, order, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get transaction details
     * @summary Get transaction details
     * @param {string} xWidgetId WidgetID header
     * @param {string} id ID of transaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetGetTransaction(xWidgetId: string, id: string, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetGetTransaction(xWidgetId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get kyc status
     * @summary Get kyc status
     * @param {string} xWidgetId WidgetID header
     * @param {'light' | 'dark'} [scheme] Color scheme for KYC redirect link (Default \&#39;light\&#39;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetKyc(xWidgetId: string, scheme?: 'light' | 'dark', options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetKyc(xWidgetId, scheme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get limits
     * @summary Get limits
     * @param {string} xWidgetId WidgetID header
     * @param {'fiat'} networkFrom Network to convert from.
     * @param {string} symbolFrom Currency to convert from.
     * @param {string} networkTo Network to convert to.
     * @param {string} symbolTo Currency to convert to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetLimits(xWidgetId: string, networkFrom: 'fiat', symbolFrom: string, networkTo: string, symbolTo: string, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetLimits(xWidgetId, networkFrom, symbolFrom, networkTo, symbolTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get limits for unverified users
     * @summary Get limits for unverified users
     * @param {string} xWidgetId WidgetID header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetAPIApi
     */
    public widgetLimitsUnverified(xWidgetId: string, options?: any) {
        return WidgetAPIApiFp(this.configuration).widgetLimitsUnverified(xWidgetId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WidgetsApi - axios parameter creator
 * @export
 */
export const WidgetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new widget
         * @summary Create a widget
         * @param {WidgetCreate} widgetCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidget: async (widgetCreate: WidgetCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'widgetCreate' is not null or undefined
            assertParamExists('createWidget', 'widgetCreate', widgetCreate)
            const localVarPath = `/v2.0/widgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a widget
         * @summary Delete a widget
         * @param {string} id ID of widget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidget: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWidget', 'id', id)
            const localVarPath = `/v2.0/widgets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a single widget
         * @summary Show a widget
         * @param {string} id ID of widget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidget: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWidget', 'id', id)
            const localVarPath = `/v2.0/widgets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a widget transactions list
         * @summary Show a widget transactions list
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [widgetId] Filter by Widget ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetTransactions: async (order?: 'asc' | 'desc', offset?: number, limit?: number, widgetId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/widgets/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (widgetId !== undefined) {
                localVarQueryParameter['widget_id'] = widgetId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all widgets
         * @summary List widgets
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgets: async (order?: 'asc' | 'desc', offset?: number, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/widgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a widget
         * @summary Update a widget
         * @param {string} id ID of widget
         * @param {WidgetUpdate} widgetUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidget: async (id: string, widgetUpdate: WidgetUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWidget', 'id', id)
            // verify required parameter 'widgetUpdate' is not null or undefined
            assertParamExists('updateWidget', 'widgetUpdate', widgetUpdate)
            const localVarPath = `/v2.0/widgets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(widgetUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WidgetsApi - functional programming interface
 * @export
 */
export const WidgetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WidgetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new widget
         * @summary Create a widget
         * @param {WidgetCreate} widgetCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWidget(widgetCreate: WidgetCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20055>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWidget(widgetCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a widget
         * @summary Delete a widget
         * @param {string} id ID of widget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWidget(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWidget(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a single widget
         * @summary Show a widget
         * @param {string} id ID of widget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidget(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20055>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidget(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a widget transactions list
         * @summary Show a widget transactions list
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [widgetId] Filter by Widget ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetTransactions(order?: 'asc' | 'desc', offset?: number, limit?: number, widgetId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20056>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetTransactions(order, offset, limit, widgetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all widgets
         * @summary List widgets
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgets(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20054>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgets(order, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a widget
         * @summary Update a widget
         * @param {string} id ID of widget
         * @param {WidgetUpdate} widgetUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWidget(id: string, widgetUpdate: WidgetUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWidget(id, widgetUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WidgetsApi - factory interface
 * @export
 */
export const WidgetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WidgetsApiFp(configuration)
    return {
        /**
         * Create a new widget
         * @summary Create a widget
         * @param {WidgetCreate} widgetCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidget(widgetCreate: WidgetCreate, options?: any): AxiosPromise<InlineResponse20055> {
            return localVarFp.createWidget(widgetCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a widget
         * @summary Delete a widget
         * @param {string} id ID of widget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWidget(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWidget(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a single widget
         * @summary Show a widget
         * @param {string} id ID of widget
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidget(id: string, options?: any): AxiosPromise<InlineResponse20055> {
            return localVarFp.getWidget(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a widget transactions list
         * @summary Show a widget transactions list
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [widgetId] Filter by Widget ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetTransactions(order?: 'asc' | 'desc', offset?: number, limit?: number, widgetId?: string, options?: any): AxiosPromise<InlineResponse20056> {
            return localVarFp.getWidgetTransactions(order, offset, limit, widgetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all widgets
         * @summary List widgets
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgets(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any): AxiosPromise<InlineResponse20054> {
            return localVarFp.getWidgets(order, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a widget
         * @summary Update a widget
         * @param {string} id ID of widget
         * @param {WidgetUpdate} widgetUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidget(id: string, widgetUpdate: WidgetUpdate, options?: any): AxiosPromise<WidgetResponse> {
            return localVarFp.updateWidget(id, widgetUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WidgetsApi - object-oriented interface
 * @export
 * @class WidgetsApi
 * @extends {BaseAPI}
 */
export class WidgetsApi extends BaseAPI {
    /**
     * Create a new widget
     * @summary Create a widget
     * @param {WidgetCreate} widgetCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public createWidget(widgetCreate: WidgetCreate, options?: any) {
        return WidgetsApiFp(this.configuration).createWidget(widgetCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a widget
     * @summary Delete a widget
     * @param {string} id ID of widget
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public deleteWidget(id: string, options?: any) {
        return WidgetsApiFp(this.configuration).deleteWidget(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a single widget
     * @summary Show a widget
     * @param {string} id ID of widget
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public getWidget(id: string, options?: any) {
        return WidgetsApiFp(this.configuration).getWidget(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a widget transactions list
     * @summary Show a widget transactions list
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [widgetId] Filter by Widget ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public getWidgetTransactions(order?: 'asc' | 'desc', offset?: number, limit?: number, widgetId?: string, options?: any) {
        return WidgetsApiFp(this.configuration).getWidgetTransactions(order, offset, limit, widgetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all widgets
     * @summary List widgets
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public getWidgets(order?: 'asc' | 'desc', offset?: number, limit?: number, options?: any) {
        return WidgetsApiFp(this.configuration).getWidgets(order, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a widget
     * @summary Update a widget
     * @param {string} id ID of widget
     * @param {WidgetUpdate} widgetUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    public updateWidget(id: string, widgetUpdate: WidgetUpdate, options?: any) {
        return WidgetsApiFp(this.configuration).updateWidget(id, widgetUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WithdrawalsApi - axios parameter creator
 * @export
 */
export const WithdrawalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a withdrawal
         * @summary Create a withdrawal
         * @param {WithdrawalCreate} withdrawalCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdrawal: async (withdrawalCreate: WithdrawalCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'withdrawalCreate' is not null or undefined
            assertParamExists('createWithdrawal', 'withdrawalCreate', withdrawalCreate)
            const localVarPath = `/v2.0/withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(withdrawalCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a single withdrawal
         * @summary Show a withdrawal
         * @param {string} id ID of withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawal: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWithdrawal', 'id', id)
            const localVarPath = `/v2.0/withdrawals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of withdrawals
         * @summary List of withdrawals
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWithdrawals: async (order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2.0/withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CookieAuth required

            // authentication SessionAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Session-Token", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (createdAtFrom !== undefined) {
                localVarQueryParameter['created_at_from'] = (createdAtFrom as any instanceof Date) ?
                    (createdAtFrom as any).toISOString() :
                    createdAtFrom;
            }

            if (createdAtTo !== undefined) {
                localVarQueryParameter['created_at_to'] = (createdAtTo as any instanceof Date) ?
                    (createdAtTo as any).toISOString() :
                    createdAtTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WithdrawalsApi - functional programming interface
 * @export
 */
export const WithdrawalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WithdrawalsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a withdrawal
         * @summary Create a withdrawal
         * @param {WithdrawalCreate} withdrawalCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithdrawal(withdrawalCreate: WithdrawalCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20042>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithdrawal(withdrawalCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a single withdrawal
         * @summary Show a withdrawal
         * @param {string} id ID of withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWithdrawal(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20042>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWithdrawal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of withdrawals
         * @summary List of withdrawals
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWithdrawals(order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20041>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWithdrawals(order, offset, limit, externalId, createdAtFrom, createdAtTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WithdrawalsApi - factory interface
 * @export
 */
export const WithdrawalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WithdrawalsApiFp(configuration)
    return {
        /**
         * Create a withdrawal
         * @summary Create a withdrawal
         * @param {WithdrawalCreate} withdrawalCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdrawal(withdrawalCreate: WithdrawalCreate, options?: any): AxiosPromise<InlineResponse20042> {
            return localVarFp.createWithdrawal(withdrawalCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a single withdrawal
         * @summary Show a withdrawal
         * @param {string} id ID of withdrawal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawal(id: string, options?: any): AxiosPromise<InlineResponse20042> {
            return localVarFp.getWithdrawal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List of withdrawals
         * @summary List of withdrawals
         * @param {'asc' | 'desc'} [order] Sort order
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
         * @param {string} [externalId] External ID
         * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
         * @param {string} [createdAtTo] CreatedAt to value (exclusive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWithdrawals(order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, options?: any): AxiosPromise<InlineResponse20041> {
            return localVarFp.listWithdrawals(order, offset, limit, externalId, createdAtFrom, createdAtTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WithdrawalsApi - object-oriented interface
 * @export
 * @class WithdrawalsApi
 * @extends {BaseAPI}
 */
export class WithdrawalsApi extends BaseAPI {
    /**
     * Create a withdrawal
     * @summary Create a withdrawal
     * @param {WithdrawalCreate} withdrawalCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    public createWithdrawal(withdrawalCreate: WithdrawalCreate, options?: any) {
        return WithdrawalsApiFp(this.configuration).createWithdrawal(withdrawalCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a single withdrawal
     * @summary Show a withdrawal
     * @param {string} id ID of withdrawal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    public getWithdrawal(id: string, options?: any) {
        return WithdrawalsApiFp(this.configuration).getWithdrawal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of withdrawals
     * @summary List of withdrawals
     * @param {'asc' | 'desc'} [order] Sort order
     * @param {number} [offset] The number of items to skip before starting to collect the result set.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 100.
     * @param {string} [externalId] External ID
     * @param {string} [createdAtFrom] CreatedAt from value (inclusive)
     * @param {string} [createdAtTo] CreatedAt to value (exclusive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    public listWithdrawals(order?: 'asc' | 'desc', offset?: number, limit?: number, externalId?: string, createdAtFrom?: string, createdAtTo?: string, options?: any) {
        return WithdrawalsApiFp(this.configuration).listWithdrawals(order, offset, limit, externalId, createdAtFrom, createdAtTo, options).then((request) => request(this.axios, this.basePath));
    }
}


